{
  "app": {
    "app": "app",
    "Please_upload_valid_file_We_supported_file_types_are_JPG_PNG_JPEG_PDF_WORD": "Please upload a file type that we support. The supported file types are JPG, PNG, JPEG, PDF & WORD.",
    "Please_upload_valid_file_We_supported_file_types_are_IMAGE_PDF_TXT_XLSX_WORD": "Please upload a file type that we support. The supported file types are JPG, PNG, JPEG, PDF & WORD.",
    "Signed": "Signed",
    "Document in progress": "Document is in preparation",
    "Sent for signing": "Sent for signing",
    "Mail not sent": "Mail not sent",
    "Partially_signed": "Partially signed",
    "Not_Sent": "Not sent",
    "Error": "Error",
    "Click_to_see_more": "Click to see more",
    "All": "All",
    "DUPLICATE_KBO_NUMBER": "This CBE number is already used with another customer ",
    "Submitted": "Completed",
    "Completed": "Completed",
    "Action_required": "Action required",
    "Type_and_press_Enter": "Type and press enter",
    "Add_more": "Add more...",
    "Select_labels": "Select labels",
    "USER_MISMATCH": "User Mismatch",
    "No_results": "No Results",
    "Copied": "Copied",
    "Select_one": "Select one"
  },
  "contract-download": {
    "You_will_be_redirected_to_dashborad_after_5_seconds_or": "You will be redirected to dashboard after 5 seconds or",
    "redirect": "redirect",
    "now": "now",
    "Your_contract_is_downloading": "Your document is downloading",
    "Contract_not_found_for_download": "Document not found"
  },
  "loader": {
    "Loading": "Loading..."
  },
  "login": {
    "123456": "123456",
    "Login": "Login",
    "Enter_Username": "Enter Username",
    "_": "* * * * * * * ",
    "User_is_Not_Registered": "User is Not Registered",
    "Invalid_Email_id": "Invalid Email id",
    "Invalid_User_or_Password": "Invalid User or Password",
    "Something_Went_Wrong": "Something Went Wrong",
    "Forgot_Password": "Forgot Password",
    "Enter_your_email_to_Retrieve_your_account": "Enter your email to Retrieve your account",
    "Email": "Email address",
    "Send_Password": "Send Password",
    "Try_again_after_some_time": "Try again after some time",
    "Back_to_login": "Back to login",
    "Change_Password": "Change Password",
    "Enter_New_Password": "Enter New Password",
    "Confirm_Password": "Confirm Password",
    "Submit": "Submit",
    "Password_must_contain_a_lower_character_a_upper_character_adigit_and_a_special_character_and_length_must_be_between_8_to100_characters": "Password must contain a lower character , a upper character , adigit and a special character and length must be between 8 to100 characters",
    "Setup_TFA": "Setup TFA",
    "Scan_the_QR_code_in_Google_Authenticator": "Scan the QR code in Google Authenticator",
    "Auth_Type_Time_Based_OTP": "Auth Type - Time Based - OTP",
    "Enter_the_auth_code": "Enter the auth code",
    "Enable": "Enable",
    "Invalid_Code": "Invalid Code",
    "Enter_OTP": "Enter OTP",
    "OTP": "OTP",
    "Having_Trouble": "Having Trouble",
    "To_recover_the_account_please_contact_infoaccountonio_Itmight_take_45_business_days_due_to_security_reasons_to_verifyyour_account": "To recover the account, please contact info@accounton.io. Itmight take 4-5 business days due to security reasons to verify your account.",
    "login": "login",
    "set-new": "set new",
    "reset": "reset",
    "forgot": "forgot",
    "setupTFA": "setup 2FA",
    "acceptOTP": "accept OTP",
    "INVALID_CODE": "INVALID_CODE",
    "mailto:info@lawren.io": "mailto:info@lawren.io",
    "PASSWORD_WEAK": "Password must contain a lowercase letter, an uppercase letter, a digit and a special character. The length must be between 8 to 100 characters.",
    "Mail_Sent": "Mail is sent",
    "You_mail_has_been_sent": "We have sent an e-mail to the email address. Via this email you can reset your password.",
    "Password_Changed": "Password is changed",
    "Your_Password_has_been_changed": "Your password has been changed",
    "Continue": "Continue",
    "Password_rest_sent": "Password reset sent",
    "receive_email_if_you_registered_system": "You will receive an email if you are registered in our system.",
    "Passwords_do_not_match": "The confirmation password does not match the new password.",
    "Unauthorized": "Invalid email address or password.",
    "SSO_REQUIRED": "Sign in with Microsoft to access delegated environments."
  },
  "ok-sign-success": {
    "successMsg": "Successfully Signed!",
    "successDescription": "No further action required. You will receive a copy via email once all signatures are placed.",
    "errorDescription": "Something went wrong!",
    "error": "Error"
  },
  "pagination": {
    "Show": "Show",
    "entries": "entries",
    "Items_per_page": "Items per page:",
    "Of": "of",
    "Navigation": "Pagination",
    "Previous_page": "Previous page",
    "Next_page": "Next page",
    "Page": "Page"
  },
  "aml": {
    "Loading_": "Loading ...",
    "Company_AMLPolicy": "Company AML-Policy",
    "Regenerate_Policy": "Regenerate Policy",
    "Policy_Name": "Policy Name",
    "Date": "Date",
    "Signature": "Signature",
    "Action": "Action",
    "Download": "Download",
    "Not_Found_Company_AMLPolicy": "Not company AML-policy found",
    "Company_Risk_Assessment": "Company Risk Assessment:",
    "AML_Officer_Detail": "AML Officer Detail:",
    "Sectors_we_dont_accept_clients_from": "Sectors we don't accept clients from:",
    "Standard": "Standard",
    "High": "High",
    "Unknown": "Unknown",
    "Internal_Policy": "Internal Policy",
    "Are_you_sure_you_want_to_regenerate_the_policy": "Are you sure you want to regenerate the AML-policy? If you regenerate this, you will have to finish this before you or another user can perform another action in the AMLCare platform.",
    "Yes": "Yes",
    "No": "No",
    "Details": "Details",
    "Blow_Whistle": "Coming soon",
    "Email_AMLCO_Officer": "Send e-mail to AML responsible",
    "Sent for signing": "Sent for signing",
    "Partially signed": "Partially signed",
    "Signed": "Signed",
    "Document in progress": "Document is in preparation",
    "ERROR": "Error",
    "Yearly_activity_report": "Annual reports",
    "Add_activity_report": "Add annual report",
    "No_yearly_reports_found": "No annual reports found",
    "CANNOT_DELETE_CURRENT_AML_POLICY": "You can not delete current active AML policy."
  },
  "amlco-education": {
    "AMLCO_Education_Section": "AMLCO Education",
    "To_go_to_the_courses_please_click_on_the_button_below": "To go to the courses, please click on the button below",
    "Go_to_AMLCO_Education": "Go to AMLCO Education"
  },
  "add-document-slider": {
    "Add_New_Task": "Add new task",
    "Loading_": "Loading !",
    "Add_Document_Name": "Add new task",
    "Category": "Category",
    "Language": "Language",
    "Add": "Add",
    "Invite_Customer": "Invite Customer via e-mail",
    "Fill_In_Myself": "Fill In Myself",
    "Do_you_want_to_invite_the_customer_to_provide_this_info_or_do_you_want_to_fill_it_in_yourself": "Do you want to invite the customer via e-mail to provide this info or do you want to fill it in yourself?",
    "Office AML policy": "Internal AML policy",
    "Customer Identification: Company": "Customer Identification: Company",
    "Customer Identification: Private Person": "Customer Identification: Private Person",
    "Customer Acceptance Procedure Light": "Individual risk assessment: Shortened",
    "Customer Acceptance Procedure": "Individual risk assessment: Extended",
    "Whistleblowing": "Whistleblowing",
    "Notification CFI": "Engagement letter",
    "Yearly Report": "Annual report",
    "Report Atypical Operation": "Atypical operations: report AMLCO",
    "Customer identification: Sole proprietorship": "Customer identification: Sole proprietorship",
    "Offboarding": "Offboarding",
    "ID Card Renewal": "Renewal ID Card: Company",
    "Yearly activity report": "Annual reports",
    "Verification": "Verification report",
    "Verification_task_cannot_be_added": "It is not possible to add the verification as at least one customer is not a company and/or does not have a valid KBO number",
    "Verification_task_already_added": "The verification report has already been added to this company.",
    "Renewal ID Card Private Person": "Renewal ID Card: Person",
    "Private_person_IDRenewal_task_cannot_be_added": "It is not possible to add the Renewal ID card private person task as at least one customer is not a private person.",
    "Name": "Name",
    "Multi_CAP_hint": "We’ll pre-fill this customer’s assessment with answers from their last assessment.",
    "Add_Additional_Sections": "Add additional sections ",
    "Optional": "optional",
    "Configuration_Note": "To add comments or include specific adverse media, sanctions, and political exposure results, click \"Configure optional sections\".",
    "Configuration_Optional_Note": "",
    "Configure_Report": "Configure report",
    "Download_Report": "Download report",
    "Introduction": "Introduction",
    "Configure_Verification_Report": "Configure verification report",
    "Configure_Report_Description": "Customize the optional sections below, then click \"Create report\" to generate your report.",
    "Introduction_Description": "Include an optional introductory message at the beginning of the report.",
    "Add_Introductory_Message": "Add an optional introductory message",
    "Characters_Remaining": "Characters remaining",
    "Check_Sections_to_Include": "Select the sections you want to include in the report.",
    "Add_Comment": "Add a comment",
    "Include_Optional_Comment": "Include an optional comment",
    "Disabled_Comment": "To add a comment, enable this section above to include it in the report.",
    "Uncheck_All_Sources": "Deselect all sources",
    "Check_All_Sources": "Select all sources",
    "Disabled_Sources_Hint": "To remove a source, disable this section above to exclude it from the report.",
    "Include_Sources": "Include sources",
    "Select_Category": "Select one",
    "Create_Report": "Create report",
    "Cancel_And_Return": "Cancel and return to relation details",
    "Cancel_Report": "Cancel report",
    "Stay_On_Page": "Stay on page",
    "Cancel_Report_Description": "If you leave this page, all configuration changes will be lost and your report will not be created.",
    "Cancel_Verification_Report": "Cancel verification report",
    "Document_Assigned": "Task assigned successfully",
    "Verification_report_created": "Verification report created successfully",
    "Verification_report_generating": "Verification report is generating...",
    "Verification_report_generating_please_wait": "Your verification report is being generated. Please wait, this may take a few seconds.",
    "Search": "Search",
    "Verification_report_generating_for": "Generating verification report for {{name}}",
    "Verification_report_ready": "Verification report ready",
    "View_report_for": "View report for {{name}}",
    "View_report": "View report",
    "Bulk_Verification_Note": "A verification report with all default sections will be added to each selected customer. Reports can't be configured or downloaded in bulk — you can find each report in the customer's tasks.",
    "Generate_Reports": "Generate reports",
    "Verification_reports_generating_for_count": "Generating verification reports for {{count}} customers",
    "Verification_reports_bulk_summary": "{{succeeded}} of {{total}} verification reports generated successfully",
    "Verification_reports_bulk_failed_detail": "{{failed}} could not be generated, for example because the required information is not available for that customer.",
    "Verification_reports_already_generating": "A verification report is already being generated for all selected customers.",
    "Assign_a_user": "Assign a user",
    "Assign_a_workflow_or_user": "Assign a workflow or user",
    "Next": "Next",
    "Assign_workflow_assignees": "Assign workflow assignees",
    "Assign_workflow_assignees_description": "The <b>{{workflowName}}</b> workflow requires assignees at task creation.",
    "Assign_workflow_assignees_description_2": "For each editable step, choose one or more users from its configured group. Remaining steps are assigned automatically.",
    "Back_to_task_selection": "Back to task selection",
    "Cancel": "Cancel",
    "Create_task": "Create task",
    "Select_Assignee": "Select assignee",
    "All_users": "All users",
    "Task_creator": "Task creator",
    "Customer_responsible": "Customer responsible",
    "Assigned_to_previous_step_assignees": "Automatically assigned to the previous step's assignee(s)",
    "Failed_to_load_workflow_steps": "Failed to load workflow steps. Please try again.",
    "Auto_applied_workflow_tooltip": "This workflow is assigned automatically based on the selected task category.",
    "Auto_assigned_step_tooltip": "Auto-assigned based on the workflow configuration.",
    "Step_pool_unresolved_warning": "This step's configured assignees could not be resolved to anyone — check the workflow's configuration.",
    "step_problem_missing": "Choose at least one assignee for this step.",
    "step_problem_not_editable": "This step's assignees are fixed by the workflow and cannot be chosen here.",
    "step_problem_no_candidates": "Nobody in this step's configured group is available to assign.",
    "step_problem_no_common_candidates": "Nobody in this step's group has access to all the selected customers.",
    "step_problem_not_in_pool": "One of the selected users is not in this step's configured group."
  },
  "bulk-import": {
    "Loading_": "Loading...",
    "Customers": "Customers",
    "Import_Customers": "Import Customers",
    "Upload_xlsx_document": "Upload .xlsx document",
    "Drag_file_here_for_upload": "Drag file here for upload",
    "Name": "Name",
    "Email": "Email address",
    "Phone_Number": "Phone Number",
    "Address": "Address",
    "Add": "Add",
    "No_Customers_Found_to_Add": "No Customers Found to Add",
    "Incorrect_Customers": "Incorrect Customers",
    "Import_document_Help": "Information for drawing up the document",
    "Download_the_sample_document": "Download the sample document",
    "Fill_the_details_into_appropriate_column": "Fill in the data in the corresponding columns",
    "Name_and_email_columns_are_compulsory__Dont_keep_it_blank_": "Name and e-mail columns are mandatory. Please do not leave them empty.",
    "If_information_is_not_available_then_keep_it_empty_dont_insert__NA": "If you have other information that is not available or do not wish to fill in, please leave these cells empty.",
    "Download": "Download",
    "Are_you_sure": "Are you sure that you want to delete this?",
    "You_Want_to_delete_this_Document": "This will be deleted permanently.",
    "Yes_delete_it": "Yes, delete it",
    "No_keep_it": "No, keep it",
    "Customer_type": "Customer type",
    "KBO_Number": "Enterprise number",
    "Customers_only_in_import": "Customers only in import",
    "The_following_customers_are_not_yet_in_AMLCare": "The following customers are not yet in AMLCare",
    "Add_the_selected_customers_to_AMLCare": "Add the selected customers to AMLCare",
    "Customers_only_in_AMLCare": "Customers only in AMLCare",
    "The_following_customers_are_in_AMLCare_but_not_in_the_import": "The following customers are in AMLCare but not in the import",
    "Delete_selected_customers_in_AMLCare": "Delete selected customers in AMLCare",
    "Double_customers": "Double customers",
    "The_following_customers_are_already_in_AMLCare": "The following customers are already in AMLCare",
    "Invalid_customers": "Invalid customers",
    "The_following_customers_contain_incorrect_information_and_cannot_be_checked_or_imported": "The following customers contain incorrect information and cannot be checked or imported",
    "No_Customers_Found": "No customers found",
    "Please_make_sure_customers_to_be_deleted_are_selected": "Please make sure customers to be deleted are selected",
    "Deleting_customers_failed": "Deleting customers failed",
    "Customers_Added_Successfully": "Customers added successfully",
    "Name_Language_and_Customer_Email_columns_are_compulsory_Dont_keep_it_blank": "Name, language and customer email columns are mandatory. Please do not leave these empty.",
    "Registration_Number": "Registration Number",
    "Updateoverwrite_all_emailaddresses_in_AMLCare": "Update/overwrite all e-mail addresses in AMLCare",
    "Updateoverwrite_labels_in_AMLCare": "Update/overwrite all labels in AMLCare ",
    "Updateoverwrite_responsible_in_AMLCare": "Update/overwrite all responsibles in AMLCare",
    "Customer_updated_successfully": "Customers have been successfully updated",
    "Choose_Source": "Choose an active import option",
    "No_Configured_Sources": "No configured sources",
    "All_Options_Configured": "All import options are configured",
    "Other_Import_Options": "Other available import options",
    "Excel_Worksheet_File": "Excel file",
    "Upload_Excel_File_Description": "Upload an Excel file based on the provided template to import relations.",
    "Next": "Next",
    "Choose_Different_Source": "Choose a different import option",
    "Import_Admin_Pulse_Description": "Import customers from your AdminPulse integration",
    "AdminIS/AdminConsult_Description": "Import customers from your AdminIS/AdminConsult integration",
    "Admin_IS/Admin_Consult": "AdminIS/AdminConsult Import",
    "Configure": "Configure",
    "Import_Admin_Pulse": "AdminPulse",
    "Choose_which_data_to_import_from_AdminIS/AdminConsult": "Select which data to import from AdminIS/AdminConsult",
    "Import_customers_from_a_specific_year_and_taskflow": "Import relations from a specific taskflow and deadline date",
    "Import_all_customers": "Import all customers",
    "Task_Flow": "Taskflow",
    "Select_a_task_flow": "Select a taskflow",
    "Choose_which_data_to_import_from_AdminPulse": "Select which data to import from AdminPulse",
    "Import_customers_from_a_task_template": "Import customers from a task template",
    "Task_Template": "Task template",
    "Select_task": "Select a task template",
    "Country": "Country",
    "Yes_add_new_labels": "Yes, add new labels",
    "No": "No",
    "New_Advance_Labels": "New labels detected",
    "Labels_not_configured_message": "These labels haven't been configured yet and will be added as new label options. Do you want to proceed?",
    "Category_of_Label": "Advanced Label Category",
    "Allowed_Labels": "Permitted Labels",
    "New_labels_detected": "New labels detected",
    "New_labels_detected_message": "These customers use <strong>{{labelCount}} labels</strong> and <strong>{{categoryCount}} advanced label category</strong> that don't exist yet.",
    "New_labels_Confirm_message": "You can create them now, or add the customers without them:",
    "Labels": "Labels",
    "New_labels_label_one": "<strong>1 label category</strong>",
    "New_labels_label_other": "<strong>{{count}} label categories</strong>",
    "New_labels_category_one": "<strong>1 advanced label category</strong>",
    "New_labels_category_other": "<strong>{{count}} advanced label categories</strong>",
    "New_labels_and": "and",
    "New_labels_detected_message_one_customer_one_item": "The selected customer uses {{items}} that doesn't exist yet.",
    "New_labels_detected_message_one_customer_many_items": "The selected customer uses {{items}} that don't exist yet.",
    "New_labels_detected_message_many_customers_one_item": "These customers use {{items}} that doesn't exist yet.",
    "New_labels_detected_message_many_customers_many_items": "These customers use {{items}} that don't exist yet.",
    "New_category": "New Category"
  },
  "customer": {
    "Loading_": "Loading ...",
    "Companies": "Customers",
    "Add_Company": "Add customer",
    "Update_Company": "Update company",
    "Company_Information": "Company Information",
    "KBO_Number": "Company number",
    "Company_Name": "Company name",
    "Company_Search_Name": "Company search name",
    "Company_Type": "Corporate form",
    "Company_Address": "Company address",
    "Language": "Language",
    "Account_Manager": "Responsible",
    "Label": "Label",
    "Enter_Label": "Enter Label",
    "Contact_Person": "Contact Person",
    "First_Name": "First Name",
    "Last_Name": "Last Name",
    "Email": "Email",
    "Contact_No": "Telephone number",
    "Customers": "Customers",
    "Name": "Name",
    "Website": "Website",
    "Address": "Address",
    "Responsible": "Responsible",
    "Add_Customer": "Add customer",
    "Update_Customer": "Update customer",
    "Fetch_Company_Details": "Fetch company details",
    "Customer_Type": "Customer type",
    "Company": "Company",
    "Private_Person": "Private person",
    "Informative_private_person": "Information private person",
    "Full_Name": "Full name",
    "Add_Private_Person": "Add private person",
    "Update_Private_Person": "Update private person",
    "National_registration_number": "National registration number",
    "Registration_number_are_already_exists_in_another_customer": "This national register number is already linked to another customer. You can find this customer via the ‘Overview persons’ page.",
    "Please_enter_a_valid_registration_number": "Please enter a valid registration number",
    "ID_Card_Data": "ID Card Data",
    "ID_card_expiration_date": "ID card expiration date",
    "Birth_date": "Date of birth",
    "Id_Card": "ID Card",
    "Private_persons_list ": "Private persons list",
    "Private_persons": "Private persons",
    "Company_Is_Direct_Customer": "This company is a customer for which we need to perform the identification, CAP and verification",
    "Person_Is_Direct_Customer": "This person is a customer for which we need to perform the identification and the CAP.",
    "Registration_number_is_invalid": "National registration number is invalid",
    "File_Renamed_Successfully": "File renamed successfully",
    "File_Rename_Failed": "File renaming failed",
    "Idcard_expiration_warning": "This ID card expiration date is in the past",
    "label_can_not_contains_colon": "Label cannot contain colon (:)",
    "ID_Card_Uploaded_Successfully": "ID card uploaded successfully",
    "ID_Card_Expiration_Date_Updated_Successfully": "ID card expiration date updated successfully",
    "ID_Card_Deleted_Successfully": "Id card deleted successfully",
    "Birth_place": "Birth place",
    "Merge_Customers": "Merge customers?",
    "Merge_Customers_Confirm_Description": "Please confirm that you would like to merge the customers below.",
    "Merge_Customers_Common_Description": "When this option is enabled, users can select the UBO synchronization option 'First synchronization automatic, then start manually' when creating or editing a customer. In that case, an initial UBO synchronization is automatically started.\n\nAfter that, a new UBO synchronization can always be performed, but it must be started by the user each time.",
    "Direct_Customer_Private_Person": "The merged person will be a direct customer.",
    "Direct_Customer_Company": "The merged company will be a direct customer.",
    "Merge_Customers_Confirm": "Yes, merge customers",
    "Please_enter_a_valid_mobile_number": "Please enter a valid mobile phone number",
    "relation_suggestion_rejected_successfully": "Relation suggestion rejected successfully.",
    "relation_created_successfully": "Relation created successfully.",
    "relation_role_kept_successfully": "Relation role saved successfully.",
    "relation_role_removed_successfully": "Relation role removed successfully.",
    "relation_linked_successfully": "Relation linked successfully.",
    "relation_role_added_successfully": "Relation role added successfully.",
    "Ubo_Sync_Requires_Cbe_Number": "UBO sync requires a CBE number",
    "Continue_Without": "Continue without",
    "Go_Back": "Go back",
    "Ubo_Sync_Cbe_Number_Content": "To enable the UBO sync for this company, first add its CBE number.",
    "Ubo_Sync_Cbe_Number_Content_Secondary": "If you continue without it, the UBO sync will be disabled for this company. You can enable it later after adding the CBE number.",
    "Fill_Required_Fields_Tooltip": "To update this relation, please fill out the required fields above.",
    "Birthdate_invalid_error": "The date of birth is invalid.",
    "Birthdate_future_error": "The date of birth cannot be a future date.",
    "Add_responsible_to_continue": "Add a responsible person to continue.",
    "Save_responsible_and_continue": "Save responsible and continue",
    "Add_responsible_message": "Before you can accept this suggestion, a responsible person must be assigned to {{customerName}}.",
    "Select_responsible_to_continue": "Select a responsible person below to continue.",
    "Select_responsible": "Select a responsible person",
    "of": "or",
    "idCard_missing": "ID card details missing",
    "idCard_missing_expiration_date": "ID card details missing",
    "idCard_expired": "This identity card has expired.",
    "idCard_expiring_soon": "This identity card will expire within 2 weeks.",
    "percentage_max": "The percentage cannot exceed 100.",
    "Archived_Person_NRN_Tooltip": "A person with this registration number already exists but is archived. Unarchive it to continue.",
    "Archived_Company_KBO_Tooltip": "A company with this enterprise number already exists but is archived. Unarchive it to continue.",
    "Unarchive_Customer": "Unarchive relation",
    "Customer_Code": "Customer Code",
    "Bulk_suggestions_applied_with_failures": "{{succeeded}} suggestion(s) applied, {{failed}} failed.",
    "Bulk_suggestion_applied_successfully_singular": "1 suggestion applied successfully.",
    "Bulk_suggestions_applied_successfully": "{{succeeded}} suggestions applied successfully.",
    "Bulk_apply_all_succeeded": "{{count}} suggestions applied successfully",
    "Bulk_apply_all_partial": "{{succeeded}} suggestion(s) applied, {{failed}} failed, {{skipped}} require manual review.",
    "Bulk_apply_all_skipped_names": "Requires manual review: {{names}}",
    "Bulk_apply_all_failed_reasons": "Failed: {{reasons}}",
    "Bulk_apply_all_data_update_failed": "{{count}} linked customer(s) could not have their data refreshed"
  },
  "customer-detail-view": {
    "Tasks": "Tasks",
    "Loading_": "Loading ...",
    "Companies": "Customers",
    "Risk_Level": "Risk level",
    "Documents": "Tasks",
    "Ultimate_Beneficial_Owners": "Ultimate Beneficial Owners",
    "ESigning": "E-signing",
    "Uploads": "Attachments",
    "Company_Details": "Customer details",
    "Delete_Company": "Delete customer",
    "Responsible": "Responsible",
    "Edit_Company": "Edit customer",
    "Standard": "Standard",
    "High": "High",
    "Unknown": "Unknown",
    "enrich_data": "Know Your Customer (KYC) ",
    "Archive_Company": "Archive customer",
    "Unarchive_Company": "Unarchive customer",
    "Communication": "Communication",
    "Kyc": "KYC",
    "Relations": "Relations",
    "ID_Cards": "ID Cards",
    "Adverse_media": "Adverse media",
    "Invalid_KBO_number": "Invalid CBE number",
    "Sanctions_and_mandates": "Sanctions lists",
    "KYC_Activity": "Monitoring",
    "Audit_Log": "Audit Log",
    "Add_responsible": "Add responsible",
    "Political_involvements": "Political link",
    "Sanctions": "Sanctions",
    "Contact_and_registration_information": "Contact and registration information",
    "Warnings": "Warnings",
    "Main_Responsible": "Main responsible",
    "Phone_Number": "Phone number",
    "CBE_Number": "CBE number",
    "Save": "Save",
    "Responsible_no_access_tooltip": "This user does not have access to this customer. Update their access or the responsible."
  },
  "customer-list": {
    "Loading_": "Loading ...",
    "Search": "Search",
    "Filter_By": "Filter By",
    "CAP_Date": "CAP Date",
    "Status": "CAP",
    "Risk": "Risk",
    "New_Assessment": "New CAP",
    "Label": "Label",
    "Action": "Action",
    "Edit": "Edit",
    "Delete": "Delete",
    "Company_Not_Found": "No customers found",
    "Standard": "Standard",
    "High": "High",
    "Unknown": "Unknown",
    "Identification_completed": "Completed",
    "Identification_in_progress": "In progress",
    "Identification_not_started": "Not started",
    "ID_cards_valid": "Valid",
    "ID_cards_missing_info": "Missing info",
    "ID_cards_expired": "Expired",
    "ID_cards_renewal": "Due for renewal",
    "Verification_verified": "Verified",
    "Verification_not_verified": "Not verified",
    "Document_Details": "Task details",
    "Category": "Category",
    "Type": "Type",
    "Overrule_Reason": "Overrule reason",
    "Progress_Percentage": "Progress",
    "Risk_Questions": "Risk questions",
    "Question": "Question",
    "Answer": "Answer",
    "Company_Assessment": "Customer Assessment",
    "Label_Management": "Label management",
    "Import_Company": "Import Customers",
    "Add_Company": "Add customer",
    "Delete_Companies": "Delete customers",
    "Name": "Name",
    "Email": "Email",
    "CAP Not Initiated": "CAP not started",
    "CAP In Progress": "CAP is ongoing",
    "Customer Accepted": "Customer accepted",
    "Customer not Accepted": "Customer not accepted",
    "ID_Cards": "IDs",
    "Status_identification": "Identification",
    "Identification_task_is_ongoing": "Identification is ongoing",
    "All_identification_task_is_completed": "All identifications are completed",
    "No_identification_is_assigned": "No identification has been started yet",
    "Missing_Info": "ID card or expiry date of an ID card is missing ",
    "Renewal": "At least one ID card is due to expire within two weeks",
    "Completed": "All ID cards and expiry dates of ID cards are present and valid",
    "Expired": "At least one ID card has expired",
    "No_cap_started_tooltip": "No CAP has been started yet",
    "CAP_in_progress_tooltip": "CAP is ongoing",
    "CAP_customer_not_accepted_tooltip": "Customer was not accepted",
    "CAP_is_expired_tooltip": "CAP is expired",
    "CAP_will_expire_tooltip": "CAP is due to expire within two weeks",
    "CAP_customer_accepted_tooltip": "Customer is accepted",
    "All_identification_task_submitted": "All identifications are completed",
    "Verification": "Verification",
    "Private_person_verification_tooltip": "Customer is a private person. Verification is for companies only.",
    "Company_not_verified_tooltip": "No verification has been done yet",
    "Company_verified_tooltip": "Verification has been done",
    "Cap will expire soon": "CAP will expire soon",
    "CAP is expired": "CAP is expired",
    "out_of": "out of",
    "compliant": "compliant",
    "Add_Filter": "Add filter",
    "Remove_Filter": "Remove filter",
    "Filter_Options_Load_Failed": "The filters could not be loaded. You can still search.",
    "Filter_Already_Used": "Already used in another filter",
    "Max_Filters_Reached": "Maximum {{max}} filters allowed",
    "Items_selected": "$$SELECTED$$ selected",
    "At_least_one_identification_has_an_outstanding_signature": "At least one identification has an outstanding signature",
    "At_least_one_CAP_has_an_outstanding_signature": "At least one CAP has an outstanding signature",
    "CAP has an outstanding signature": "CAP has an outstanding signature",
    "Esign not completed": "Signature required",
    "Id_card_expiration_date": "ID card expiration date",
    "Private_Persons_Not_Found": "No private persons found",
    "Customer": "Customer",
    "Other_director": "Director ",
    "UBO": "UBO",
    "Companies_Not_Found": "Companies not found",
    "Company_director": "Director",
    "Permanent_representative": "Permanent representative",
    "Indirect_private_person": "Linked relation",
    "Direct_private_person": "Primary customer (=full AML procedure)",
    "Indirect_company": "Linked relation",
    "Direct_company": "Primary customer (=full AML procedure)",
    "Archived_customers": "Archived customers overview",
    "Bulk_Label_Disabled": "Bulk label management is disabled due to advanced label management being enabled.",
    "NRN": "National registration number",
    "CBE": "CBE number",
    "Missing_Id_card": "ID card details missing",
    "Merge_People": "Merge persons",
    "Merge_Companies": "Merge companies",
    "Merge_People_With_Multiple_RRN": "The selected customers have different national registration numbers. Each number is unique to one person, so these customers cannot be merged.",
    "Merge_Companies_With_Multiple_CBE": "The selected entities have different company registration numbers (CBE). Each number is unique to one company, so these entities cannot be merged.",
    "No_id_card_expiration_date": "ID card expiration date not available",
    "Customers": "Customers",
    "CAPs": "CAPs",
    "Progression": "Progress",
    "Files": "Files",
    "risk_status": "Status",
    "customer_name": "Customer Name",
    "Unarchive this CAP category?": "Do you want to unarchive this matter?",
    "Unarchive_CAP_category_message": "Please confirm that you would like to unarchive this matter.",
    "Unarchive_CAP_category_note": "All ongoing or completed assessments for the the {{category}}: {{capName}} will be reactivated in AMLCare.",
    "Delete_CAP_category": "Do you want to delete this matter?",
    "Delete_CAP_category_message": "Please confirm that you would like to delete this matter.",
    "Delete_CAP_category_note": "All ongoing or completed assessments for the the {{category}}: {{capName}} will be deleted permanently.",
    "Unarchive_ALL_CAP_category": "Do you want to unarchive all selected matters?",
    "Unarchive_ALL_CAP_category_message": "Please confirm that you would like to unarchive the {{ count }} matter(s).",
    "Unarchive_ALL_CAP_category_note": "All ongoing or completed assessments for the selected matters will be reactivated in AMLCare.",
    "Delete_ALL_CAP_category": "Do you want to delete all selected matters?",
    "Delete_ALL_CAP_category_message": "Please confirm that you would like to delete the {{ count }} matter(s).",
    "Delete_ALL_CAP_category_note": "All ongoing or completed assessments for the selected matters will be deleted permanently.",
    "Unarchive_customer": "Do you want to unarchive this customer?",
    "Unarchive_customer_message": "Please confirm that you would like to unarchive this customer.",
    "Unarchive_customer_note": "This customer will be reactivated in AMLCare.",
    "Delete_customer": "Do you want to delete this customer?",
    "Delete_customer_message": "This will permanently delete the {{ name }} customer and all of its data.",
    "Delete_customer_confirm_message": "Please confirm by typing DELETE below.",
    "Unarchive_ALL_customers": "Do you want to unarchive all selected customers?",
    "Unarchive_ALL_customers_message": "Please confirm that you would like to unarchive the {{ count }} selected customers.",
    "Delete_all_selected_customers": "Do you want to delete all selected customers?",
    "Delete_all_selected_customers_message": "This will permanently delete the {{ count }} selected customers and all of their data.",
    "Delete_CAPs": "Delete matters",
    "Unarchive_CAP_category": "Unarchive matter",
    "Unarchive_Customers": "Unarchive customers",
    "Unarchive_CAPs": "Unarchive matters",
    "Yes_unarchive_CAP_category": "Yes, unarchive this matter",
    "Cancel": "Cancel",
    "Yes_delete_CAP_category": "Yes, delete matter",
    "Yes_delete_CAP_categories": "Yes, delete {{count}} matter(s)",
    "Yes_unarchive_customer": "Yes, unarchive this customer",
    "Yes_unarchive_customers": "Yes, unarchive {{count}} customer(s)",
    "Type_DELETE_to_confirm": "Type DELETE to confirm",
    "Delete_customers": "Delete customers",
    "Yes_unarchive_CAP_categories_Count": "Yes, unarchive {{count}} matter(s)",
    "CAPName": "Case name",
    "Missing_Info_Message": "ID card details missing",
    "Icon_Tooltip_Customer": "Customer",
    "Icon_Tooltip_Linked_Relation": "Linked relation",
    "Icon_Tooltip_Archived_Customer": "Archived relation",
    "Icon_Tooltip_Archived_Linked_Relation": "Archived linked relation",
    "Labels": "Labels",
    "This_customer_has_labels": "This customer has {{count}} labels:",
    "Clear_Filters": "Clear filters"
  },
  "document-details-slider": {
    "Policy_Details": "Details internal AML policy",
    "Task_Details": "Task details",
    "Loading_": "Loading ...",
    "Document_Details": "Document Details",
    "Category": "Category",
    "Type": "Type",
    "Risk": "Risk",
    "Overrule_Reason": "Overrule Reason",
    "Progress_Percentage": "Progress",
    "Risk_Questions": "Answers leading to high risk",
    "Question": "Question",
    "Answer": "Answer",
    "Search": "Search",
    "Filter_By": "Filter By",
    "Company_Name": "Name",
    "Contact_Person": "Contact Person",
    "CAP_Date": "CAP Date",
    "Status": "Status CAP",
    "New_Assessment": "New Assessment",
    "Label": "Label",
    "Action": "Action",
    "Edit": "Edit",
    "Delete": "Delete",
    "Customers_Not_Found": "Customers Not Found",
    "Standard": "Standard",
    "High": "High",
    "Unknown": "Unknown",
    "Document_is_fully_submitted": "Document is submitted",
    "Document_not_yet_submitted": "Document is not yet submitted",
    "View_Conversation": "View questionnaire",
    "Copy_URL": "Copy URL",
    "Start_Conversation": "Start questionnaire",
    "Download_Document": "Download document",
    "Send_Reminder": "Send reminder",
    "Send_Mail": "Send invite to customer",
    "Delete_Document": "Delete document",
    "Office AML policy": "Internal AML policy",
    "Customer Identification: Company": "Customer Identification: Company",
    "Customer Identification: Private Person": "Customer Identification: Private Person",
    "Customer Acceptance Procedure Light": "Individual risk assessment: Shortened",
    "Customer Acceptance Procedure": "Individual risk assessment: Extended",
    "Whistleblowing": "Whistleblowing",
    "Notification CFI": "Engagement letter",
    "Yearly Report": "Annual report",
    "Report Atypical Operation": "Atypical operations: report AMLCO",
    "Internal": "Internal",
    "External": "External",
    "Risk_weight": "Risk weight",
    "Yearly activity report": "Annual report",
    "Yearly_report_details": "Details annual report",
    "total_risk_weight": "If the risk weight ≥ 100, a high risk is assigned. The total risk weight is",
    "overrule_reason_description": "The risk level has been overruled with the following description",
    "Verification": "Verification report",
    "ID Card Renewal": "Renewal ID Card",
    "Customer identification": "Customer identification",
    "Customer identification: Sole proprietorship": "Customer identification: Sole proprietorship",
    "Renewal ID Card Private Person": "Renewal ID Card: Person",
    "Assigned_To": "If applicable, you can assign this task below to a colleague."
  },
  "documents": {
    "No_tasks_have_been_added_yet": "This customer has no tasks available. You can add a task at the top right.",
    "Tasks": "Tasks",
    "Add_New_Tasks": "Add new task",
    "Loading_": "Loading ...",
    "Documents": "Tasks",
    "New_Document": "New task",
    "Date": "Date",
    "Category": "Category",
    "Progression": "Progress",
    "Additional_Uploads": "Files",
    "Type": "Type",
    "Action": "Actions",
    "No": "No",
    "Documents_Not_Found": "This customer has no tasks available. You can add a task at the top right.",
    "Status": "Status",
    "Details": "Details",
    "View_Conversation": "View questionnaire",
    "Copy_URL": "Copy URL",
    "Download_Document": "Download document",
    "Send_Reminder": "Send reminder",
    "Send_Mail": "Send invite to customer",
    "Delete_Document": "Delete document",
    "Draft": "Not sent",
    "Sent": "Sent",
    "Submitted": "Completed",
    "Office AML policy": "Internal AML policy",
    "Customer Identification: Company": "Customer Identification: Company",
    "Customer Identification: Private Person": "Customer Identification: Private Person",
    "Customer Acceptance Procedure Light": "Individual risk assessment: Shortened",
    "Customer Acceptance Procedure": "Individual risk assessment: Extended",
    "Whistleblowing": "Whistleblowing",
    "Notification CFI": "Engagement letter",
    "Yearly Report": "Annual report",
    "Report Atypical Operation": "Atypical operations: report AMLCO",
    "Internal": "Internal",
    "External": "External",
    "Customer identification: Sole proprietorship": "Customer identification: Sole proprietorship",
    "Offboarding": "Offboarding",
    "ID Card Renewal": "Renewal ID Card: Company",
    "No_tasks_available": "No tasks available",
    "Yearly activity report": "Annual report",
    "Mark_questionnaire_as_submitted": "Mark task as completed",
    "Verification": "Verification report",
    "Questionnaire_marked_as_submitted": "Task marked as submitted",
    "Renewal ID Card Private Person": "Renewal ID Card: Person",
    "Merge_People": "Merge persons",
    "Companies": "Companies",
    "Add_Task": "Add Task",
    "Archive_CAP": "Archive CAP",
    "Archive_CAP_title": "Archive this CAP?",
    "Archive_CAP_message": "All ongoing or completed assessments for the <b> {{category}} > {{capName}} </b> will be stored in the AMLCare archive.",
    "Archive_CAP_note": "This customer itself including all customer information and other matters will not be archived and remains active.",
    "Archive_CAP_confirm": "Yes, archive CAP",
    "Cancel": "Cancel",
    "Archive_CAP_success": "CAP successfully archived",
    "Start": "Task",
    "No_CAPS_available": "No CAPs available",
    "Task": "Task"
  },
  "e-signing": {
    "ESigning": "E-Signing",
    "Date": "Date",
    "Document_Name": "Document",
    "Status": "Status",
    "Action": "Action",
    "No": "No",
    "ESigning_Document_Not_Found": "An e-signature is not or not yet initiated for this customer.",
    "Name": "Name",
    "Created_At": "Created at",
    "History": "History of actions",
    "Document_Not_Found": "Documents not found",
    "Document_has_not_completely_signed": "All the necessary signatures have not yet been placed on this document.",
    "Do_you_still_want_to_download_it": "Do you still want to download the document?",
    "Download": "Download",
    "Close": "Close",
    "Copy_URL": "Copy URL",
    "Download_Document": "Download document",
    "Details": "Details",
    "Sent for signing": "Sent for signing",
    "Signed": "Signed",
    "Document in progress": "Document is in preparation",
    "Mail not sent": "Not sent",
    "Signee": "Signees",
    "Task": "Task",
    "Customer_risk": "Customer risk",
    "Name_customer": "Name customer",
    "Partially signed": "Partially signed",
    "ERROR": "Error",
    "Declined": "Declined",
    "Cancelled": "Cancelled",
    "Do_you_still_want_to_preview_it": "Do you still want to preview it?",
    "Preview": "Preview"
  },
  "e-sign-details": {
    "ESigning_Details": "Details e-signing",
    "Customers": "Customers",
    "Sent for signing": "Sent for signing",
    "Signed": "Signed",
    "Document in progress": "Document is in preparation",
    "Mail not sent": "Not sent",
    "Declined": "Declined",
    "Copy_URL": "Copy URL",
    "Name": "Name",
    "Created_At": "Date",
    "History": "History of actions",
    "Status": "Status"
  },
  "members": {
    "Loading_": "Loading ...",
    "First_Name": "First Name",
    "Name": "Name",
    "Email": "Email address",
    "Contact_Number": "Mobile number",
    "Role": "Role",
    "Language": "Language",
    "Contact_Person": "Contact Person",
    "View": "View",
    "addUBO": "Add",
    "editUBODetails": "Edit UBO",
    "viewUBODetails": "UBO details",
    "by_setting_this_UBO_as_a_Contact_Person_current_Contact_Person_will_be_overruled": "Designating this UBO as the main contact will replace the current main contact.",
    "to_remove_current_UBO_from_contact_person_make_other_UBO_a_Contact_Person": "To remove the current UBO as a contact person, please select another UBO to be Contact Person",
    "Please_enter_Name": "Please enter a name",
    "Please_enter_a_valid_mobile_number_with_country_code": "Please enter a valid mobile number including country code",
    "Id_Card": "ID Card",
    "Last_Name": "Last Name",
    "ID_card_expiration_date": "ID card expiration date",
    "Add_Director": "Add ",
    "editDirectorDetails": "Edit director",
    "viewDirectorDetails": "Details director",
    "Existing_person": "Existing person",
    "New_person": "New person",
    "Search_persons_placeholder": "Search for persons...",
    "New_company": "New company",
    "Existing_company": "Existing company",
    "Search_companies_placeholder": "Search for companies...",
    "Details": "Details",
    "editDetails": "Edit details",
    "addUBOFor": "Add",
    "Add_Director_for": "Add ",
    "KBO_number": "CBE number",
    "NOT_ALLOWED_TO_ADD_SAME_COMPANY_AS_DIRECTOR": "The same company cannot be added as director for itself",
    "viewPermanentRepresentativeDetails": "Permanent representative details",
    "SELECTED_PRIVATEPERSON_IS_ALREADY_ADDED_AS_UBO": "This person is already added as UBO.",
    "SELECTED_PRIVATEPERSON_IS_ALREADY_ADDED_AS_OTHERDIRECTOR": "This person is already added as director.",
    "SELECTED_COMPANY_IS_ALREADY_ADDED_AS_COMPANYDIRECTOR": "This company is already added as director.",
    "SELECTED_PRIVATEPERSON_IS_ALREADY_ADDED_AS_PERMANENTREPRESENTATIVE": "This person is already added as permanent representative.",
    "ALREADY_ADDED_AS_UBO_IN_SELECTED_COMPANY": "Already added as \"UBO\" in selected company.",
    "ALREADY_ADDED_AS_OTHERDIRECTOR_IN_SELECTED_COMPANY": "Already added as \"Director\" in selected company.",
    "ALREADY_ADDED_AS_PERMANENTREPRESENTATIVE_IN_SELECTED_COMPANY": "Already added as \"permanent representative\" in selected company.",
    "ALREADY_ADDED_AS_COMPANYDIRECTOR_IN_SELECTED_COMPANY": "Already added as \"director\" in selected company.",
    "ADD_RELATION_FIND_COMPANY_CUSTOMER_BY_NAME": "Find a company by name",
    "ADD_RELATION_FIND_PERSON_OR_COMPANY_CUSTOMER_BY_NAME": "Find a person or company by name",
    "ADD_RELATION_SEARCH_PERSONS_OR_COMPANIES_PLACEHOLDER": "Search for persons or companies...",
    "ADD_RELATION_SELECT_CUSTOMER_ERROR": "Please select a customer.",
    "Select_role(s)": "Select role(s)",
    "ADD_RELATION_SELECT_AT_LEAST_ONE_ROLE_ERROR": " Please select at least one role.",
    "Or": "OR",
    "Add_new_person": "Add new person",
    "Add_new_company": "Add new company",
    "Person": "Person",
    "Company": "Company",
    "ADD_RELATION_ADD_RELATION_ERROR": "An error occurred while adding the relation.",
    "ADD_RELATION_ROLE_IS_DIRECTOR_OF": "{{customerName}} is \"director\" of this company",
    "ADD_RELATION_ROLE_IS_UBO_OF": "{{customerName}} is \"UBO\" of this company",
    "ADD_RELATION_ROLE_IS_PERMANENT_REPRESENTATIVE_OF": "{{customerName}} is \"permanent representative\" of this company",
    "ADD_RELATION_ROLE_DIRECTOR": "Director",
    "ADD_RELATION_ROLE_UBO": "Ultimate Beneficial Owner",
    "ADD_RELATION_ROLE_PERMANENT_REPRESENTATIVE": "Permanent Representative",
    "ADD_RELATION_FETCH_DETAILS_ERROR": "An error occurred while fetching relation details.",
    "Add_relation": "Add relation",
    "CBE_number_already_exist": "A customer with this company number already exists.",
    "Invalid_KBO_Number": "Invalid company number",
    "Update": "Update",
    "Switching_to_exiting_customer": "Use existing customer",
    "Directed_By_customerName": "Directed by {{customerName}}",
    "ADD_RELATION_NO_DATA_FOUND": "No relation found",
    "CUSTOMER_WITH_NRN_EXISTS": "A customer with this national registration number already exists.",
    "INVALID_RRN_NUMBER": "Invalid national registration number",
    "Birthplace": "Birth place",
    "PERSON_SAVE_ERROR": "An error occurred while saving this person.",
    "ROLE_IS_DIRECTOR_OF": "{{customerName}} is \"director\" of this company",
    "ROLE_IS_UBO_OF": "{{customerName}} is \"UBO\" of this company",
    "ROLE_IS_PERMANENT_REPRESENTATIVE_OF": "{{customerName}} is \"permanent representative\" of this company",
    "ADD_RELATION": "Add Relation",
    "TABLE_HEADER_ROLES": "Role(s)",
    "TABLE_HEADER_ROLES_FOR": "Roles of {{firstName}}",
    "TABLE_HEADER_ID_EXPIRATION": "ID card expiration date",
    "ADD_PERMANENT_REPRESENTATIVE": "Add permanent rep.",
    "REMOVE_ROLE": "Remove role",
    "REMOVE_SPECIFIC_ROLE": "Remove {{role}} role",
    "REMOVE_ALL_ROLES": "Remove all roles",
    "EMPTY_STATE_TITLE": "No relations added yet",
    "EMPTY_STATE_DESCRIPTION": "Add a relation such as UBO, director, or Permanent Representative.",
    "Go_to_customer_details": "Go to customer details",
    "EDIT_RELATION_TOOLTIP": "Edit roles",
    "UBO": "UBO",
    "ADD_RELATION_FIND_PERSON_CUSTOMER_BY_NAME": "Find a person by name",
    "Existing_Customer": "Existing customer",
    "New_Person": "New person",
    "New_Company": "New company",
    "New_Permanent_Representative": "New permanent representative",
    "Edit_Company": "Edit company",
    "Edit_Person": "Edit person",
    "Relation_Details": "Details of relation",
    "ADD_RELATION_ALREADY_PERMANENT_REPRESENTATIVE": "This customer is already assigned as a permanent representative.  ",
    "Existing_Customer_as_PR": "Permanent Representative",
    "This_will_unlink_the_role": "This will remove the selected role.",
    "This_will_unlink_all_roles": "This will remove all the roles.",
    "Are_you_sure_you_want_to_unlink_all_roles": "Are you sure you want to remove all roles?",
    "Are_you_sure_you_want_to_unlink_the_role": "Are you sure you want to delete the selected role?",
    "COMPANY_SAVE_ERROR": "An error occurred while saving company details.",
    "GET_MEMBER_BY_ID_ERROR": "An error occurred while fetching the customer details.",
    "VERIFY_EXISTING_CUSTOMER_ERROR": "An error occurred while verify the existing customer.",
    "EDIT_CUSTOMER_TOOLTIP": "Edit Customer Details",
    "Update_Roles": "Update roles",
    "Directed_By": "Directed By",
    "Add_role": "Link",
    "Keep_Role": "Keep Role",
    "Create_new_relation": "Create a new relation anyway",
    "Link": "Add role",
    "Link_different_customer": "Add role",
    "Remove_Role": "Remove Role",
    "File_upload_note": "Extracted UBOs will be suggested in the relations page. Please review and confirm each UBO.",
    "Please_note": "Please note: ",
    "Extract_and_suggest_UBO_changes": "Extract and suggest UBO changes",
    "import_ubo_file_description": "Upload a PDF of this company’s UBO register and we’ll extract it for you.",
    "Click_to_upload": "Click to upload",
    "drag_and_drop": "drag and drop",
    "SUGGESTION_REMOVE_DESCRIPTION": "Not found as '{{role}}'. Keep role?",
    "SUGGESTION_LINK_ROLE_DESCRIPTION": "Do you want to add the \"{{role}}\" role to this relation?",
    "SUGGESTION_LINK_DESCRIPTION": "Found as '{{role}}'. Link to an existing relation or create a new one?",
    "SUGGESTION_ADD_DESCRIPTION": "Found as '{{role}}'. Create relation?",
    "SUGGESTION_DEFAULT_DESCRIPTION": "This relation has a pending AMLCare suggestion.",
    "Only_suggested_role_will_be_removed": "Only {{suggestedRole}} will be removed.",
    "IMPORT_UBO_DISABLED_NO_KBO": "Import UBO file button is disabled because we don't have a CBE number at file for this customer.",
    "IMPORT_UBO_DISABLED_EXISTING_SUGGESTIONS": "Import UBO file button is disabled because there are pending suggestions from UBO files. Please process those suggestions first to upload a new file.",
    "File_uploaded_successfully": "File uploaded successfully",
    "UBO_Register_file_processed_successfully": "UBO Register file processed successfully",
    "File_will_be_saved_in_attachments": "{{ fileName }} will be saved under this company’s attachments.",
    "invalidFileType": "Uploaded file is invalid",
    "UBO_Sync_is_Processing": "UBO Sync is processing",
    "Processing_and_extracting_{{companyName}}’s_Ultimate_Beneficial_Owners...": "Processing and extracting {{companyName}}’s Ultimate Beneficial Owners...",
    "COMPANY_NAME": "Company name",
    "PERSON_NAME": "Person name",
    "Remove_role_name": "Remove {{roleName}}",
    "Remove_number_roles": "Remove {{count}} roles",
    "Permanent_Representative_of_companyName": "Permanent representative of {{companyName}}",
    "Role_selection_tooltip": "This view shows direct relations of {{customerName}} and permanent representatives of its directors. To add or edit other relations, go to that company's detail page.",
    "NO_ACCESS_TO_RELATION": "No access to this relation",
    "NO_PERMISSION_CONTACT_ADMIN": "You don't have permission to view this relation. If you need access, contact your AMLCare admin.",
    "TABLE_HEADER_WARNINGS": "Warnings",
    "Unarchive_and_update_roles": "Unarchive and update relation",
    "Unarchive_and_add_relation": "Unarchive and add relation",
    "NO_WARNINGS": "No warnings",
    "WARNING_COUNT_SINGLE": "{{count}} warning",
    "WARNING_MULTI_COUNT": "{{count}} warnings",
    "WARNING_FOR": "Warning for",
    "WARNINGS_FOR": "Warnings for",
    "AND": "and",
    "ARCHIVED_CUSTOMER_WITH_NRN_EXISTS": "An archived customer with this national registration number already exists.",
    "ARCHIVED_CBE_NUMBER_ALREADY_EXIST": "An archived customer with this enterprise number already exists.",
    "Unarchive_and_use_existing_customer": "Unarchive and use existing customer",
    "RELATION_SUGGESTIONS": "Relation suggestions",
    "RELATION_SUGGESTION_LINK_DESCRIPTION": "Found as '{{role}}'. Link relation?",
    "RELATION_SUGGESTION_LINK": "Link to existing relation",
    "RELATION_SUGGESTION_CREATE_RELATION": "Create relation",
    "Accept_all_suggestions": "Accept all suggestions",
    "Accept_suggestion": "Accept suggestion\t",
    "Accept_all_suggestions_tooltip": "Accept every suggestion using its recommended action.",
    "NO_PERMANENT_REP": "No permanent rep.",
    "NO_PERMANENT_REP_TOOLTIP": "Add {{customerName}}'s missing permanent representative via the button to the right.",
    "PR_ID_MISSING": "PR missing ID",
    "PR_ID_MISSING_TOOLTIP": "{{customerName}} has a permanent representative missing ID card details",
    "PR_ID_EXPIRED": "PR ID expired",
    "PR_ID_EXPIRED_TOOLTIP": "{{customerName}} has a permanent representative whose ID card is expired",
    "PR_ID_EXPIRES_SOON": "PR ID expires soon",
    "PR_ID_EXPIRES_SOON_TOOLTIP": "{{customerName}} has a permanent representative whose ID card will expire in the next 2 weeks"
  },
  "member-list": {
    "Loading_": "Loading ...",
    "Ultimate_Beneficial_Owners": "Ultimate Beneficial Owners",
    "UBO": "Add",
    "Name": "Name",
    "Email": "Email address",
    "Role": "Role",
    "Action": "Action",
    "Edit": "Edit",
    "Delete": "Delete customer",
    "Ultimate_Beneficial_Owners_Not_Found": "There are no UBOs yet",
    "Contact_Person_cant_be_deleted": "The main contact person can not be deleted",
    "In_order_to_delete_the_contact_person_you_need_to_make_some_other_UBO_a_Contact_Person": "In order to delete this person, you need to make another UBO the main contact person.",
    "ID_card_expiration_date": "ID card expiration date",
    "Other_Directors": "Director ",
    "Directors_Not_Found": "There are no other directors (individual) yet",
    "Add_Director": "Add",
    "Add_Permanent_Representative": "Add",
    "Company_directors": "Directors (company)",
    "Add_Company_director": "Add",
    "is_a_Company_director_Of": "is a director of",
    "Add_companies_directed_by": "Add",
    "Company_Director": "Director (company)\n\n",
    "Remove_Link": "Remove role",
    "PermanentRepresentative_Not_Found": "There are no permanent representatives yet",
    "Ultimate_Beneficial_Owner_of": "Ultimate Beneficial Owner of",
    "Other_director_of": "Director of",
    "Add_Company": "Add",
    "KBO_number": "CBE number",
    "OD": "Director ",
    "Permanent_representative_of": "Permanent responsible of",
    "Company_directors_not_found": "There are no directors (company) yet",
    "{{customerName}}_is_not_a_director_of_any_company": "{{customerName}} is not a director of any company",
    "Permanent_representatives": "Permanent Representatives",
    "Status_identification": "Identification",
    "ID_Cards": "IDs",
    "Verification": "Verification report",
    "CAP": "CAP",
    "CAP_Date": "CAP Date",
    "Risk": "Risk",
    "New_Assessment": "New CAP",
    "Labels": "Labels",
    "Go_to_customer_details": "Open relation record",
    "Company_directors_of": "Directors (company) of"
  },
  "upload-details-slider": {
    "Loading_": "Loading ...",
    "Uploads": "Attachments",
    "File_Name": "Name",
    "Source": "Source",
    "Uploaded_Date": "Uploaded date",
    "Remarks": "Remarks",
    "Delete": "Delete",
    "Save": "Save"
  },
  "uploads": {
    "Loading_": "Loading ...",
    "Uploads": "Attachments",
    "New_Upload": "Upload file",
    "Name_of_Uploads_File": "Name",
    "Action": "Action",
    "Uploads_Not_Found": "This client has none of these files available. You can upload a file at the top right.",
    "Download_File": "Download",
    "Details": "Details",
    "Delete": "Delete",
    "No_uploads_available": "This client has none of these files available. ",
    "ID_Cards": "Identity cards",
    "Verification": "Verification report",
    "Snapshot": "Snapshot",
    "Other": "Other",
    "UBO": "UBO",
    "Director": "Director ",
    "Private_person_id": "Identity card",
    "Permanent_representative": "Permanent representative",
    "PR_of_Company_Director": "Permanent representative of \"company director\"",
    "Download_disable_reason": "Cannot be downloaded yet as the customer is not saved yet. Please save/update the customer to enable downloading.",
    "Rename_file": "Rename file",
    "Rename_disable_reason": "Cannot be renamed yet as the customer is not saved yet. Please save/update the customer to rename the file",
    "UBO_Register": "UBO register",
    "Upload_Other_Documents": "Upload documents",
    "Upload_UBO_Register": "Upload UBO register PDF",
    "Only_PDF_files_allowed_for_UBO_Register": "Only PDF files are allowed for UBO register uploads.",
    "UPLOAD_UBO_DISABLED_NO_KBO": "The UBO file upload is disabled because no enterprise number is registered for this relation.",
    "File_Not_Previewable": "This file type cannot be previewed.",
    "File_Preview_Failed": "Failed to open file preview.",
    "File_Download_Failed": "Failed to download file.",
    "File_Network_Or_Cors_Error": "Could not reach the file storage. Please check your connection and try again.",
    "File_Preview_Popup_Blocked": "Your browser blocked the preview window.",
    "Open_File": "Open file",
    "View_File": "Preview file",
    "Delete_file": "Delete file",
    "File_Deleted_Successfully": "File deleted successfully.",
    "Notes": "Notes",
    "note_attachment": "This file is linked to a note and cannot be deleted.",
    "Preview_Not_Supported": "Preview not supported",
    "Preview_Not_Supported_Download_Instead": "This file type can't be previewed. Would you like to download it instead?"
  },
  "dashboard": {
    "Dashboard": "Statistics",
    "Internal_Policy": "Internal policy",
    "Company_Assessment": "Customer assessment",
    "General_Settings": "Settings",
    "Account": "Account",
    "Audit_Logs": "Audit Logs",
    "Internal_users": "Internal users",
    "Email_Setting": "Email Settings",
    "Settings": "Settings",
    "Logout": "Logout",
    "app-panel-user": "User",
    "read-only-user": "Read-only user",
    "admin": "Admin",
    "amlco-officer": "AML Officer",
    "Customer_Assessment": "Customer assessment",
    "AMLCO_Education": "AML Education",
    "Support": "Customer Support",
    "Overview_customers": "Overview customers",
    "Esigning": "E-signatures",
    "Archived_customers": "Archive",
    "Integrations": "Integrations",
    "Overview_persons": "Overview persons",
    "Overview_companies": "Overview companies",
    "Adverse_media": "Adverse media",
    "Sanctions_and_mandates": "Sanctions lists",
    "KYC_Activity": "Monitoring",
    "Sanctions": "Sanctions",
    "Political_involvements": "Political link",
    "Warnings": "Warnings"
  },
  "warnings": {
    "Only_show_customers_found_on_a_list": "Only show customers found on a list",
    "Actions": "Actions",
    "Load_error": "The customers could not be loaded. Please try again."
  },
  "label-management-modal": {
    "Loading_": "Loading ...",
    "Label_Management": "Label Management",
    "Label": "Label",
    "Enter_Label": "Enter Label",
    "Add_Selected_Labels": "Add Selected Labels",
    "Remove_Selected_Labels": "Remove Selected Labels",
    "Change_labels_to_selected_labels": "Change labels to selected labels"
  },
  "new-dashboard": {
    "Internal_Policy": "Internal Policy",
    "Company_Assessment": "Customer assessment",
    "Customer_Assessment": "Customer assessment",
    "Good_Morning": "Good morning",
    "Good_Afternoon": "Good afternoon",
    "Good_Evening": "Good evening"
  },
  "panel-loader": {
    "Loading_": "Loading ..."
  },
  "refactored-dashboard": {
    "Loading_": "Loading ...",
    "TOTAL_CAPS": "Amount of CAP's",
    "TOTAL_NOTIFICATIONS_CFI": "Number of notifications CFI",
    "TOTAL_COMPANIES": "Number of customers added",
    "RISK_LEVEL": "Risk level",
    "MONTHLY_OVERVIEW": "Monthly overview",
    "STANDARD_OR_HIGH": "Standard or high",
    "No_Data_Found": "No Data Found",
    "Dashboard": "Statistics",
    "Risk_Level": "Risk level",
    "Standard": "Standard",
    "High": "High",
    "Companies_Incomplete_ID_card_info": "Customers with incomplete ID card information",
    "Companies_expired_ID_card": "Customers with expired ID cards",
    "Status_CAP": "Status CAP",
    "Overview_of_the_status_of_the_CAPs": "Overview of the status of the CAP's",
    "Status_identification": "Status identification",
    "Overview_of_the_status_of_the_identifications": "Overview of the status of the identifications",
    "Customer_accepted": "Customer accepted",
    "Customer_not_accepted": "Customer not accepted",
    "CAP_in_progress": "CAP in progress",
    "CAP_not_started": "CAP not started",
    "Completed": "Completed",
    "Not_started": "Not started",
    "In_progress": "In progress"
  },
  "audit-logs": {
    "{{taskName}}_created_with_review_workflow_{{workflowName}}_assigned": "{{taskName}} created with review workflow {{workflowName}} assigned",
    "{{taskName}}_re_assigned_to_review_workflow_{{workflowName}}": "{{taskName}} re-assigned to review workflow {{workflowName}}",
    "Review_workflow_{{workflowName}}_removed_from_{{taskName}}_task": "Review workflow {{workflowName}} removed from {{taskName}} task",
    "{{taskName}}_step_{{stepNo}}_{{stepName}}_assignees_changed_to_{{assigneeNames}}": "{{taskName}} step {{stepNo}} ({{stepName}}) assignees changed to {{assigneeNames}}",
    "{{taskName}}_review_workflow_completion_notification_recipients_changed_to_{{assigneeNames}}": "{{taskName}} review workflow completion notification recipients changed to {{assigneeNames}}",
    "{{taskName}}_step_{{stepNo}}_{{stepName}}_completed_by_{{assigneeName}}": "{{taskName}}: Step {{stepNo}} ({{stepName}}) completed by {{assigneeName}}",
    "{{taskName}}_step_{{stepNo}}_{{stepName}}_completed_by_{{assigneeName}}_with_comment_{{comment}}": "{{taskName}}: Step {{stepNo}} ({{stepName}}) completed by {{assigneeName}} with comment: {{comment}}",
    "{{taskName}}_step_{{stepNo}}_{{stepName}}_completed_when_{{assigneeName}}_removed_its_last_pending_assignee": "{{taskName}}: Step {{stepNo}} ({{stepName}}) completed automatically when {{assigneeName}} removed its last pending assignee",
    "{{taskName}}_step_{{stepNo}}_{{stepName}}_signed_by_{{assigneeName}}": "{{taskName}}: Step {{stepNo}} ({{stepName}}) signed by {{assigneeName}}",
    "{{taskName}}_step_{{stepNo}}_{{stepName}}_rejected_by_{{assigneeName}}": "{{taskName}}: Step {{stepNo}} ({{stepName}}) rejected by {{assigneeName}}",
    "{{taskName}}_step_{{stepNo}}_{{stepName}}_rejected_by_{{assigneeName}}_with_comment_{{comment}}": "{{taskName}}: Step {{stepNo}} ({{stepName}}) rejected by {{assigneeName}} with comment: {{comment}}",
    "{{taskName}}_step_{{stepNo}}_{{stepName}}_signature_request_sent_to_{{assigneeNames}}": "{{taskName}}: Step {{stepNo}} ({{stepName}}) signature request sent to {{assigneeNames}}",
    "{{taskName}}_step_{{stepNo}}_{{stepName}}_declined_in_the_signing_portal_by_{{assigneeName}}": "{{taskName}}: Step {{stepNo}} ({{stepName}}) rejected by {{assigneeName}} in the signing portal",
    "{{taskName}}_rejected_step_{{stepNo}}_{{stepName}}_revised_by_{{rejectionAssigneeName}}": "{{taskName}} rejected step {{stepNo}} ({{stepName}}) revised by {{rejectionAssigneeName}}",
    "{{taskName}}_step_{{stepNo}}_{{stepName}}_skipped_because_its_conditions_were_not_met": "{{taskName}} step {{stepNo}} ({{stepName}}) skipped because its conditions were not met",
    "{{taskName}}_review_workflow_{{workflowName}}_completed": "{{taskName}} review workflow {{workflowName}} completed",
    "{{taskName}}_archived_while_review_workflow_{{workflowName}}_was_running": "{{taskName}} archived while review workflow {{workflowName}} was running",
    "{{taskName}}_deleted_while_review_workflow_{{workflowName}}_was_running": "{{taskName}} deleted while review workflow {{workflowName}} was running",
    "Loading_": "Loading ...",
    "Users": "Users",
    "Module": "Module",
    "Action": "Action",
    "Date_range": "Date range",
    "Language": "Language",
    "Fetch": "Search",
    "User": "User",
    "Location": "Establishment",
    "Extra": "Additional",
    "Audit_logs": "Audit logs",
    "First_name_changed_to_{{firstName}}": "First name changed to {{firstName}}",
    "Last_name_changed_to_{{lastName}}": "Last name changed to {{lastName}}",
    "Email_changed_to_{{email}}": "Email changed to {{email}}",
    "Responsible_changed_to_{{responsible}}": "Responsible changed to {{responsible}}",
    "Customer_type_changed_to_{{customerType}}": "Customer type changed to {{customerType}}",
    "Time": "Time",
    "Section": "Section",
    "Sections": "Sections",
    "Actions": "Actions",
    "ID_card_expiration_date_changed_to_{{idCardExpirationDate}}": "ID card expiration date changed to {{idCardExpirationDate}}",
    "Added_{{fileName}}_under_Identity_cards": "{{fileName}} added to the \"identity cards\" section",
    "Deleted_{{fileName}}_under_Identity_cards": "{{fileName}} deleted from the \"identity cards\" section",
    "Added_{{fileName}}_under_Identity_Cards": "{{fileName}} added to the \"identity cards\" section",
    "Deleted_{{fileName}}_under_Identity_Cards": "{{fileName}} deleted from the \"identity cards\" section",
    "Added_{{fileName}}_under_Verification": "{{fileName}} added to the \"verification reports\" section",
    "Deleted_{{fileName}}_under_Verification": "{{fileName}} deleted from the \"verification reports\" section",
    "Added_{{fileName}}_under_Snapshot": "{{fileName}} added to the \"snapshot\" section",
    "Deleted_{{fileName}}_under_Snapshot": "{{fileName}} deleted from the \"snapshot\" section",
    "Added_{{fileName}}_under_Others": "{{fileName}} added to the \"other\" section",
    "Deleted_{{fileName}}_under_Others": "{{fileName}} added to the \"other\" section",
    "This_customer_changed_to_{{customerType}}_customer": "The customer type of this customer was changed to {{customerType}}",
    "This_customer_archived": "The customer was archived",
    "This_customer_unarchived": "The customer was unarchived",
    "Task_created_for_category_{{categoryName}}": "The following task was created: {{categoryName}}",
    "{{categoryName}}_task_created_with_{{userName}}_assigned": "The following task was created: {{categoryName}}, with {{userName}} assigned",
    "Mail_sent_for_{{categoryName}}_task": "An email was sent for the following task: {{categoryName}}",
    "{{categoryName}}_task_reopened": "The following task was reopened: {{categoryName}}",
    "{{categoryName}}_task_deleted": "The following task was deleted: {{categoryName}}",
    "Automatic_reminder_sent_for_{{categoryName}}_task": "An automatic reminder for the following task was sent: {{categoryName}}",
    "Manual_reminder_sent_for_{{categoryName}}_task": "A manual reminder for the following task was sent: {{categoryName}}",
    "Mail_sent_for_{{categoryName}}_task_to_internal_user_{{userName}}": "An email regarding the following task was sent to {{userName}}: {{categoryName}}",
    "Automatic_reminder_sent_for_{{categoryName}}_task_to_internal_user_{{userName}}": "An automatic reminder for the following task was sent to {{userName}}: {{categoryName}}",
    "Manual_reminder_sent_for_{{categoryName}}_task_to_internal_user_{{userName}}": "An automatic reminder for the following task was sent to {{userName}}: {{categoryName}}",
    "Deleted_company_{{companyName}}_from_Company_Directors": "The following company was deleted as a director: {{companyName}}",
    "Deleted_company_{{companyName}}_for_which_{{currentCompanyName}}_is_Company_Director": "The following company was deleted as being directed by {{currentCompanyName}}: {{companyName}}",
    "E_signing_document_{{documentName}}_is_in_{{status}}_status": "The e-sign status of the document \"{{documentName}}\" was updated to {{status}}",
    "Document_{{documentName}}_sent_for_E_signing": "The following document was sent to be signed: {{documentName}}",
    "Reminder_sent_for_E_signing_document_{{documentName}}": "A reminder for the signature of the following document was sent: {{documentName}}",
    "Automatic_reminder_{{automaticReminderStatus}}": "Automatic reminder {{automaticReminderStatus}}",
    "Customer_found_under_Financial_Crimes_and_Money_Laundering": "Customer linked to financial crimes and money laundering in AI adverse media check",
    "Customer_removed_from_Financial_Crimes_and_Money_Laundering": "Customer unlinked from financial crimes and money laundering in AI adverse media check",
    "Customer_found_under_Terrorism_and_crime": "Customer linked to terrorism and crime in AI adverse media check",
    "Customer_removed_from_Terrorism_and_crime": "Customer unlinked from terrorism and crime in AI adverse media check",
    "Customer_found_under_Corruption_and_Bribery": "Customer linked to corruption and bribery in AI adverse media check",
    "Customer_removed_under_Corruption_and_Bribery": "Customer unlinked from corruption and bribery in AI adverse media check",
    "Customer_found_under_Litigation_and_Legal_Issues": "Customer linked to litigation and legal issues in AI adverse media check",
    "Customer_removed_under_Litigation_and_Legal_Issues": "Customer unlinked from litigation and legal issues in AI adverse media check",
    "Customer_found_under_National_sanctions_list": "Customer found on National Sanctions List (BE)",
    "Customer_removed_from_National_sanctions_list": "Customer removed from National Sanctions List (BE)",
    "Customer_found_under_European_sanctions_list": "Customer found on European Sanctions List",
    "Customer_removed_from_European_sanctions_list": "Customer removed from European Sanctions List",
    "Customer_found_under_European_travel_ban_list": "Customer found on European Travel Ban List",
    "Customer_removed_from_European_travel_ban_list": "Customer removed from European Travel Ban List",
    "Customer_found_under_UN_sanctions_list": "Customer found on UN Sanctions List",
    "Customer_removed_from_UN_sanctions_list": "Customer removed from UN Sanctions List",
    "Customer_found_under_Political_mandate_(PDF)": "Political mandate found for customer (source: Belgian Court of Audit)",
    "Customer_removed_from_Political_mandate_(PDF)": "Political mandate removed for customer (source: Belgian Court of Audit)",
    "Customer_found_under_Political_mandate_(CSV)": "Political mandate found for customer (source: Flemish Mandate Database)",
    "Customer_removed_from_Political_mandate_(CSV)": "Political mandate removed for customer (source: Flemish Mandate Database)",
    "Search_for_a_user": "Search for a user",
    "Search_for_a_module": "Search for a module",
    "Search_for_an_action": "Search for an action",
    "Customer_Details": "Customer details",
    "Communication": "Communication",
    "Company_added_in_UBO": "Company added to the Belgian UBO register",
    "Company_added_in_Other_director": "Company added in Other director",
    "Company_added_in_Permanent_responsible": "Company added in Permanent responsible",
    "CAP_date_changed": "CAP date updated",
    "Company_risk_changed": "Customer risk score updated",
    "New_CAP_date_changed": "New CAP date updated",
    "Removed_company_in_UBO_link": "Removed company in UBO link",
    "Deleted_company_in_UBO": "Deleted company in UBO",
    "Removed_Other_Director_link": "Removed Other Director link",
    "Deleted_company_in_Other_Director": "Deleted company in Other Director",
    "Removed_Other_Permanent_Responsible": "Removed Other Permanent Responsible",
    "Deleted_company_in_Permanent_Responsible": "Deleted company in Permanent Responsible",
    "Person_added_in_UBO": "Person added in UBO",
    "Person_added_in_Other_Director": "Person added in Other Director",
    "Person_added_in_Company_Director": "Person added in Company Director",
    "Audit_Log_List_Not_Found": "No audit logs yet",
    "Company_name_changed_to_{{name}}": "Company name changed to {{name}}",
    "{{categoryName}}_marked_as_completed_with_{{progress}}": "The following task was marked as completed: {{categoryName}}",
    "Task": "Task",
    "ID_card": "ID card",
    "Relations": "Relations",
    "ESigning": "E-signing",
    "Attachment": "Attachment",
    "Adverse_Media": "Adverse media",
    "Sanctions_and_Mandates": "Sanctions lists",
    "Edited_Customer_Details": "Updated Customer Details",
    "Archived_Customer": "Archived customer",
    "Unarchived_Customer": "Unarchived Customer",
    "Created_task": "Created task",
    "Sent_mail_for_task": "Sent mail for task",
    "Completed_task": "Completed task",
    "Reopened_task": "Reopened task",
    "Deleted_task": "Deleted task",
    "Changed_ID_card_expiration_date": "Changed ID card expiration date",
    "Sent_reminder_for_task": "Sent reminder for task",
    "Updated_ESigning_document_status": "Updated E-signing document status",
    "Sent_document_for_ESigning": "Document sent to be signed",
    "Sent_reminder_for_ESigning_document": "Reminder sent for digital signature",
    "Added_file": "Added file",
    "Deleted_file": "Deleted file",
    "Found_customer_under_adverse_media": "Adverse media found for customer",
    "Removed_customer_under_adverse_media": "Adverse media removed for customer",
    "Found_customer_under_sanctions_and_mandates": "Sanctions and mandates found for customer",
    "Removed_customer_under_sanctions_and_mandates": "Sanctions and mandates found for customer",
    "Changed_automatic_reminder": "Changed automatic reminder",
    "Became_UBO": "Became UBO",
    "Became_director": "Became director",
    "Became_PR": "Became permanent representative",
    "Removed_UBO_link": "UBO link removed",
    "Removed_director_link": "Director link removed",
    "Removed_PR_link": "Permanent representative link removed",
    "Deleted_company": "Company deleted",
    "Added_UBO": "UBO added",
    "Added_director": "Director added",
    "Added_PR": "Permanent representative added",
    "Deleted_UBO": "UBO deleted",
    "Deleted_director": "Director deleted",
    "Deleted_PR": "Permanent representative deleted",
    "Deleted_company_director": "Company director deleted",
    "Removed_company_director": "Company director removed",
    "{{customerName}}_Became_An_{{relation}}_of_company_{{companyName}}": "{{customerName}} became a '{{relation}}' of {{companyName}}",
    "Removed_Link_Between_{{companyName}}_and_{{relation}}_{{customerName}}": "The \"{{relation}}\" link between {{companyName}} and {{customerName}} was removed",
    "Deleted_company_{{companyName}}_for_which_{{customerName}}_is_{{relation}}": "{{companyName}} for which {{customerName}} is '{{relation}}' was deleted",
    "Added_private_person_{{customerName}}_as_{{relation}}_of_{{companyName}}": "{{customerName}} was added as '{{relation}}'",
    "Added_company_{{companyName}}_as_Company_Director": "{{companyName}} was added as 'director'.",
    "{{currentCompany}}_became_Company_Director_of_company_{{newAddedCompanyName}}": "{{currentCompany}} became 'director' of {{newAddedCompanyName}}",
    "Removed_link_of_private_person_{{customerName}}_from_{{relation}}_of_{{companyName}}": "The \"{{relation}}\" link between {{customerName}} and {{companyName}} was removed",
    "Deleted_private_person_{{customerName}}_from_{{relation}}": "{{customerName}} was deleted as '{{relation}}'",
    "Removed_link_of_company_{{companyName}}_from_Company_Directors": "{{companyName}} was removed as \"director\"",
    "Removed_link_of_company_{{companyName}}_for_which_{{currentCompanyName}}_is_Company_Director": "The link \"director\" between {{currentCompanyName}} and {{companyName}} was removed",
    "UBO": "UBO",
    "Director": "Director",
    "Company_Director": "Director",
    "Permanent_Representative": "Permanent representative",
    "Customer_removed_from_Political_mandate_PDF": "Political mandate removed for customer (source: Belgian Court of Audit)",
    "Customer_found_under_Political_mandate_CSV": "Political mandate found for customer (source: Flemish Mandate Database)",
    "Customer_found_under_Political_mandate_PDF": "Political mandate found for customer (source: Belgian Court of Audit)",
    "Customer_removed_under_Political_mandate_CSV": "Political mandate removed for customer (source: Flemish Mandate Database)",
    "Sub_Section": "Sub-section",
    "Companies": "Relations",
    "Search_for_a_company": "Search for a company",
    "Rejected_suggestion_for_{{customerName}}_as_{{role}}": "AMLCare suggested to add {{customerName}} as '{{role}}'. This suggestion was rejected.",
    "Task_for_{{categoryName}}_assigned_to_internal_user_{{userName}}": "The task \"{{categoryName}}\" was assigned to {{userName}}",
    "Today": "Today",
    "Task_for_{{categoryName}}_archived_by_internal_user_{{userName}}": "The task {{categoryName}} was archived",
    "Deleted_{{fileName}}_under_UBO_Register": "The file \"{{fileName}}\" in the UBO register section was deleted",
    "Added_{{fileName}}_under_UBO_Register": "The file \"{{fileName}}\" in the UBO register section was added",
    "Minfin_configuration": "UBO synchronization configuration",
    "Rejected_suggestion": "Suggestion rejected",
    "Minfin_enabled": "UBO connection enabled",
    "Minfin_disabled": "UBO connection disabled",
    "Minfin_sync_type_changed": "The synchronization type regarding the UBO connection was changed",
    "Minfin_individual_sync_started": "The individual UBO synchronization was started",
    "Assigned_task_to_internal_user": "Assigned task",
    "minfin_enabled_to_false": "The UBO synchronization was disabled",
    "minfin_enabled_to_true": "The UBO synchronization was enabled",
    "minfin_sync_type_changed_{{type}}": "The synchronization type regarding the UBO connection was changed to {{type}}",
    "minfin_individual_sync_started_for_{{kboNumber}}": "The UBO synchronization started for {{kboNumber}}",
    "TASK_PROGRESS_PERCENTAGE_CHANGED_for_{{categoryName}}_{{progress}}": "The progress of the task {{categoryName}} changed to {{progress}}%",
    "The_following_task_was_marked_as_completed_{{categoryName}}_with_{{risk}}_risk": "The task {{categoryName}} was marked as completed with a {{risk}} risk level",
    "The_risk_was_overridden_from_{{oldRisk}}_to_{{newRisk}}_by_user_{{userName}}_with_the_following_justification_{{justification}}": "The risk was overridden from {{oldRisk}} to {{newRisk}} by {{userName}} with the following justification: {{justification}}",
    "Risk_overridden": "Risk override",
    "UBO_share_percentage_changed_for_{{company}}_to_{{newPercentage}}": "The UBO share percentage for {{company}} was updated to {{newPercentage}}",
    "Risk_accepted": "Risk accepted",
    "The_customer_was_accepted_with_risk_level_{{riskLevel}}_by_user_{{userName}}_with_the_following_reason_{{justification}}": "The relation was accepted with risk level {{riskLevel}} by {{userName}} with the following reason: {{justification}}",
    "{{labels}}_labels_added_in_customer": "The following label(s) were added: {{labels}}",
    "{{labels}}_labels_removed_from_customer": "The following label(s) were removed: {{labels}}",
    "Customer_Created": "Customer created",
    "App": "Manual update",
    "Bot": "Questionnaire",
    "Admin_Pulse": "AdminPulse",
    "UBO_sync": "UBO Synchronization",
    "Developer_API": "Developer API",
    "Webhook": "Webhook",
    "Excel": "Excel import",
    "Auto_Check": "Automated check",
    "Source": "Source",
    "Sources": "Sources",
    "Search_for_a_source": "Search for a source",
    "Notes": "Notes",
    "Note_created": "Note created",
    "Note_title_edited": "Note title edited",
    "Note_description_edited": "Note description edited",
    "Note_deleted": "Note deleted",
    "Comment_added": "Comment added",
    "Comment_edited": "Comment edited",
    "Comment_deleted": "Comment deleted",
    "Note_created_{{noteTitle}}": "Note created: {{noteTitle}}",
    "Note_edited_{{noteTitle}}": "Note title updated: {{noteTitle}}",
    "Note_{{noteTitle}}_description_edited_{{noteDescription}}": "Note description updated for '{{noteTitle}}': {{noteDescription}}",
    "Note_deleted_{{noteTitle}}": "Note deleted: {{noteTitle}}",
    "Comment_added_on_{{noteTitle}}": "Comment added on note: {{noteTitle}}",
    "Comment_on_{{noteTitle}}_edited_{{commentContent}}": "Comment edited on note '{{noteTitle}}': {{commentContent}}",
    "Comment_deleted_on_{{noteTitle}}": "Comment deleted on note: {{noteTitle}}",
    "Attachment_added": "Attachment added",
    "Attachment_deleted": "Attachment deleted",
    "Attachment_deleted_on_comment_of_note_{{noteTitle}}": "Attachment deleted on comment of note: {{noteTitle}}",
    "Attachment_added_on_{{noteTitle}}": "Attachment added on note: {{noteTitle}}",
    "Attachment_deleted_on_{{noteTitle}}": "Attachment deleted on note: {{noteTitle}}",
    "Attachment_added_on_comment_of_note_{{noteTitle}}": "Attachment added on comment of note: {{noteTitle}}",
    "Customer_code_added_{{customerCode}}": "Customer code added: {{customerCode}}",
    "Customer_code_removed": "Customer code removed",
    "Customer_code_changed_to_{{customerCode}}": "Customer code changed to {{customerCode}}",
    "The_customer_was_not_accepted_with_risk_level_{{riskLevel}}_by_user_{{userName}}": "The customer was not accepted with risk level {{riskLevel}} by {{userName}}",
    "Customer_not_accepted": "Customer not accepted",
    "Monitoring": "Monitoring",
    "Monitoring_event_reviewed_as_correct": "Monitoring event reviewed as correct",
    "Monitoring_event_reviewed_as_not_correct": "Monitoring event reviewed as not correct",
    "Monitoring_event_re_reviewed": "Monitoring event re-reviewed",
    "Monitoring_event_assigned": "Monitoring event assigned",
    "Monitoring_event_re_assigned": "Monitoring event re-assigned",
    "Unassigned_monitoring_event": "Monitoring event unassigned",
    "Comment_added_to_monitoring_event": "Comment added to monitoring event",
    "Comment_edited_on_monitoring_event": "Comment edited on monitoring event",
    "Comment_deleted_from_monitoring_event": "Comment deleted from monitoring event",
    "Sources_marked_on_monitoring_event": "Sources marked on monitoring event",
    "Attachment_added_to_monitoring_event": "Attachment added to monitoring event",
    "Attachment_deleted_from_monitoring_event": "Attachment deleted from monitoring event",
    "Monitoring_event_{{sectionName}}_{{change}}_reviewed_as_correct": "Monitoring event ({{sectionName}}: {{change}}) reviewed as Correct.",
    "Monitoring_event_{{sectionName}}_{{change}}_reviewed_as_not_correct_{{status}}_warning_updated": "Monitoring event ({{sectionName}}: {{change}}) reviewed as Not correct: {{status}}. Warning updated to \"No results\".",
    "Monitoring_event_{{sectionName}}_{{change}}_reviewed_as_not_correct_{{status}}": "Monitoring event ({{sectionName}}: {{change}}) reviewed as Not correct: {{status}}.",
    "Monitoring_event_{{sectionName}}_{{change}}_reviewed_as_previous_results_still_apply_warning_updated": "Monitoring event ({{sectionName}}: {{change}}) reviewed as Previous results still apply. Warning updated to the previous results.",
    "Monitoring_event_re_reviewed_{{change}}_status_updated_from_{{oldStatus}}_to_{{newStatus}}": "Monitoring event re-reviewed: {{change}}. Status updated from {{oldStatus}} to {{newStatus}}.",
    "Sources_marked_on_{{change}}_{{accurateCount}}_accurate_{{inaccurateCount}}_not_accurate": "Sources marked on {{change}}: {{accurateCount}} accurate, {{inaccurateCount}} not accurate.",
    "Monitoring_event_assigned_to_{{user}}": "Monitoring event assigned to {{user}}.",
    "Monitoring_event_re_assigned_from_{{originalUser}}_to_{{user}}": "Monitoring event re-assigned from {{originalUser}} to {{user}}.",
    "Monitoring_event_unassigned": "Monitoring event unassigned.",
    "Comment_added_to_monitoring_event_{{change}}": "Comment added to monitoring event: {{change}}.",
    "Comment_edited_on_monitoring_event_{{change}}": "Comment edited on monitoring event: {{change}}.",
    "Comment_deleted_from_monitoring_event_{{change}}": "Comment deleted from monitoring event: {{change}}.",
    "Attachment_added_to_monitoring_event_{{fileName}}": "Attachment added to monitoring event: {{fileName}}",
    "Attachment_deleted_from_monitoring_event_{{fileName}}": "Attachment deleted from monitoring event: {{fileName}}"
  },
  "account": {
    "Loading_": "Loading ...",
    "Account_Settings": "Account settings",
    "Profile": "Profile",
    "Name": "Name",
    "Email": "Email",
    "Phone_Number": "Mobile number",
    "Address": "Address",
    "Update": "Update",
    "Security_Settings": "Security settings",
    "Current_Password": "Current password",
    "New_Password": "New password",
    "Reenter_Password": "Re-enter the new password",
    "Change_Password": "Change password",
    "TFA_Settings": "TFA Settings",
    "Scan_the_QR_code_in_GoogleAuthenticator": "Scan the QR code in your authenticator app",
    "Auth_Type_Time_Based_OTP": "Enter the authentication code (OTP)",
    "Enter_the_auth_code": "Enter the authentication code (OTP)",
    "Enable": "Enable",
    "Disable_TFA": "Disable TFA",
    "Enter_otp": "Enter the authentication code (OTP)",
    "Disable": "Disable",
    "account": "Account"
  },
  "document-setting": {
    "Loading_": "Loading !",
    "Color_Scheme": "Color scheme",
    "Primary": "Primary",
    "Secondary": "Secondary",
    "Header": "Header",
    "Bot_Message_Background": "Question: background",
    "Bot_Message_Text": "Question: text",
    "User_Message_Background": "Answer: background",
    "User_Message_Text": "Answer: text",
    "Button_Background": "Button: background",
    "Button_Text": "Button: text",
    "Bot_Image": "Favicon",
    "Choose_file": "Upload file",
    "Background_Image": "Background image",
    "Bot_Logo": "Logo",
    "Save": "Save",
    "Live_PreviewReduced_by_50": "Live Preview(Reduced by 50%)",
    "Personal_Details": "Personal data",
    "Name": "Name",
    "Email": "Email",
    "Address": "Address",
    "Business_Details": "Business Details",
    "Final_Submit": "Submit",
    "More_Info": "More info",
    "Next": "Next",
    "Enter_name": "Enter name",
    "Demo_name": "Demo name",
    "Enter_email": "Enter email",
    "demomailcom": "demo@mail.com",
    "Enter_address": "Enter address",
    "Please_enter_address": "Please enter address",
    "Document_Design": "Design"
  },
  "email-content": {
    "List_Of_Email_Contentnbsp": "List of email templates",
    "Reset": "Reset",
    "Save": "Save",
    "Email_Content": "Content email",
    "Send_Email": "Send email",
    "Language": "Language",
    "Email_Title": "Email title",
    "Email_Subject": "Email subject",
    "Email_Text": "Email text",
    "Email_Button_Text": "Email button text",
    "Email_Button_Link": "Email button link",
    "Use_Default_Design": "Use default design",
    "Email_Colors": "Email colors",
    "Primary_Color": "Primary color",
    "Secondary_Color": "Secondary color",
    "Background_Color": "Background color",
    "Title_Color": "Title color",
    "Text_Color": "Text color",
    "Email_Logo": "Email logo",
    "Upload_Logo": "Upload logo",
    "Logo_Preview": "Logo preview",
    "Email_Preview": "Email preview"
  },
  "email-content-list": {
    "List_Of_Email_Content": "List Of Email Content",
    "Email_Title": "Email Title",
    "Status": "Status"
  },
  "email-design": {
    "Email_Default_Design": "Default design email",
    "Save": "Save",
    "Email_Design": "Email design",
    "Email_Colors": "Email colors",
    "Primary_Color": "Primary color",
    "Secondary_Color": "Secondary color",
    "Background_Color": "Background color",
    "Title_Color": "Title color",
    "Text_Color": "Text color",
    "Email_Logo": "Email logo",
    "Upload_Logo": "Upload logo",
    "Upload_Preview": "Logo preview",
    "Email_Preview": "Email preview",
    "Contract_Invitation": "Document invitation",
    "Dear_customer": "Dear customer,",
    "Click_on_Startconversation_below_to_prepare_yourdemocontract_for_xyz": "Click on 'Start conversation' below to prepare your demo-contract for xyz.",
    "Thank_you_inadvance": "Thank you in advance.",
    "Start_Conversion": "Start Conversion"
  },
  "email-setting": {
    "Loading_": "Loading ...",
    "Domain": "Domain",
    "Content": "Content",
    "Design": "Design",
    "Advanced_label_management": "Advanced label management"
  },
  "email-domain": {
    "Domain_Settings": "Domain settings",
    "Name": "Name",
    "Email": "Email",
    "Domain": "Domain",
    "Advance_Settings": "Advanced settings",
    "Use_a_custom_DKIM_selector": "Use a custom DKIM selector",
    "Custom_DKIM_selector": "Custom DKIM selector",
    "Use_custom_return_path": "Use custom return path",
    "Custom_return_path": "Custom return path",
    "Use_automated_security": "Use automated security",
    "Check": "Verify",
    "Checked_Details": "Details of the verification",
    "Type": "Type",
    "Host": "Host",
    "Data": "Data",
    "Validate": "Validate",
    "Validate_Details": "Details of the validation",
    "Close": "Close",
    "Email_Setting": "Email settings",
    "Success": "Updated successfully.",
    "Your_Domain_successfully_validated": "Your domain is successfully validated",
    "Are_you_sure": "Are you sure that you want to disable sending emails from your domain?",
    "You_want_to_off_send_mail_from_your_domain": "If you disable this, future emails will be sent from a generic Accounton email address.",
    "Yes_off_it": "Yes, turn it off",
    "No_keep_it": "No, keep it"
  },
  "internal-users-list": {
    "Loading_": "Loading ...",
    "Search": "Search",
    "Filter_By": "Filter By",
    "Name": "Name",
    "Email": "Email",
    "Role": "Role",
    "Action": "Action",
    "Edit": "Edit",
    "Delete": "Delete",
    "app-panel-user": "User",
    "read-only-user": "Read-only user",
    "admin": "Admin",
    "amlco-officer": "AML Compliance Officer",
    "Internal_Users": "Internal users",
    "Label_Management": "Label management",
    "Add_User": "Add user",
    "No_users_found": "No users found",
    "Deletion_blocked_title": "Cannot delete: {{userName}}",
    "Deletion_blocked_description": "Complete the workflow, or reassign {{userName}} from the steps listed below, then try deleting this user again.",
    "Deletion_workflow_column": "Workflow",
    "Deletion_step_column": "Step"
  },
  "internal-user": {
    "Loading_": "Loading ...",
    "Users": "Users",
    "Name": "Name",
    "Email": "Email",
    "Contact_No": "Mobile number",
    "Role_Selection": "Role",
    "Address": "Address",
    "Label": "Label",
    "Enter_Label": "Enter Label",
    "User_Inserted_Successfully": "User successfully added",
    "Password": "Password",
    "Ok": "Close",
    "Add_User": "Add user",
    "Update_User": "Update user"
  },
  "body": {
    "Save_and_go_to_next": "Save and go to next",
    "Save": "Save",
    "Next": "Next",
    "Please_answer_all_questions_on_this_matter": "Please answer all questions on this matter",
    "btotalErrorNumber_invalid_answers_foundb_Invalid_answers_wont_be_saved_if_you_choose_to_move_ahead": "<b>{{totalErrorNumber}} invalid answers found.</b> Invalid answers won't be saved if you choose to move ahead.",
    "Please_enter_an_email_address": "Please enter an email address",
    "Please_enter_a_number": "Please enter a number.",
    "Please_enter_a_website": "Please enter a website",
    "Please_select_a_date": "Please select a date",
    "Please_enter_an_address": "Please enter an address",
    "Please_enter_a_phone_number": "Please enter a valid phone number",
    "Please_enter_an_answer": "Please enter an answer",
    "Please_enter_a_proper_IBAN_number": "Please enter a proper IBAN number.",
    "Please_enter_a_proper_nationalregistration_number_eg10201011122": "Please enter a proper national register number",
    "Review_answers": "Review Answers",
    "Move_Ahead": "Move Ahead"
  },
  "chip": {
    "Add": "Add",
    "Do_not_add_new_industry": "It is not possible to add an industry",
    "Do_not_enter_same_answer_once_again": "It is not possible to enter the same answer twice",
    "You_can_not_select_multiple": "It is not possible to enter multiple answers",
    "cancel": "Cancel"
  },
  "error": {
    "Unexpected_token_error_please_validate_it_again": "Unexpected token error, please reload this page after a while.",
    "Customer_archived_error": "You no longer have access to this questionnaire"
  },
  "final-submit-modal": {
    "Submit": "Submit",
    "Click_submit_to_finalize_and_submit_all_your_answers_If_you_wish_you_can_still_edit_your_answers_click_edit_answers_to_do_so": "Click submit to finalize and submit all your answers. If you wish you can still edit your answers, click edit answers to do so.",
    "Edit_Answers": "Edit Answers"
  },
  "form-area": {
    "Your_firm_normally_doesnt_accept_customers_from_this_industry": "Your firm normally doesn’t accept customers from this industry.",
    "Please_select_a_document": "Please select a document",
    "Enter_input_here": "Enter information here",
    "Save": "Save and go to next",
    "Next": "Save",
    "Save_and_go_to_next": "Next",
    "Are_you_sure_you_want_to_delete_this": "Are you sure that you want to delete this?",
    "You_will_not_be_able_to_revert_it": "This will be deleted permanently.",
    "Yes_delete_it": "Yes, delete it",
    "Cancel": "No, keep it",
    "File_Is_Not_Valid": "File is not allowed or not valid.",
    "Standard": "Standard",
    "High": "High",
    "Unknown": "Unknown",
    "Please_add_ubo_ID": "Please upload an identity card",
    "Please_update_the_ID_Card_and_expiry_date_of_this_customer": "This person’s ID card is no longer valid or will expire soon. Please upload a new valid ID card and update the expiration date.",
    "Entered_registration_number_already_exists": "This national registration number is already in use with another customer",
    "Drag_file_here_for_upload": "Drag and drop files here or click here to select file(s)",
    "Mandatory_upload_message": "No document was uploaded yet. It is mandatory to upload a document.",
    "Need_to_update_private_person_idcard_expiry": "This ID card is no longer valid. Please upload the new valid ID card and change the expiry date.",
    "We_found_existing_customer_data_Would_you_like_to_autofill_the_questionnaire": " We found existing customer data based on the entered National Registration Number or KBO Number. Would you like to autofill the questionnaire with this information?",
    "Are_you_sure": "Are you sure?",
    "Customer_having_the_same_number_already_exists_Customer_data_override_with_new_data": "Customer having the same number already exists in App panel, Customer data will be override with this new data",
    "Customer_having_the_same_number_already_exists_you_can't_proceed": "A customer with this registration number already exists in AMLCare. We recommend adding this person via the 'Relations' tab to automatically reuse their existing data (name, email, ID-card details).",
    "Existing_data_found": "Data found in back office",
    "Registration_or_KBO_number_exist_so_prefill": "This relation was recognized. Known fields will be prefilled.",
    "Ok_Continue": "Ok, continue",
    "Only_PDF_files_are_allowed_for_UBO_Register_uploads": "Only PDF files are allowed for UBO register uploads.",
    "Unarchive_to_add_as_relation": "Unarchive to add as relation",
    "This_relation_is_archived_unarchive_them_to_link_them_as_a_relation": "This relation is archived. Unarchive it to link it as a relation.",
    "Unarchive_and_link_customer": "Unarchive and link relation"
  },
  "model": {
    "Save": "Save"
  },
  "progress": {
    "Your_Progress": "Your progress",
    "Reset": "Reset",
    "Help": "Help",
    "Steps_Status": "Steps Status",
    "Completed_Steps": "Completed Steps",
    "Skip_Steps": "Skip Steps",
    "Terms_Condition": "Terms & Conditions",
    "Read_Again": "Read Again"
  },
  "sidebar": {
    "btotalErrorNumber_invalid_answers_foundb_Invalid_answers_wont_be_saved_if_you_choose_to_move_ahead": "<b>{{totalErrorNumber}} invalid answers found.</b> Invalid answers won't be saved if you choose to move ahead.",
    "Review_answers": "Review Answers",
    "Move_Ahead": "Move Ahead"
  },
  "view-conversation": {
    "Customers": "Customers",
    "_Document": "> Questionnaire",
    "Submit": "Submit",
    "Questionnaire_cant_be_modified": "Questionnaire can't be modified",
    "Name": "Name",
    "Status": "Status",
    "Document in progress": "Questionnaire in progress",
    "Sent for signing": "Sent for signing",
    "Mail not sent": "Mail not sent",
    "Signed": "Signed",
    "Action": "Action",
    "status": "Status",
    "hint": "Not yet possible to submit. You have not yet answered all the questions.",
    "Approve_requires_answer_tooltip": "Answer at least one question before approving.",
    "Preview_document_for_signing": "Preview document for signing",
    "Complete_the_questionnaire_to_preview_document": "Complete the questionnaire to view the full document that will be sent for signing after submission.",
    "Preview_not_available": "A preview is not available for this questionnaire.",
    "Document_Conversation": "Overview questionnaire",
    "Click_here_to_sign": "Click here to sign",
    "Reopen_questionnaire": "Reopen questionnaire",
    "Are_you_sure_that_you_want_to_reopen_the_questionnaire": "Are you sure that you want to reopen the questionnaire?",
    "This_questionnaire_has_already_been_submitted_or_processed_If_esigning_is_enabled_and_the_questionnaire_was_submitted_signing_invitations_are_already_sent_to_the_required_signers": "This questionnaire has already been submitted. If e-signing is enabled and the questionnaire was submitted, signing invitations are already sent to the required signers.",
    "If_desired_the_questionnaire_can_be_reopened_After_doing_so_you_can_add_or_change_information_The_questionnaire_will_have_to_be_submitted_again": "If desired, the questionnaire can be reopened. After doing so, you can add or change information. The questionnaire will have to be submitted again.",
    "If_you_reopen_the_questionnaire_the_status_will_be_changed_to_Not_sent_no_automatic_email_will_be_sent_to_the_customer_You_can_send_an_invitation_afterwards_if_you_wish_You_can_do_this_in_the_customer_overview": "If you reopen the questionnaire, the status will be changed to “Not sent”, no automatic e-mail will be sent to the customer. You can send an invitation afterwards if you wish.",
    "Note_if_esignature_is_enabled_the_customer_will_no_longer_be_able_to_sign_via_the_current_link_URL_All_the_current_signing_data_will_be_deleted_After_resubmitting_the_questionnaire_the_customer_will_receive_a_new_link_via_which_he_can_sign": "Note: if e-signature is enabled, the customer will no longer be able to sign via the current link (URL). All the current signing data will be deleted. After resubmitting the questionnaire, the customer will receive a new link via which he can sign.",
    "Yearly_reports": "Annual reports",
    "Archived_Customers": "Archive",
    "Approve": "Approve",
    "Approve_and_continue": "Approve and continue",
    "Approve_and_continue_tooltip": "Approve this step and move it to the next assignee in the workflow.",
    "Approve_and_complete_tooltip": "Approve and complete this task.",
    "Resolve_and_reassign": "Resolve & Reassign",
    "Resolve_and_reassign_tooltip": "Send this step back to its original assignees for review.",
    "Reject": "Reject",
    "Sign": "Sign",
    "Signing_state_intro": "This step is signed in the signing portal. Everyone below has been sent a link by email — the link is personal, so it stays in their own mailbox and cannot be shared from here.",
    "Step_approved_sent_to_next_assignee": "Step approved and sent to the next assignee.",
    "Step_approved_task_completed": "Step approved — this task is now complete.",
    "Step_resolved_sent_back_to_assignees": "Step resolved and sent back to its original assignees.",
    "Step_rejected_reassigned_to_creator": "Step rejected and sent back for changes.",
    "Step_decision_failed": "Could not save this decision. Please try again.",
    "Form_access_denied": "You don't have access to this questionnaire."
  },
  "welcome-modal": {
    "Welcome_to_AMLCO": "Welcome to AMLCare!",
    "detailWelcome": "To start, we ask to generate the internal office policy of {firmName}. By clicking on the button below you will enter the questionnaire that requests the necessary information. Your internal office policy will then be generated on the basis of this questionnaire.\n\nIt is not necessary to complete this questionnaire in one go. If desired, you can close the tab and continue the questionnaire at a later time, all information already entered will be saved.",
    "detailProgress": "We ask to complete the regeneration of {firmName}'s internal office policy. By clicking on the button below you will enter the questionnaire that requests the necessary information. Your internal office policy will then be generated on the basis of this questionnaire.\r\n\r\nIt is not necessary to complete this questionnaire in one go. If desired, you can close the window and continue the questionnaire at a later time, all information already known and filled in is saved.\r\n\r\nOther users currently do not have access to your AMLCare backoffice. As soon as the internal office policy has been completed, all users automatically regain access.",
    "btnProgress": "Generate AML Policy",
    "btnWelcome": "Generate AML Policy",
    "contactOfficer": "The internal (anti-money laundering) office policy is currently being drawn up and generated, please contact your AML representative."
  },
  "validation-service": {
    "Enter_valid_email_Ex_abcxyzcom": "Please enter a valid email address",
    "Enter_a_valid_webSite": "Please enter a valid website",
    "Answer_must_be_between_value1_to_value2": "Answer must be between {{value1}} and {{value2}}",
    "Answer_must_be_value_digit": "Answer must be {{value}} digit(s)",
    "Please_enter_a_number": "Please enter a number less than {{value}}",
    "Please_enter_a_proper_nationalregistration_number_ExXXXXXXXXXXX_X_must_be_number": "Please enter a valid national register number",
    "Please_enter_a_phone_number": "Please enter a valid phone number",
    "Please_enter_a_valid_KBO_number": "Please enter a valid CBE number"
  },
  "message": {
    "Oops": "Oops...",
    "Are_you_sure": "Are you sure that you want to delete this?",
    "You_Want_to_delete": "This will be deleted permanently.",
    "Yes_delete_it": "Yes, delete it",
    "No_keep_it": "No, keep it",
    "Company_has_not_filled_document_completely": "The questionnaire has not yet been completed",
    "Do_you_still_want_to_download_it": "Do you still want to download the document?",
    "Deleted": "Deleted",
    "Updated": "Updated.",
    "Created": "Added",
    "Downloaded": "Downloaded",
    "Download": "Download",
    "Close": "Close",
    "Multiple_documents_available": "There are multiple files available",
    "Do_you_want_to_download": "Do you want to download these?",
    "Coming_Soon": "Coming soon",
    "You_need_to_write_DELETE_in_uppercase": "You must write DELETE with capital letters",
    "Deleted_Successfully": "deleted successfully",
    "Updated_Successfully": "Updated successfully.",
    "Created_Successfully": "successfully added",
    "This_will_permanently_delete_": "This will permanently delete",
    "_and_all_of_its_data": "and all of its data.",
    "Write": "Type ",
    "DELETE": "DELETE",
    "to_confirm": "to confirm this",
    "Ultimate_Beneficial_Owner": "Ultimate Beneficial Owner",
    "User": "User",
    "Document": "Document",
    "Company": "Company",
    "Private_Person": "Private person",
    "Continue": "Continue",
    "Cancel": "Cancel",
    "Customer": "Customer",
    "Are_you_sure_you_want_to_archive_this_customer": "Are you sure you want to archive this customer?",
    "archive_description": "All data will be stored in the AMLCare archive. The customer and you will not receive any reminders, nor will you be able to do an identification or CAP anymore unless you unarchive the customer.",
    "Yes_Continue": "Yes, continue",
    "No_Cancel": "No, cancel",
    "Are_you_sure_you_want_to_undo_the_archiving_for_this_customer": "Are you sure you want to unarchive this customer?",
    "The_customer_will_be_made_active_again": "The customer will be made active again",
    "Customer_archived_successfully": "Customer archived successfully",
    "Customer_unarchived_successfully": "Customer unarchived successfully",
    "Automatic_reminder_has_been_changed_successfully": "Automatic reminder settings changed successfully",
    "Director": "Director ",
    "Company Director": "Director (company)\n\n",
    "Permanent Representative": "Permanent Representative",
    "Person": "Person",
    "Permanent Representative of Company Director": "Permanent representative of director",
    "Are_you_sure_you_want_to_unlink_the_relation": "Are you sure you want to unlink this relation ?",
    "This_will_unlink_the_relation": "This does not delete the private person or company. This will only remove the link.",
    "Label_Field": "Label field",
    "Label_remove_warning": "This label might currently be assigned to customers or internal users. Removing it will unassign the label from all of them. Are you sure you want to proceed?",
    "Label_field_remove": "This label field is currently assigned to customers or internal users. Deleting it will remove the entire label field and unassign all its labels, if assigned, from every customer or internal user. Are you sure you want to proceed?",
    "Please_enter_label_field_name": "Please enter label field name",
    "Please_enter_at_least_one_label": "Please enter at least one label",
    "Duplicate_label_field_name": "A label field with this name : {{name}} already exists. Please enter a unique name to proceed.",
    "Got_it": "Got it",
    "Relation": "Relation",
    "Customers": "Customers",
    "Merged": "Merged",
    "Merged_Successfully": "Merged successfully",
    "You_Want_to_enable_multiple_caps": "Enable multiple caps for this firm? This action cannot be undone.",
    "Yes_enable_multiple_caps": "Yes, enable Multiple Caps",
    "responsible_required_to_accept_suggestion": "Without selecting a responsible, you cannot accept this suggestion.",
    "Do_you_still_want_to_preview_it": "Do you still want to preview it?",
    "Preview": "Preview"
  },
  "APIResponseCodes": {
    "INTERNAL-SERVER-ERROR": "Something went wrong",
    "BAD-REQUEST": "Something went wrong",
    "FILE_TOO_LARGE": "This file is too large for this upload.",
    "FILE_EXTENSION_NOT_ALLOWED": "This file type is not permitted for this upload.",
    "FILE_CONTENT_MISMATCH": "The file's content does not match its extension.",
    "FILE_TYPE_UNDETECTED": "We couldn't determine this file's type.",
    "FILE_INVALID_TEXT": "This file is not valid text.",
    "FILE_DETECTION_FAILED": "The file could not be analysed.",
    "FORBIDDEN-ERROR": "You are not allowed to perform this operation",
    "FORBIDDEN": "You are not allowed to perform this operation",
    "NOT-AUTHORIZED": "You are not allowed to perform this operation",
    "READ_ONLY_USER": "Your account has read-only access, so this action is not available",
    "DATABASE-ERROR": "Something went wrong",
    "UBO-CREATED-SUCCESSFULLY": "UBO created successfully",
    "USERS-FETCHED-SUCCESSFULLY": "User fetched successfully",
    "AUTH-FAIL": "Login fail",
    "AUTH-TOKEN-EXPIRED": "Authentication expired",
    "AUTH-FAIL-FIRM-REMOVED": "The customer has been removed",
    "AUTH-FAIL-USER-REMOVED": "The user has been removed",
    "AUTH-TOKEN-NOT-IN-HEADER": "Something went wrong",
    "AUTHENTICATION-FAIL": "Document link is invalid",
    "INVALID-TOKEN": "Document link is invalid",
    "INVALID-PARAMS": "Something went wrong",
    "BAD-REQUEST-ID": "Resource not found",
    "CUSTOMER-DOCUMENT-UPLOADED-SUCCESSFULLY": "Customer document uploaded successfully",
    "CUSTOMER-DOCUMENT-NOT-FOUND": "Customer document not found",
    "CUSTOMER-DOCUMENT-DELETED-SUCCESSFULLY": "Customer document deleted successfully",
    "DOCUMENT-FETCHED-SUCCESSFULLY": "Uploaded documents fetched successfully",
    "UPLOADED-DOCUMENTS-DOWNLOADLINK-GENERATED": "Uploaded documents downloaded successfully",
    "NO-DOCUMENT-FOUND": "No uploaded document found",
    "DOCUMENT-UPDATED-SUCCESSFULLY": "Document updated successfully",
    "NOT-REGISTERED": "User is not registered",
    "WRONG-CREDENTIALS": "Username or password might be wrong",
    "FIRM-NOT-FOUND": "Customer not found",
    "USER-NEW-TFA-SECRET-GENERATED": "New TFA generated for user",
    "LOGGED-IN-SUCCESSFULLY": "Logged in successfully",
    "MAIL-SEND-IN-PROGRESS": "Mail sending is in process",
    "MAILER-ERROR": "Something went wrong in sending the mail",
    "AUTH_FAIL": "Login fail",
    "TOKEN-TIMEOUT": "Reset password link is expired",
    "REQUEST-INVALID": "Reset password link is wrong",
    "PASSWORD-CHANGED-SUCESSFULLY": "Password changed successfully",
    "USER-LOGGED-OUT-SUCESSFULLY": "Logged out Successfully",
    "TOKEN-FOUND": "Token found successfully",
    "TOKEN-UPDATED-SUCCESSFULLY": "Token updated successfully",
    "TOKEN-CREATED-SUCCESSFULLY": "Token created successfully",
    "CUSTOMERS-FETCHED-SUCCESSFULLY": "Customer fetched succcessfully",
    "CUSTOMER-CREATED-SUCCESSFULLY": "Customer created successfully",
    "IMPORT-CUSTOMER-SUCCESSFULLY": "Customer imported successfully",
    "REMINDER-SENT-SUCCESSFULLY": "Reminder sent successfully",
    "EMAIL-NOT-FOUND": "Customer email not found",
    "INVALID-DOCUMENT-TYPE": "Document not Found or Document Type is Internal",
    "CUSTOMER-NOT-FOUND": "Customer not found",
    "CUSTOMER-FOUND-SUCCESSFULLY": "Customer found successfully",
    "CUSTOMERS-DELETED-SUCCESSFULLY": "Customer deleted successfully",
    "CUSTOMER-LABEL-UPDATED-SUCCESSFULLY": "Customer labels updated successfully",
    "CUSTOMER-EDITED-SUCCESSFULLY": "Customer edited successfully",
    "CUSTOMER-DELETED-SUCCESSFULLY": "Customer deleted successfully",
    "NO-DESIGN-FOUND": "Design not found",
    "SUCCESSSFULLY-DESIGN-UPDATED": "Design updated successfully",
    "ESIGNATURE_NOT_FOUND": "E-Signature not found",
    "NEW_ESIGNATURE_ADD_SUCCESS": "New E-Signature added successfully",
    "ERROR_POST_DOCUMENT_BOT_V2_DOWNLOAD_DOCUMENTS_INVALID_REQUEST": "Something went wrong",
    "ERROR_POST_DOCUMENT_BOT_V2_DOWNLOAD_DOCUMENTS_SERVER_ERROR": "Something went wrong",
    "SIGNER_UPDATED_SUCCESS": "Signer updated successfully",
    "SIGNER_DELETED_SUCCESS": "Signer deleted successfully",
    "SIGNER_ADDED_SUCCESS": "Signer added successfully",
    "INVALID_PARAMS": "Something went wrong",
    "SUCCESS_DELETE_DOCUMENT_BOT_V2_DOCUMENT_DELETED": "Document deleted successfully",
    "ERROR_DELETE_DOCUMENT_BOT_V2_DOCUMENT_FILENAME_NOT_FOUND": "Document not found",
    "ERROR_DELETE_DOCUMENT_BOT_V2_DOCUMENT_WHILE_DELETE_DOCUMENT": "Error while deleting document",
    "ERROR_POST_DOCUMENT_BOT_V2_BOT_DESIGN_TRANSCRIPT_NOT_FOUND": "Transcript or customer not found",
    "ERROR_POST_DOCUMENT_BOT_V2_BOT_DESIGN_TRANSCRIPT_ID_NOT_FOUND": "Something went wrong",
    "ERROR_POST_DOCUMENT_BOT_V2_BOT_DESIGN": "Error in getting information about bot design",
    "ERROR_POST_DOCUMENT_BOT_V2_AUTH_REGISTER_NUMBER_NOT_VALID": "Register number not valid",
    "ERROR_POST_DOCUMENT_BOT_V2_AUTH_REGISTER_NUMBER_CUSTOMER_NOT_FOUND": "Customer not found",
    "ERROR_POST_DOCUMENT_BOT_V2_AUTH_REGISTER_NUMBER_JWT_AUTH_FAILS": "Something went wrong",
    "ERROR_POST_DOCUMENT_BOT_V2_AUTH_AUTHENTICATION_FAIL": "Authentication fail",
    "ERROR_POST_DOCUMENT_BOT_V2_AUTH_AUTHENTICATION_INTERNAL_ERROR": "Something went wrong",
    "DOCUMENT-GROUP-CREATED-SUCCESSFULLY": "Document group created successfully",
    "DOCUMENT-GROUP-NOT-FOUND": "Document group not found",
    "DOCUMENT-GROUP-UPDATED-SUCCESSFULLY": "Document group updated successfully",
    "DOCUMENT-GROUP-DELETED-SUCCESSFULLY": "Document group deleted successfully",
    "DOCUMENT-STEP-ADDED-SUCCESSFULLY": "Document step added successfully",
    "DOCUMENT-STEP-NOT-FOUND": "Document step not found",
    "DOCUMENT-STEP-GET-SUCCESSFULLY": "Document step successfully",
    "REQUEST-PARAMETER-MISSING": "Something went wrong",
    "DOCUMENT-STEP-EDITED-SUCCESSFULLY": "Step edited successfully",
    "DOCUMENT-STEP-DELETED-SUCCESSFULLY": "Step deleted successfully",
    "DOCUMENT-LOOP-STEP-DELETED-SUCCESSFULLY": "Loop step deleted successfully",
    "DOCUMENT-CREATED-SUCCESSFULLY": "Document created successfully",
    "DOCUMENT-NAMES-FETCHED-SUCCESSFULLY": "Document name fetched successfully",
    "GET-DOCUMENT-LIST-SUCCESSFULLY": "Document list fetched successfully",
    "CUSTOM-VARIABLES-FETCHED-SUCCESSFULLY": "Data fetched successfully",
    "DOCUMENT-NOT-FOUND": "Document not found",
    "DOCUMENT-FOUND-SUCCESSFULLY": "Document was found successfully",
    "DOCUMENT-COPIED-SUCCESSFULLY": "Document was copied successsully",
    "COPIED-SUCCESSFULLY": "Document was copied successsully",
    "DOCUMENT-DELETED-SUCCESSFULLY": "Document was deleted successfully",
    "ERROR_GET_ESIGNATURE_RETRIVE_SIGNED_DOCUMENT_ESIGN_NOT_FOUND": "E-Signature document not found",
    "ESIGNATURE-FETCHED-SUCCESSFULLY": "E-Signature fetched successfully",
    "EMAIL-CONTENT-NOT-FOUND": "Email content not found",
    "ERROR-EMAIL-CONTENT-GET": "Error while getting email content",
    "EMAIL-CONTENT-UPDATED-SUCCESSFULLY": "Email content updated successfully",
    "ERROR-EMAIL-CONTENT-PUT": "Error while updating email content",
    "ERROR-EMAIL-CONTENT-POST": "Error while creating email content",
    "EMAIL-DESIGN-NOT-FOUND": "Email design not found",
    "ERROR-EMAIL-DESIGN-GET": "Error while getting email content",
    "EMAIL-DESIGN-UPDATED-SUCCESSFULLY": "Email design updated successfully",
    "ERROR-EMAIL-DESIGN-PUT": "Error while updating email design",
    "INSUFFICIENT-ACCESS": "You are not allowed to perform this operation",
    "ERROR-EMAIL-DESIGN-POST": "Error while creating email design",
    "ERROR-EMAIL-DOMAIN-AUTHORIZE": "Error while authorizing email domain",
    "ERROR-EMAIL-DOMAIN-VALIDATE": "Error while validating email domain",
    "EMAIL-DOMAIN-NOT-FOUND": "Email domain not found",
    "ERROR-EMAIL-DOMAIN-GET": "Error while getting email domain",
    "FIRM-FETCHED-SUCCESSFULLY": "Customer fetched successfully",
    "INVALID-REQUEST": "Customer not found",
    "NO-FIRM-FOUND": "Customer not found",
    "FIRM-CREATED-SUCCESSFULLY": "Customer created successfully",
    "DUPLICATE-EMAIL-ENTRY-ADMIN": "A user with this e-mail address already exists",
    "DUPLICATE-EMAIL-ENTRY-FIRM": "A customer with this e-mail address already exists",
    "FIRM-UPDATED-SUCCESSFULLY": "Customer updated successfully",
    "FIRM-DELETED-SUCCESSFULLY": "Customer deleted successfully",
    "ALL-AUDIT-LOGS-FETCHED-SUCCESSFULLY": "All audit logs fetched successfully",
    "FIRM-AUDIT-LOG-FETCHED-SUCCESSFULLY": "Customer audit logs fetched successfully",
    "CUSTOMER-DETAILS-FETCHED-SUCCESSFULLY": "Customer details fetched successfully",
    "LABEL-CREATED-SUCCESSFULLY": "Label created successfully",
    "LABEL-FETCHED-SUCCESSFULLY": "Label fetched successfully",
    "LABEL-DELETED-SUCCESSFULLY": "Label deleted successfully",
    "CUSTOMER-ASSIGNED-DOCUMENTS-FETCHED-SUCCESSFULLY": "Customer assigned documents were fetched successfully",
    "TRANSCRIPT-NOT-FOUND": "Transcript not found",
    "MAIL-SEND-SUCCESSFULLY": "Mail send successfully",
    "MAIL-ALREADY-SENT": "Mail already sent",
    "DOCUMENT-ASSIGN-SUCCESSFULLY": "Document assigned successfully",
    "ASSIGNED-DOCUMENT-DELETED-SUCCESSFULLY": "Assigned document deleted successfully",
    "ASSIGNED-DOCUMENT-NOT-FOUND": "Assigned document not found",
    "UBO-UPDATED-SUCCESSFULLY": "UBO updated successfully",
    "NOT-UBO-FOUND": "UBO not found",
    "UBO-DELETED-SUCCESSFULLY": "UBO deleted successfully",
    "INTERNAL-USER-ALREADY-REGISTERED": "Internal user already registered",
    "UNAUTHORIZED-ACCESS": "You are not allowed to perform this operation",
    "INTERNAL-USER-FETCHED-SUCCESSFULLY": "User fetched successfully",
    "AMLCO-OFFICER-FETCHED-SUCCESSFULLY": "AMLCO responsible fetched successfully",
    "AMLCO-OFFICER--NOT-FOUND": "AMLCO responsible not found",
    "INTERNAL-USER-SECRET-GENERATED": "User secret generated",
    "INTERNAL-USER-ADDRESS-FETCHED-SUCCESSFULLY": "User addresses fetched successfully",
    "INTERNAL-USER-FETCHED-BY-ID-SUCCESSFULLY": "User fetched successfully",
    "INTERNAL-USER-NOT-FOUND": "User not found",
    "INTERNAL-USER-HAS-OPEN-ASSIGNMENTS": "This user is assigned to review workflow steps that are in progress",
    "INTERNAL-USER-HAS-PENDING-ASSIGNMENTS": "This user is selected on review workflow steps or templates that have not started yet",
    "INTERNAL-USER-REASSIGN-TARGET-INVALID": "The selected reassignment target is invalid",
    "INTERNAL-USER-CREATED-SUCCESSFULLY": "User created successfully",
    "DUPLICATE-EMAIL-ENTRY-USER": "Duplicate email enter user",
    "INTERNAL-USER-2FA-DELETED-SUCCESSFULLY": "User 2FA deleted successfully",
    "INTERNAL-USER-2FA-SETTINGS-UPDATED-SUCCESSFULLY": "User 2FA updated successfully",
    "UNAUTHORIZED": "You are not allowed to perform this operation",
    "INTERNAL-USER-LABEL-UPDATED-SUCCESSFULLY": "User label updated successfully",
    "PASSWORD-UPDATED-SUCCESSFULLY": "Password updated successfully",
    "INTERNAL-USER-UPDATED-SUCCESSFULLY": "User updated successfully",
    "INTERNAL-USER-DELETED-SUCCESSFULLY": "User deleted successfully",
    "MAILER_ATTACHMENT_ERROR": "Something went wrong in sending the mail",
    "MAILER_ERROR": "Something went wrong in sending the mail",
    "INVALID_KBO_NUMBER": "Invalid KBO Number",
    "INTEGRATION_ERROR": "Integration Error",
    "TOKEN-EXPIRED": "Session expired. Please log in again.",
    "KBO_NOT_MATCH": "This UBO register document relates to a different company. Please upload a PDF of {{customerName}}’s UBO register.",
    "NEWER_UBO_REGISTER_EXISTS_THAN_UPLOADED": "We have a more recent version of this UBO register from {{documentDate}} in this company’s attachments.",
    "UNPROCESSABLE_UBO_REGISTER": "The uploaded file is not valid. Please make sure you upload the official PDF document from the UBO register.",
    "MINFIN_CREDENTIAL_NOT_FOUND": "We could not log in successfully. Please check that all credentials are correct.",
    "ID_CARD_EXPIRY": "This identity card has expired.",
    "MONITORING_EVENT_NOT_REVIEWABLE": "This event can no longer be reviewed.",
    "MONITORING_EVENT_ASSIGNEE_REQUIRED": "Assign this event to someone before reviewing it.",
    "MONITORING_EVENT_ASSIGNEE_NOT_ELIGIBLE": "This user cannot be assigned to this event.",
    "MONITORING_REVIEW_ASSIGNEE_NOT_ALLOWED": "You cannot change who this event is assigned to.",
    "MONITORING_REVIEW_STATUS_NOT_ALLOWED": "This status is not available for this event.",
    "MONITORING_REVIEW_COMMENT_REQUIRED": "A comment is required for this status.",
    "MONITORING_REVIEW_SOURCES_NOT_ALLOWED": "Sources cannot be marked for this event.",
    "MONITORING_REVIEW_SOURCE_NOT_IN_RESULT": "One of the marked sources is no longer part of this result. Close the panel and open it again to see the latest sources.",
    "MONITORING_REVIEW_NOT_NEWEST_EVENT": "A newer event exists for this check, so this one can no longer be reviewed.",
    "MONITORING_REVIEW_NOT_ASSIGNEE": "Only the person this event is assigned to can review it.",
    "MONITORING_EVENT_CHANGED": "This event changed while you were reviewing it. Close the panel and open it again to see the latest details.",
    "NO_CHANGES": "Nothing has changed since the last review, so there is nothing to submit.",
    "MONITORING_REVIEW_ROUND_LIMIT": "This event has reached the maximum number of review rounds."
  },
  "otb": {
    "warning_source": "Sources of the type BSP were automatically extracted from the publications of the Belgian Official Gazette and are therefore possibly not 100% correct. Always check the source publications.",
    "warning": "Warning",
    "warning_pep": "Warning: one or more persons connected to this company hold a political mandate.",
    "pep_title": "Political mandate",
    "natural_persons": "Natural persons",
    "legal_entities": "Legal entities",
    "directors": "Directors",
    "board_mandates": "Board mandates",
    "overview": "Overview",
    "financial": "Financial",
    "mandates": "Mandates",
    "participations": "Participations",
    "publications": "Publications",
    "activities": "Activities",
    "kbo_error": "We weren’t able to find a (valid) KBO number. Please enter a valid KBO number to continue.",
    "company_profile_not_found": "No company data could be found for this KBO number.",
    "company_profile": "Company profile",
    "vat": "VAT",
    "legal_form": "Legal form",
    "address": "Address",
    "juridical_status": "Juridical status",
    "juridical_situation": "Juridical situation",
    "start_date": "Start date",
    "phone": "Phone",
    "sources": "Sources",
    "name": "Name",
    "gross_margin": "Gross operating margin",
    "equity": "Equity",
    "gain": "Gain",
    "loss": "Loss",
    "operating_income": "Operating income",
    "manages": "manages",
    "founded": ", founded",
    "warning_participation": "Participations of companies with a percentage lower than 10% are not always mentioned.",
    "cohabitation": "Same address",
    "financial_warning": "No financial or social balance data found for this organisation.",
    "financial_overview": "Financial overview",
    "social_balance": "Social balance",
    "employees": "Employees",
    "political_mandate": "Political mandate",
    "end": "End",
    "latest_update": "Latest update",
    "political_person": "Political person |",
    "not_known": "Not known",
    "no_natural_person_found": "No natural person found with a directors mandate for this organisation.",
    "extra_info": "Extra info",
    "no_legal_entity_found": "No legal entity found which is a director for this organisation.",
    "no_mandates_for_this_entity": "This organisation has no director mandates.",
    "publications_found": "Publications found",
    "publication_date": "Publication Date",
    "publication_subject": "Subject",
    "publication_source": "Source",
    "view": "View",
    "no_publications_found": "No publications found.",
    "no_natural_persons_found_on_address": "No natural persons found on this address.",
    "no_legal_entities_found_on_address": "No other legal entities found on this address.",
    "main_activities": "Main activities",
    "secondary_activities": "Secondary activities",
    "no_main_activities_found": "No main activities found.",
    "no_secondary_activities_found": "No secondary activities found.",
    "activity_group": "Activity group",
    "description": "Description",
    "mandate": "Mandate",
    "no_financials_natural_person": "No financial data can be found since this entity is a natural person.",
    "natural_person": "Natural Person",
    "shares": "Shares",
    "no_natural_person_shares": "No natural persons found that have shares for this entity.",
    "not_shareholder_in_other_entity": "This entity is no shareholder of any other entity.",
    "no_entities_found_as_shareholders": "No entities found as shareholder for this entity.",
    "shareholders": "Shareholders",
    "snapshot_creation_started": "Snapshot creation started.",
    "successfully_generated_snapshot": "Successfully generated company information snapshot.",
    "snapshot_creation_error": "Error while generating a snapshot.",
    "health": "Financial health",
    "companies": "companies",
    "company": "company",
    "participation_warning": "The following shareholders are mentioned exclusively in publications.",
    "telephone": "Phone",
    "website": "Website",
    "main_activity": "Main activity",
    "locations": "Establishments",
    "side_activity": "Ancillary activity",
    "no_location_found": "No Location Found",
    "rsz_activity": "RSZ activities",
    "Spider_Web": "Relation network",
    "Snapshot": "Snapshot"
  },
  "settings": {
    "Automatic_reminder": "Automatic reminder",
    "Name_reminder": "Name of the reminder",
    "Status": "Status",
    "Action": "Action",
    "ON": "ON",
    "OFF": "OFF",
    "Reminder_Title": "Name of the reminder",
    "Repeat_Every": "Repeat every",
    "Repeat_For": "Repeat for",
    "Save": "Save",
    "Cancel": "Cancel",
    "Name": "Name",
    "Day": "Day",
    "Week": "Week",
    "Year": "Year",
    "Month": "Month",
    "Select": "Select",
    "Select_Date": "Select Date",
    "End": "End",
    "Customers_settings": "Customers settings",
    "Name_of_Label_Field": "Name of Label Field",
    "Only_allowed_predefined_set_of_labels": "Only allow predefined set of labels",
    "Label_Field": "Label Field",
    "Enter_label_name": "Enter label name",
    "Allowed_Labels": "Allowed labels",
    "Add_label_field": "Add label field",
    "Label_field_move_up": "Move up",
    "Label_field_move_down": "Move down",
    "Label_field_delete": "Delete label field",
    "Label_Management": "Label management",
    "Successfully_saved": "Saved successfully",
    "Enter_label": "Enter label",
    "Ubo_register_sync": "UBO register sync",
    "Ubo_register_sync_title": "Sync UBOs from the UBO register",
    "Ubo_register_sync_description": "Allow users to retrieve the data of the ultimate beneficial owners of direct corporate customers from the UBO register. This synchronizes the UBO information of customers, including the UBO register PDF.",
    "CSAM_credentials": "CSAM credentials",
    "CSAM_credentials_description": "To use the sync below, configure your CSAM credentials.",
    "Configure_credentials": "Configure credentials",
    "Remove_credentials": "Remove account",
    "Delete_credentials": "Delete",
    "One_time_import": "First synchronization automatically after adding the customer, then start manually",
    "One_time_import_description": "Users can perform a one-time import of UBO information after a \"direct customer\" company is created.",
    "One_time_import_description_2": "Imported UBOs will be suggested in the customer's relations page. Users will need to review and confirm each UBO.",
    "Automatic_update": "Automatic, continuous synchronization",
    "Automatic_update_description": "When this option is enabled, users can select the UBO synchronization option 'Automatic, continuous synchronization' when creating or editing a customer. In that case, a UBO synchronization is started and the customer is subsequently included in the automatic synchronizations.\n\nThis automatic synchronization typically runs every 6 to 14 days, depending on the stability of the government platforms.\n\nWhen this option is enabled, it is automatically applied to all existing customers in AMLCare. For newly added customers, the user can choose per customer whether this synchronization is activated.",
    "Automatic_update_description_2": "UBO changes will be suggested in the customer's relations page. Users will need to review and confirm each change.",
    "Connect_CSAM_credentials": "Connect your CSAM credentials",
    "Connect_CSAM_credentials_description": "To sync UBOs from the UBO register, please enter your CSAM credentials.",
    "Connect_CSAM_credentials_description_2": "If your CSAM account has access to multiple enterprise numbers, you can select, in the next step, the enterprise number that will be used for the synchronization.\n\nAs a firm, you have default access to all companies in the UBO Register. No specific mandates are required to perform searches in the UBO Register.\n\nTherefore, it is sufficient and we ask you to select a single enterprise number for the synchronization.",
    "CSAM_username": "CSAM username",
    "CSAM_password": "CSAM password",
    "CSAM_32_digit_code": "CSAM 32-digit code",
    "Accept_terms_and_conditions": "Accept the",
    "Select_CBE_number": "Select your CBE number(s)",
    "Select_CBE_number_description": "As a firm, you have default access to all companies in the UBO Register. No specific mandates are required to perform searches in the UBO Register.",
    "CBE_number_verifying": "Your login credentials are being verified and we are checking whether we can retrieve the correct information. This may take up to five minutes.",
    "Enable_one_time_import": "Please confirm: enable one-time import",
    "Enable_one_time_import_description": "By enabling this feature, all users in your organization can perform a UBO import for any direct customer in AMLCare with a valid CBE number.",
    "One_time_import_warning": "Every time such an import is performed, AMLCare will log the import action in the audit log.",
    "Enable_automatic_update": "Please confirm: enable automatic update",
    "Enable_automatic_update_description": "By enabling this feature, AMLCare will regularly check for updates in the UBO register automatically.",
    "Automatic_update_warning": "Whenever the sync finds any changes in the UBO register for a specific customer in AMLCare, these changes will be suggested in the customer's relations page. Users will need to review and confirm each change.",
    "Confirm_remove_CSAM_credentials": "Remove CSAM credentials?",
    "Confirm_remove_CSAM_credentials_description": "If you remove these credentials, users will no longer be able to perform syncs from the UBO register. Any ongoing syncs will automatically be cancelled.",
    "Confirm_turn_off_one_time_import": "Please confirm: turn off one-time import for all customers",
    "Confirm_turn_off_one_time_import_description": "Please confirm that you would like to turn off this feature and disable all one-time imports from the UBO register.",
    "Confirm_turn_off_automatic_update": "Please confirm: turn off automatic updates from the UBO register for all AMLCare customers",
    "Confirm_turn_off_automatic_update_description": "Please confirm that you would like to turn off this feature and disable all automatic syncs from the UBO register.",
    "Minfin_service_updating": "The AMLCare development team is making adjustments to account for changes in the UBO register. You can start the synchronization process again soon.",
    "Fetch_Minfin_Connection_Details_Failed": "Failed to fetch UBO connection details.",
    "Load_Ubo_Sync_Status_Failed": "Failed to load UBO sync status.",
    "Configure_Csam_Credentials_Failed": "Failed to configure CSAM credentials. Please check the credentials and try again.",
    "Fetch_Cbe_Numbers_Error": "An error occurred while fetching CBE numbers. Please try again.",
    "Minfin_Connection_Details_Cleared": "The UBO connection details have been cleared.",
    "Clear_Minfin_Connection_Details_Failed": "Failed to clear UBO connection details.",
    "Csam_Settings_Applied_Successfully": "CSAM settings configured successfully.",
    "Save_Cbe_Selection_Failed": "Failed to save the CBE number selection.",
    "Delete_Csam_Credentials_Successfully": "Successfully deleted the CSAM credentials.",
    "Delete_Csam_Credentials_Failed": "Failed to delete the CSAM credentials.",
    "Settings_Updated_Successfully": "Settings updated successfully.",
    "Update_Settings_Failed": "Failed to update settings.",
    "Next_Select_Cbe_Numbers": "Next: select CBE number",
    "Enter_Your_Username": "Enter your username",
    "Enter_Your_Password": "Enter your password",
    "Csam_32_Digit_Code_Tooltip": "Enter the 32-digit code CSAM provided when setting up the digital key with code via the mobile app.",
    "Confirm_And_Apply_Csam_Settings": "Confirm and configure settings",
    "Select_Cbe_Number": "Select CBE number",
    "Yes_Enable_One_Time_Import": "Yes, enable one-time import",
    "Yes_Enable_Automatic_Update": "Yes, enable automatic sync",
    "Yes_Remove_And_Cancel_All_Syncs": "Yes, remove and cancel all syncs",
    "Yes_Disable_For_All_Customers": "Yes, disable for all customers",
    "Username": "Username",
    "CBE": "CBE",
    "Accept_terms_and_conditions_link": "terms and conditions"
  },
  "communication": {
    "Date": "Date",
    "Email_title": "Email title",
    "Type": "Type",
    "Automatic_reminder": "Automatic reminder",
    "No_email_records": "No email was sent to the customer yet",
    "Document Invitation": "Invitation questionnaire",
    "Reminder Document Invitation": "Reminder questionnaire",
    "Reminder Sign Invite": "Reminder e-signature",
    "Reminder Document Invitation Id Card Renewal": "Reminder questionnaire ID card renewal",
    "Document Reminder": "Reminder questionnaire",
    "Document Reminder Id Card Renewal": "Reminder ID card renewal",
    "Document Invitation Id Card Renewal": "Invitation ID card renewal",
    "Sign Invite": "E-sign invite",
    "Internal Document Invitation": "Internal document invitation"
  },
  "crm": {
    "API_Key": "API key",
    "API_Endpoint": "API endpoint",
    "Save": "Save",
    "Documentation": "Documentation",
    "Delete": "Delete",
    "Please_enter_syneton_url": "Please enter a valid Admin IS | Consult API endpoint",
    "Please_enter_software_token": "Please enter a valid software token",
    "Confirm_delete_syneton_connection": " the Admin IS | Consult connection",
    "Established": "Enabled",
    "Admin_IS_Consult_connection_has_been_established_successfully": "Admin IS | Consult connection has been established successfully",
    "Admin_IS_Consult_connection_has_been_deleted_successfully": "Admin IS | Consult connection has been deleted successfully",
    "Deleted": "Deleted",
    "AdminPulse": "AdminPulse",
    "Admin_IS | Admin_Consult": "Admin IS | Consult",
    "Active": "Active",
    "Email": "Connected AdminPulse account",
    "Connect_Pulse_Button": "Connect with AdminPulse",
    "Confirm_delete_syneton_pulse_connection": "Delete the AdminPulse connection",
    "Integration_already_exists": "The integration with AdminPulse is already enabled for this firmId and type",
    "Integration_Connection_error": "Integration connection error",
    "Crm": "CRM"
  },
  "kyc": {
    "ubo": "Ultimate Beneficial Owners",
    "customer": "Customer",
    "other-check": "Other check",
    "just-ban": "Director Bans",
    "Execute_check": "Execute check",
    "Check_director_bans_on_justban": "Check director bans on Justban",
    "Go_to_Justban": "Go to Justban",
    "Justban_description": "You can check whether this customer or related parties have been sanctioned with a director ban via the button below. If this is the case, we suggest to take a screenshot and upload it under ‘files’ for this customer",
    "Other_check_description": "Please insert the CBE number of the company or first name + last name of the person you would like to verify below.",
    "Other_check_placeholder": "... type here",
    "Verify": "Verify",
    "Verification_popup_description": "Are you sure you want to pursue this check? €3.50 will be charged for this check.",
    "No_Cancel": "No, cancel",
    "Yes_Continue": "Yes, continue"
  },
  "spider-web": {
    "Person": "Person",
    "Company": "Company",
    "Main_Company": "Main Company",
    "administrators": "administrators",
    "administers": "administers",
    "companies": "companies",
    "Equity": "Equity",
    "Operating_income": "Operating Income",
    "Employees": "Employees",
    "Gain": "Profit",
    "Since": "Since",
    "Powered_By_AMLCare": "Powered By AMLCare",
    "Administer": "Administers",
    "Participate": "Participates in",
    "Cohabit": "Same address",
    "Othermandate": "Other mandate"
  },
  "azuresso": {
    "Title_Callback": "Login via Azure AD",
    "Auth_Error": "Something went wrong during authentication.",
    "Auth_Wait": "Please wait while we authenticate you through your organisation.",
    "Azure_Error": "Azure AD authentication error. Contact your IT administrator to give you access to the AMLCare.io platform."
  },
  "delegation": {
    "Delegated_access": "Delegated access",
    "Choose_an_environment": "Choose the environment you want to work in.",
    "Search_firms_or_accounts": "Search firms or accounts",
    "Could_not_load_environments": "The authorized environments could not be loaded.",
    "No_authorized_environments": "No authorized environments found.",
    "No_matching_environments": "No environments match your search.",
    "Could_not_open_environment": "That environment could not be opened. Please try again.",
    "Switch_account_as": "Switch account as",
    "Items_per_page": "Items per page",
    "Of": "of"
  },
  "adverse-media": {
    "Only_show_customers_with_adverse_media": "Only show customers with adverse media",
    "Money_laundering": "Financial Crimes and Money Laundering",
    "Terrorism": "Terrorism and crime",
    "Corruption_and_bribery": "Corruption and Bribery",
    "No_customers_found_in_adverse_media": "No customers found",
    "Litigation_and_legal_issues": "Litigation and Legal Issues",
    "Adverse_media": "Adverse media",
    "No_adverse_media_found": "No adverse media found for this customer. ",
    "Adverse_media_disclaimer": "Our AI scans the web for possible mentions of the client related to the topics below — always with source references. The functionality has a supportive role and the results should always be critically verified. Since news articles usually do not contain unique identifiers (such as a national registration number), the search is primarily based on the name. As a result, some unrelated results may appear. The AI acts as a tool that provides suggestions only; the final assessment always lies with you. In the risk assessment, it can be explicitly indicated whether negative media reports are actually applicable.",
    "media_found": "Adverse media found",
    "media_warning": "No results for this relation, but 1 or more linked relations have results.",
    "verification_needed": "Adverse media found, verification needed",
    "no_results": "No results",
    "tooltip_found": "Adverse media found for this customer.",
    "tooltip_relation_warning": "No adverse media found for this relation. One or more linked relations have adverse media results.",
    "tooltip_verification_needed": "Adverse media found for this relation that requires verification.",
    "tooltip_clean": "No adverse media found for this relation.",
    "Adverse_media_description": "Our AI scans the web for mentions of the relation related to the specified topics, providing source references. Results should always be verified as this is a supportive tool only. Since news articles typically lack unique identifiers, searches are name-based and may include unrelated results. The AI provides suggestions; the final assessment remains your responsibility.",
    "Risk_assessment_note": "In the risk assessment, it can be explicitly indicated whether adverse media findings are actually applicable.",
    "Scanning_the_web_for_adverse_media": "Scanning the web for adverse media about this relation",
    "status_no_results_found": "No results found.",
    "status_relations_with_results": "{{count}} relations with results.",
    "status_sources_found": "{{count}} sources found.",
    "status_sources_found_and_relations_with_results": "{{sourceCount}} sources found and {{relationCount}} relations with results.",
    "Scanning_adverse_media": "Scanning adverse media data...",
    "status_source_found": "{{count}} source found.",
    "Web_search_processing_in_progress": "We are currently verifying the adverse media status for this relation. The panel is currently displaying default values. The updated status will be reflected within the next 24 hours."
  },
  "sanctions-and-mandates": {
    "National_sanctions_list": "National sanctions list",
    "European_sanctions_list": "European sanctions list",
    "European_travel_ban_list": "European travel ban list",
    "UN_sanctions_list": "UN sanctions list",
    "Political_mandate_PDF": "Political mandate (Rekenhof)",
    "Political_mandate_CSV": "Political mandate (Flemish Mandate Database)",
    "Only_show_customers_found_on_a_list": "Only show relations with a match",
    "No_customers_found_in_sanctions_and_mandates_list": "No relations found in sanctions lists",
    "Sanction_and_mandates": "Sanctions and mandates",
    "Sanction_and_mandates_disclaimer": "We match exact names against official sanctions and political mandate lists. Homonyms or false positives are not filtered out. Always verify the match by consulting the original source.",
    "tooltip_clean": "No match found for this relation.",
    "tooltip_relation_warning": "No match found for this relation. One or more linked relations have a match.",
    "tooltip_found": "Match found for this relation.",
    "tooltip_verification_needed": "Possible match found for this relation that requires verification.",
    "not_on_list": "No match found",
    "found_on_list": "Match found",
    "verification_needed": "Possible match found, verification needed",
    "not_on_list_relation_found": "No match found, but 1 or more linked relations have a match.",
    "status_not_found_on_list": "No match found.",
    "status_on_list": "Match found.",
    "status_relations_on_list": "{{count}} relations with a match.",
    "status_on_list_and_relations_on_list": "Match found, and {{count}} linked relations also have a match.",
    "Sanctions": "Sanctions",
    "Scanning_sanctions_data": "Scanning sanctions data",
    "OFAC_consolidated_sanctions_list": "OFAC consolidated sanctions list",
    "OFAC_SDN_sanctions_list": "OFAC SDN sanctions list"
  },
  "integrations": {
    "Connect_Accounton_Integrations": "Connect AMLCare ↔ Accounton",
    "Connect_Accounton_Integrations_Description": "Connect your AMLCare and Accounton back offices. Then link AdminPulse in Accounton; from that moment, you manage synchronization settings in AMLCare and data exchange (clients, documents, tasks) begins. You’ll be securely redirected to Accounton to grant one-time access (admins only).",
    "Log_In_With_Accounton": "Step 1: Connect AMLCare with Accounton",
    "Accounton_Connected": "AMLCare is connected with Accounton. If AdminPulse is linked in Accounton, the settings below are automatically displayed, allowing AMLCare to synchronize clients, documents, and tasks. If not yet linked, you can easily configure this in Accounton.",
    "Configure_in_accounton": "Open Accounton settings",
    "Download_Xlsx": "Download Excel File",
    "Generating_Import_Xlsx": "Generating import file...",
    "Push_Documents": "Send documents to AdminPulse",
    "Save_Settings": "Save settings and start synchronisation",
    "View_Invalid_Customers": "Customers with invalid data in AdminPulse",
    "Load_Templates_Error": "Failed to load task templates",
    "Settings_Saved_Success": "Settings saved successfully",
    "Settings_Save_Error": "Failed to save settings",
    "Load_Settings_Error": "Failed to load settings",
    "Load_Invalid_Customers_Error": "Failed to load invalid customers",
    "Connection_Success": "Connection established successfully",
    "Connection_Error": "Failed to establish connection",
    "Create_Import_File_Success": "Import file created successfully",
    "Create_Import_File_Error": "Failed to create import file",
    "No_Search_Results_Found": "No customers found matching your search.",
    "Name": "Customer name",
    "Field": "Invalid field",
    "ErrorMessage": "Additional information",
    "Import_all_customers": "Import all customers (with status 'Customer')",
    "Import_customers_from_a_task_template": "Only import customers (with status 'Customer') from a task template",
    "Select_Task_Templates": "Select task templates",
    "Add_More_Task_Templates": "Add more task templates",
    "Syneton_AdminIS/Consult": "Syneton AdminIS/Consult",
    "Choose_which_data_to_import_from_AdminPulse": "Choose which customers to import",
    "Invalid_Customers_List": "Customers with invalid data in AdminPulse",
    "Connected": "Connected",
    "Confirmation": "Are you sure you want to save these settings?",
    "Are_You_Sure_To_Save_Settings": "We will start a synchronization and check for customers that are not yet in Accounton.",
    "Sync_started_message": "Synchronization with AdminPulse started. Customers are being checked and added. This process may take a few minutes.",
    "Update_customer_sync_error": "Update customer sync error",
    "Synchronize_AdminPulse_Customers": "Synchronize AdminPulse customers and data to AMLCare",
    "Update_data_fields": "Send data fields (CAP date, new CAP date, risk, and ID expiry date) to AdminPulse",
    "Sync_in_progress": "Sync in progress\n",
    "Please_wait_sync_message": "A synchronization is currently running. Please wait until it has fully completed before starting a new one.",
    "Task_Template_Selection_Required": "Please select at least one task template before starting the synchronization.",
    "Archive_Inactive_Customers": "Automatically archive inactive AdminPulse clients in AMLCare",
    "Accounton_connected_successfully": "AMLCare is connected with Accounton. When AdminPulse is linked in Accounton, the settings below are automatically displayed, allowing AMLCare to synchronize clients, documents, and tasks.",
    "Configure_accounton": "If not yet linked, you can easily configure this in Accounton.",
    "Connected_Account": "Connected account",
    "Invalid_Customers_Message": "{{count}} customers could not be synced due to invalid data",
    "Invalid_Customer_Message_Singular": "{{count}} customer could not be synced due to invalid data",
    "View_Customers": "View customers",
    "Choose_information_to_synchronize_in_AdminPulse": "Choose which information to synchronize in AdminPulse",
    "Invalid_Customers_Search_Placeholder": "Enter a customer name"
  },
  "suggestionBanner": {
    "description": "Indicate below, per role, how you would like to handle the proposed changes.",
    "relationSingular": "relation",
    "relationPlural": "relations",
    "DirectorSingular": "Director",
    "DirectorPlural": "Directors",
    "Permanent representativeSingular": "Permanent representative",
    "Permanent representativePlural": "Permanent representatives",
    "OTB_Add_And_Remove_SuggestionBanner_Title": "AMLCare found {{addedCount}} directors and/or permanent representatives to add and {{removedCount}} to remove based on public sources.",
    "OTB_Remove_SuggestionBanner_Title": "AMLCare found {{removedCount}} directors and/or permanent representatives to remove based on public sources.",
    "UBO_Add_And_Remove_SuggestionBanner_Title": "AMLCare found {{addedCount}} UBO(s) to add and {{removedCount}} UBO(s) to remove based on the UBO register.",
    "UBO_Add_SuggestionBanner_Title": "AMLCare found {{addedCount}} UBO(s) to add based on the UBO register.",
    "UBO_Remove_SuggestionBanner_Title": "AMLCare found {{removedCount}} UBO(s) to remove based on the UBO register.",
    "OTB_Add_SuggestionBanner_Title": "AMLCare found {{addedCount}} directors and/or permanent representatives to add based on public sources."
  },
  "kyc-logs": {
    "Overview": "Overview",
    "Mandates": "Mandates",
    "Participations": "Participations",
    "SameAddress": "Same Address",
    "Company profile": "Company profile",
    "Directors": "Directors",
    "Board Mandates": "Board Mandates",
    "Shareholders": "Shareholders",
    "Natural Persons": "Natural Persons",
    "Legal Entities": "Legal Entities",
    "Name_changed_to_{{changedName}}_in_KYC_company_profile": "Company name updated to: {{changedName}}",
    "VAT_changed_to_{{changedVat}}_in_KYC_company_profile": "The VAT number changed to: {{changedVat}}.",
    "Financial_health_changed_to_{{changedFinancialHealthIndicator}}_in_KYC_company_profile": "Company financial health indicator updated to: {{changedFinancialHealthIndicator}}",
    "Address_changed_to_{{changedAddress}}_in_KYC_company_profile": "Company address updated to: {{changedAddress}}",
    "Juridical_status_changed_to_{{changedJuridicalStatus}}_in_KYC_company_profile": "Company legal status updated to:  {{changedJuridicalStatus}}",
    "Juridical_situation_changed_to_{{changedJuridicalSituation}}_in_KYC_company_profile": "Company legal situation updated to: {{changedJuridicalSituation}}",
    "Added_{{personName}}_as_a_natural_person_in_mandate_director_of_KYC": "{{personName}} registered as \"director\" of the company",
    "Added_{{company}}_as_a_board_mandate_of_KYC": "Company registered as \"director\" of {{company}}\n",
    "Added_{{entityName}}_as_a_legal_entity_in_mandate_director_of_KYC": "{{entityName}} registered as \"director\" of the company",
    "Added_{{entityName}}_as_a_legal_entity_in_stackholder_of_KYC": "{{entityName}} registered as \"shareholder\" of the company",
    "Added_{{personName}}_as_a_natural_person_in_stackholders_of_KYC": "{{personName}} registered as \"shareholder\" of the company",
    "Added_{{companyName}}_in_participations_of_KYC": "Company registered as \"shareholder\" of {{companyName}}",
    "Added_{{personName}}_as_a_natural_person_in_same_address_of_KYC": "{{personName}} registered at the same address as the company",
    "Added_{{entityName}}_as_a_legal_entity_in_same_address_of_KYC": "{{entityName}} registered at the same address as the company",
    "Removed_{{entityName}}_as_a_legal_entity_in_same_address_of_KYC": "{{entityName}} no longer registered at the same address as the company",
    "Removed_{{personName}}_as_a_natural_person_in_same_address_of_KYC": "{{personName}} no longer registered at the same address as the company",
    "Removed_{{companyName}}_in_participations_of_KYC": "Company no longer registered as \"shareholder\" of {{companyName}}",
    "Removed_{{personName}}_as_a_natural_person_in_stackholders_of_KYC": "{{personName}} no longer registered as \"shareholder\" of the company",
    "Removed_{{entityName}}_as_a_legal_entity_in_stackholders_of_KYC": "{{entityName}} no longer registered as \"shareholder\" of the company",
    "Removed_{{entityName}}_as_a_legal_entity_in_mandate_director_of_KYC": "{{entityName}} no longer registered as \"director\" of the company",
    "Removed_{{company}}_as_a_board_mandate_of_KYC": "Company no longer registered as \"director\" of {{company}}",
    "Removed_{{personName}}_as_a_natural_person_in_mandate_director_of_KYC": "{{personName}} no longer registered as \"director\" of the company",
    "Status_changed_to_{{politicalMandateStatus}}_in_person_{{personName}}_from_natural_person_in_mandate_director_of_KYC": "The \"political mandate status\" of {{personName}} changed to: {{politicalMandateStatus}}.",
    "Kyc_Log_List_Not_Found": "No monitoring activity yet. Changes and updates will appear here.",
    "Locations": "Establishments",
    "KYC_Location_added_for_{{CompanyName}}": "New establishment unit for {{CompanyName}}",
    "KYC_Location_removed_for_{{CompanyName}}": "Establishment unit for {{CompanyName}} removed",
    "Legal_form_changed_to_{{changedJuridicalForm}}_in_KYC_company_profile": "Company legal form updated to:  {{changedJuridicalForm}} ",
    "AdverseMedia": "Adverse media",
    "SanctionsDataset": "Sanctions",
    "Customer_found_under_Financial_Crimes_and_Money_Laundering": "Customer linked to financial crimes and money laundering in AI adverse media check",
    "Customer_found_under_Terrorism_and_crime": "Customer linked to terrorism and crime in AI adverse media check",
    "Customer_found_under_Corruption_and_Bribery": "Customer linked to corruption and bribery in AI adverse media check",
    "Customer_found_under_Litigation_and_Legal_Issues": "Customer linked to litigation and legal issues in AI adverse media check",
    "Customer_found_under_National_sanctions_list": "Customer found on National Sanctions List (BE)",
    "Customer_found_under_European_sanctions_list": "Customer found on European Sanctions List",
    "Customer_found_under_European_travel_ban_list": "Customer found on European Travel Ban List",
    "Customer_found_under_UN_sanctions_list": "Customer found on UN Sanctions List",
    "Customer_found_under_OFAC_SDN_sanctions_list": "Customer found on OFAC SDN Sanctions List",
    "Customer_found_under_OFAC_consolidated_sanctions_list": "Customer found on OFAC Consolidated Sanctions List",
    "Customer_removed_from_Financial_Crimes_and_Money_Laundering": "Customer unlinked from financial crimes and money laundering in AI adverse media check",
    "Customer_removed_from_Terrorism_and_crime": "Customer unlinked from terrorism and crime in AI adverse media check",
    "Customer_removed_under_Corruption_and_Bribery": "Customer unlinked from corruption and bribery in AI adverse media check",
    "Customer_removed_under_Litigation_and_Legal_Issues": "Customer unlinked from litigation and legal issues in AI adverse media check",
    "Customer_removed_from_National_sanctions_list": "Customer removed from National Sanctions List (BE)",
    "Customer_removed_from_European_sanctions_list": "Customer removed from European Sanctions List",
    "Customer_removed_from_European_travel_ban_list": "Customer removed from European Travel Ban List",
    "Customer_removed_from_UN_sanctions_list": "Customer removed from UN Sanctions List\n",
    "Customer_removed_from_OFAC_SDN_sanctions_list": "Customer removed from OFAC SDN Sanctions List",
    "Customer_removed_from_OFAC_consolidated_sanctions_list": "Customer removed from OFAC Consolidated Sanctions List",
    "Customer_found_under_Political_mandate_CSV": "Political mandate found for customer (source: Flemish Mandate Database)",
    "Customer_found_under_Political_mandate_PDF": "Political mandate found for customer (source: Belgian Court of Audit)",
    "Customer_removed_from_Political_mandate_PDF": "Political mandate removed for customer (source: Belgian Court of Audit)",
    "Customer_removed_from_Political_mandate_CSV": "Political mandate removed for customer (source: Flemish Mandate Database)",
    "Ongoing_monitoring_disclaimer": "This section displays automatic updates based on changes detected in public sources. These updates are not the result of manual actions in AMLCare, but are generated automatically when information about this customer changes in official databases and public registries.",
    "PoliticalInvolvement": "Political involvements",
    "Customer_found_as_Politically_Exposed_Person": "Relation identified as a possible Politically Exposed Person (PEP)",
    "Customer_removed_as_Politically_Exposed_Person": "Relation removed as a possible Politically Exposed Person (PEP)",
    "Financial_crimes_and_money_laundering_evidence_found": "Financial crimes and money laundering evidence found",
    "Sanctions_match_found": "Sanctions match found",
    "Customer_removed_from_Financial_crimes": "Customer removed from Financial crimes",
    "Address_removed_in_KYC_company_profile": "Company address removed"
  },
  "suggestion_dialog": {
    "create_director_and_pr_title": "Create director and permanent representative?",
    "create_director_and_pr_message": "A new company <strong>{{cdName}}</strong> will be created as \"director\" and a new person <strong>{{prName}}</strong> as permanent representative. They will be linked to <strong>{{company}}</strong>. Do you want to continue?",
    "yes_create_both": "Yes, add both",
    "cancel": "Cancel",
    "confirm_new_role_title": "Confirm data",
    "confirm_new_role_message": "Do you want to add the <strong>{{translatedRole}}</strong> role to <strong>{{suggestedName}}</strong>?",
    "yes_add_role": "Yes, add {{translatedRole}} role",
    "add_director_and_pr_title": "Add director and permanent representative?",
    "add_director_and_pr_nested_message": "To add <strong>{{suggestedName}}</strong> as a permanent representative, the company they are linked to also needs to be added. <br><br> Choose how you would like to add <strong>{{parentCompanyName}}</strong> as a \"director\" for <strong>{{customerName}}</strong>. It will be added with <strong>{{suggestedName}}</strong> as their permanent representative.",
    "link_to_existing_customer_title": "Add role ‘{{translatedRole}}’ to an existing relation?",
    "link_to_existing_customer_message": "According to available sources, <strong>{{suggestedName}}</strong> is a <strong>{{translatedRole}}</strong> of <strong>{{customerName}}</strong>. <br><br> AMLCare found the existing relation(s) below that may correspond to <strong>{{suggestedName}}</strong>. Select the correct relation to add the role <strong>{{translatedRole}}</strong>.",
    "select_pr_director_part1_title": "Part 1: Select this permanent representative’s director",
    "select_pr_director_link_diff_message": "To add <strong>{{suggestedName}}</strong> as a permanent representative, they also need to be linked to a director. <br><br>First, choose which existing <strong>{{parentCompanyName}}</strong> should be added as \"director\" for <strong>{{currentCompanyName}}</strong>. Next, you can select which <strong>{{suggestedName}}</strong> should be their permanent representative.",
    "no_create_new_director": "No, create new director",
    "select_pr_director_link_message": "To add <strong>{{suggestedName}}</strong> as a permanent representative, they also need to be linked to a director. <br><br>First, choose how you would like to add <strong>{{parentCompanyName}}</strong> as Director for <strong>{{currentCompanyName}}</strong>. Next, you can select which <strong>{{suggestedName}}</strong> should be their Permanent representative.",
    "add_director_and_pr_other_message": "<strong>{{parentCompanyName}}</strong> will be created as Director for <strong>{{currentCompanyName}}</strong>. Next, select which <strong>{{suggestedName}}</strong> should be the Permanent representative.",
    "match_to_existing_customer_title": "Match '{{suggestedName}}' to an existing customer?",
    "match_to_existing_customer_message": "According to public records, <strong>{{suggestedName}}</strong> has a relation to <strong>{{currentCompanyName}}</strong>. <br><br>Please confirm which of your existing customers should be linked:",
    "no_create_new_relation": "No, create new relation",
    "create_new_relation_nested_message": "To add <strong>{{suggestedName}}</strong> as a Permanent representative, the company they are linked to also needs to be added. <br><br> Please confirm that you'd like to create both a new <strong>{{parentCompanyName}}</strong> Director and link <strong>{{suggestedName}}</strong> as its Permanent representative.",
    "yes_add_both_relations": "Yes, add both relations",
    "confirm_new_relation_title": "Create new relation",
    "confirm_new_relation_message": "Do you want to create a new relation for <strong>{{suggestedName}}</strong> with the role <strong>{{translatedRole}}</strong>?",
    "yes_create_new_relation": "Yes, create new relation",
    "select_director_pr_part2_title": "Part 2: select this director’s permanent representative",
    "select_director_pr_title": "Select this director’s permanent representative",
    "select_director_pr_message": "According to available sources, <strong>{{suggestionName}}</strong> is the <strong>permanent representative</strong>. <br><br> AMLCare found the existing relation(s) below that may correspond to <strong>{{suggestionName}}</strong>. Select the correct relation to add the role <strong>permanent representative</strong>.",
    "create_pr_under_existing_cd_title": "Create a new permanent representative?",
    "create_pr_under_existing_cd_message": "A new person <strong>{{prName}}</strong> will be created as permanent representative and linked under <strong>{{directorName}}</strong> for <strong>{{company}}</strong>. Continue?",
    "create_new_customer": "New relation",
    "select_pr_director_part1_title_v2": "Part 1: select this permanent representative’s director",
    "select_pr_director_part1_message_v2": "First, choose which existing <strong>{{parentCompanyName}}</strong> should be added as Director for <strong>{{customerName}}</strong>. Then you'll select which <strong>{{suggestionName}}</strong> should be their Permanent representative.",
    "this_person_fallback": "This person",
    "ubo_register_information": "UBO register",
    "existing_values": "Current data",
    "percent_of_shares": "% of shares",
    "confirm_new_relation_ubo_message": "Would you like to create a new relation for <strong>{{suggestedName}}</strong> with the role <strong>{{translatedRole}}</strong>? The available data from the UBO register will automatically be used to complete the relation.",
    "confirm_add_role_ubo_message": "The UBO register contains data for this person that differs from the current data or provides additional information.",
    "yes_add_ubo_and_update_fields": "Use UBO data",
    "add_ubo_only_keep_existing_data": "Keep current data",
    "confirm_add_role_ubo_question": "The role <strong>{{translatedRole}}</strong> will be added to <strong>{{suggestedName}}</strong> in any case. Choose below which data you want to use.",
    "shares": "Shares",
    "public_data": "Public data",
    "juridical_form": "Legal form",
    "company_name": "Company Name",
    "yes_add_role_and_update_fields": "Use public data",
    "confirm_new_relation_public_data_message": "Would you like to create a new relation for <strong>{{suggestedName}}</strong> with the role <strong>{{translatedRole}}</strong>? The available data from public sources will automatically be used to complete the relation.",
    "confirm_add_role_public_data_message": "Public sources have information that differs from what is currently saved. Review the comparison below.",
    "confirm_add_role_public_data_question": "The role <strong>{{translatedRole}}</strong> will be added to <strong>{{suggestedName}}</strong> in any case. Choose below which data you want to use.",
    "confirm_new_nested_relation_public_data_message": "A new company <strong>{{cdName}}</strong> will be created as \"{{translatedCdRole}}\" and a new person <strong>{{prName}}</strong> as {{translatedRole}}, with information from public record data. They will be linked to <strong>{{company}}</strong>. Do you want to continue?",
    "confirm_new_nested_relation_message": "A new company {{cdName}} will be created as \"{{translatedCdRole}}\" and a new person {{prName}} as {{translatedRole}}. They will be linked to {{company}}. Do you want to continue?",
    "unarchive_and_link": "Unarchive and link",
    "apply_suggested_changes": "Apply {{count}} suggested changes?",
    "apply_suggested_change": "Apply 1 suggested change?",
    "apply_all": "Apply all",
    "apply_one": "Apply",
    "bulk_remove_role_summary": "<strong>Remove {{count}} roles:</strong> ({{names}})",
    "bulk_remove_role_summary_singular": "<strong>Remove 1 role:</strong> ({{names}})",
    "bulk_create_relation_summary": "<strong>Create {{count}} relations</strong> ({{names}})",
    "bulk_create_relation_summary_singular": "<strong>Create 1 relation</strong> ({{names}})",
    "bulk_link_relation_summary": "<strong>Link {{count}} existing relations</strong> ({{names}})",
    "bulk_link_relation_summary_singular": "<strong>Link 1 existing relation</strong> ({{names}})",
    "apply_all_confirmation_message": "Please confirm that you would like to accept the following suggestion:",
    "apply_all_confirmation_messages": "Please confirm that you would like to accept the following suggestions:",
    "continue": "Continue",
    "cancel_all_changes": "Cancel all changes",
    "multiple_found": "multiple matches found",
    "current_total_count": "({{current}} of {{total}})",
    "bulk_ambiguous_footnote_single_link": "{{name}} matches more than one existing relation. After you continue, you'll choose which one to link.",
    "bulk_ambiguous_footnote_all_link": "For the {{count}} matches above, you'll choose the right relation to link after you continue.",
    "bulk_ambiguous_footnote_partial_link": "For {{ambiguousCount}} of the {{total}} matches above, you'll choose the right relation to link after you continue.",
    "bulk_ambiguous_footnote_single_create": "{{name}} matches more than one existing company director. After you continue, you'll choose which one to attach.",
    "bulk_ambiguous_footnote_all_create": "For the {{count}} matches above, you'll choose the right company director after you continue.",
    "bulk_ambiguous_footnote_partial_create": "For {{ambiguousCount}} of the {{total}} matches above, you'll choose the right company director after you continue.",
    "bulk_unresolved_skip_footnote": "{{count}} suggestion(s) can't be applied automatically and will be skipped: {{names}}",
    "bulk_data_update_footnote": "{{count}} suggestion(s) have updated data available: {{names}}. After you continue, you'll choose whether to apply it.",
    "bulk_archived_footnote": "{{count}} suggestion(s) match an archived customer: {{names}}. After you continue, you'll be asked to unarchive and link each one.",
    "add_role_only_keep_existing_data": "Keep current data"
  },
  "ubo": {
    "choose_method": "Choose an import source:",
    "method_one_time_title": "One-time synchronization",
    "method_one_time_description": "Imported UBOs will be suggested on the Relations page. Each UBO addition must be reviewed and confirmed.",
    "Start_import": "Start import",
    "method_auto_title": "Automatic synchronization of the UBOs from the UBO Register.",
    "method_auto_description": "Imported UBOs will be suggested on the Relations page. Each UBO addition must be reviewed and confirmed.",
    "method_auto_description_changes": "UBO changes will be suggested in the customer's relations page. Users will need to review and confirm each change.",
    "method_manual_title": "Manually upload a UBO-register PDF",
    "info_basic": "<strong>After adding the customer, a UBO synchronization is automatically started for this customer, regardless of the option selected. It may take a few minutes for this process to complete. </strong><br><br>\nDepending on the selected synchronization setting, the synchronization then runs automatically on a periodic basis, or is only executed when you manually start a synchronization.<br><br>\n<strong>Imported UBOs are proposed on the 'Relations' page. </strong> Each addition or change to a UBO must always be reviewed and confirmed.\n",
    "info_multiOption": "<strong>After adding the customer, a UBO synchronization is automatically started for this customer, regardless of the option selected. It may take a few minutes for this process to complete. </strong><br><br>\nDepending on the selected synchronization setting, the synchronization then runs automatically on a periodic basis, or is only executed when you manually start a synchronization.<br><br>\n<strong>Imported UBOs are proposed on the 'Relations' page. </strong> Each addition or change to a UBO must always be reviewed and confirmed.\n",
    "info_autoSync": "UBO changes will be <strong>suggested</strong> in the customer's <strong>relations</strong>  page. Users will need to review and confirm each change.",
    "radio_label_individual": "First synchronization automatic, then start manually",
    "radio_label_bulk": "Automatic, continuous synchronization",
    "scenario_basic": "One-time synchronization of the UBOs from the UBO Register, after which you can start additional synchronizations yourself.",
    "scenario_multiOption": "Synchronize the UBOs from the UBO Register",
    "scenario_autoSync": "Automatic synchronization of the UBOs from the UBO Register.",
    "toggle_disabled_tooltip": "UBO synchronisation is only available for direct company relations.",
    "Import_Ultimate_Beneficial_Owners": "Retrieve UBO Information",
    "header_subtitle": "Select the source(s) below to keep this company’s UBOs up to date.\n<br><br>\nWe strongly recommend importing UBOs via <strong>automatic</strong> or <strong>one-time synchronization</strong>. These methods provide more and more reliable information.<br><br>\n\nIf this option is not visible, it may be because the administrator has not yet enabled it or because the synchronization is not active for this customer. In the latter case, this can be enabled by editing the customer details.<br><br>\n\nThe UBO PDF can be used as a backup option, but please note that it contains less detailed information.\n",
    "warning_already_started_24h": "UBO synchronisation was already initiated within the last 24 hours. Please try again later.",
    "error_sync_not_allowed": "UBO synchronisation is currently unavailable. Please try again later.",
    "error_kbo_required_for_sync": "A KBO number is required for UBO synchronisation.",
    "success_auto_sync_enabled": "Automatic UBO sync enabled.",
    "success_auto_sync_disabled": "Automatic UBO sync disabled.",
    "kbo_required": "A KBO number is required.",
    "individual_sync_not_allowed_tooltip": "UBO synchronisation is not available for natural persons."
  },
  "political-involvements": {
    "Rekenhof": "Court of audit",
    "Flemish_Mandate_Database": "Flemish Mandates Database",
    "AI_check": "AI check",
    "AI_details_placeholder": "AI-powered PEP check details will be displayed here when available.",
    "No_customers_found_in_political_involvements_list": "No relations found in the political mandates database",
    "Only_show_customers_found_on_a_list": "Only show relations with a match in the political mandates database",
    "AI_data_not_found": "Our AI-powered PEP check returned no results.",
    "political_involvements_disclaimer": "Our AI scans the web for possible mentions of the client related to political involvements. The functionality has a supportive role and the results should always be critically verified. Since the sources the AI scans look into usually do not contain unique identifiers (such as a national registration number), the search is primarily based on the name. As a result, some unrelated results may appear. The AI acts as a tool that provides suggestions only; the final assessment always lies with you. In the risk assessment, it can be explicitly indicated whether political involvements are actually applicable.",
    "tooltip_ai_clean": "No results found for this relation.",
    "tooltip_ai_found": "Results found for this relation.",
    "tooltip_ai_relation_warning": "No results found for this relation. One or more linked relations have results.",
    "status_not_found_on_list": "No match found.",
    "status_on_list": "Match found.",
    "status_relations_on_list": "{{count}} relations with a match.",
    "status_relations_with_results": "{{count}} relations with results.",
    "status_on_list_and_relations_on_list": "Match found, and {{count}} linked relations also have a match.",
    "Scanning_political_data": "Scanning political involvement data",
    "status_no_results_found": "No results found.",
    "Web_search_processing_in_progress": "We are currently verifying the Political involvement status for this relation. The app is currently displaying default values. The updated status will be reflected within the next 24 hours."
  },
  "notes": {
    "title": "Notes",
    "add_note": "Add note",
    "date_created": "Date created",
    "empty_title": "No notes yet",
    "empty_subtitle": "Notes and comments are visible to everyone with access to this relation.",
    "error_loading_notes": "Error loading notes for this relation.",
    "show_single_comment": "Show 1 comment",
    "show_multiple_comments": "Show {{count}} comments",
    "collapse_comments": "Collapse comments",
    "field_title": "Title",
    "placeholder_title": "Add a title",
    "field_description": "Description",
    "placeholder_description": "Enter a description",
    "cancel": "Cancel",
    "attach_file": "Attach file",
    "attach_file_tooltip": "You can upload {{fileTypes}} files up to {{maxSize}}.",
    "save": "Save",
    "placeholder_comment": "Add a comment",
    "add": "Add",
    "edit_note": "Edit note",
    "delete_note": "Delete note",
    "edit_comment": "Edit comment",
    "delete_comment": "Delete comment",
    "discard_note": "Discard note",
    "keep_editing": "Keep editing",
    "delete_note_title": "Delete note",
    "delete_comment_title": "Delete comment",
    "delete_comment_text": "Are you sure you want to delete this comment? This action cannot be undone.",
    "delete_note_text_simple": "Are you sure you want to delete this note? This action cannot be undone.",
    "delete_note_text": "Are you sure you want to delete this note? All comments linked to this note will also be deleted. This action cannot be undone.",
    "action_cannot_be_undone": "This action cannot be undone.",
    "file_rejected_title": "File rejected",
    "file_rejected_type_text": "This file type isn’t supported. Upload a {{fileTypes}} up to {{maxSize}}.",
    "file_rejected_size_text": "This file is too large. Upload a {{fileTypes}} up to {{maxSize}}.",
    "error_loading_comments": "Error loading comments for this relation.",
    "error_creating_note": "Failed to create the note.",
    "error_updating_note": "Failed to update the note.",
    "error_deleting_note": "Failed to delete the note.",
    "error_creating_comment": "Failed to create the comment.",
    "error_updating_comment": "Failed to update the comment.",
    "error_deleting_comment": "Failed to delete the comment.",
    "file_uploaded_title": "File uploaded successfully.",
    "error_uploading_file": "Failed to upload the file.",
    "error_deleting_file": "Failed to delete the file.",
    "discard_title": "Discard changes?",
    "discard_text": "You have unsaved changes to a note or comment. If you leave now, these changes will be lost.",
    "discard_changes": "Discard changes",
    "keep_changes": "Keep editing",
    "file_uploaded_detail": "This file has also been uploaded to the relation's {{link}} tab.",
    "attachments": "Attachments",
    "uploading_file": "Uploading file...",
    "add_attachment": "Attach file",
    "delete_attachment": "Delete attachment",
    "delete_attachment_text": "Are you sure you want to delete this attachment? This action cannot be undone.",
    "delete_comment_with_attachment_text": "This comment only has this attachment. Are you sure you want to delete this comment along with its attachment? This action cannot be undone.",
    "add_comment": "Add comment",
    "duplicate_file": "Duplicate file",
    "duplicate_note_file_text": "\"{{name}}\" is already attached to this note.",
    "duplicate_comment_file_text": "\"{{name}}\" is already attached to this comment.",
    "link_url_label": "Paste a URL",
    "link_url_placeholder": "Paste a website link",
    "link_url_invalid": "Enter a valid URL",
    "link_display_text_label": "Display text (optional)",
    "link_display_text_placeholder": "Text to display",
    "link_apply": "Apply changes",
    "link_add": "Link website",
    "max_attachments_title": "Too many attachments",
    "max_attachments_text": "You can not upload more than {{max}} attachments at once."
  },
  "review-workflow": {
    "Active_tasks_body": "This workflow is assigned to {{count}} active tasks across these customers:",
    "Active_tasks_body_one": "This workflow is assigned to {{count}} active task across these customers:",
    "Add_condition": "Add condition",
    "Add_step": "Add a step",
    "Add_step_disabled_no_category": "To add a step, first select a Task category for this review workflow.",
    "All_languages": "All languages",
    "Assignee_all_users": "All users",
    "Assignee_label_field_all": "{{field}} (all values)",
    "Assignee_mode_all_previous": "All users from previous steps",
    "Assignee_mode_all_previous_disabled_tooltip": "Step 1 has no previous steps to inherit assignees from.",
    "Assignee_mode_all_selected": "All users selected below",
    "Assignee_mode_choose_at_assignment": "Select from users below when task is created",
    "Assignee_placeholder": "Select users or labels",
    "Assignee_responsible": "Responsible",
    "Assignee_task_creator": "Task creator",
    "Cancel": "Cancel",
    "Category_all_languages_has_language_workflows": "A workflow already exists for {{languages}} in this category.",
    "Category_all_languages_has_signing_step": "The {{languages}} questionnaires include a signing step. Remove it from their templates to select all languages.",
    "Category_all_languages_has_signing_step_one": "The {{languages}} questionnaire includes a signing step. Remove it from the template to select all languages.",
    "Category_all_languages_label": "{{category}}: All languages ({{languages}})",
    "Category_already_has_workflow": "A review workflow already exists for this task category",
    "Category_has_signing_step": "This questionnaire includes a signing step, so it can't have a review workflow. Remove the signing step from its template to select it.",
    "Category_locked_active_tasks": "{{count}} active tasks are using this template. The task category can’t be changed until the tasks are completed or deleted.",
    "Category_locked_active_tasks_one": "{{count}} active task is using this template. The task category can’t be changed until the task is completed or deleted.",
    "Category_locked_active_tasks_error": "This template now has active tasks, so the task category can no longer be changed. Reload the page to see the latest state.",
    "Category_part_of_this_workflow_via_all_languages": "Already part of this review workflow via All languages.",
    "Category_part_of_workflow_via_all_languages": "Already part of the review workflow \"{{name}}\" via All languages.",
    "Close": "Close",
    "Column_active_tasks": "Active tasks",
    "Column_last_modified_by": "Last modified by",
    "Column_last_modified_on": "Last modified on",
    "Column_name": "Workflow name",
    "Column_step_count": "# of steps",
    "Column_task_type": "Task type",
    "Completion_approved": "Marked as approved",
    "Completion_signed": "Signed",
    "Completion_signed_disabled_one_only_tooltip": "This workflow already has a signing step, and a workflow can have only one.",
    "Condition_joiner_or": "or",
    "Condition_option_accepted": "Customer is accepted",
    "Condition_option_not_accepted": "Customer is not accepted",
    "Condition_option_risk_high": "Risk assessment is high",
    "Condition_option_risk_standard": "Risk assessment is standard",
    "Condition_option_risk_unknown": "Risk assessment is unknown",
    "Condition_option_unavailable": "Already used by, or conflicts with, another condition",
    "Condition_remove": "Remove condition",
    "Create_step": "Create step",
    "Create_workflow": "Create workflow",
    "Create_workflow_disabled_no_steps": "This workflow cannot be created without a configured step.",
    "Create_workflow_disabled_step_incomplete": "Complete your current step's configuration in order to create this workflow.",
    "Delete_step": "Delete step",
    "Delete_disabled_step_being_configured": "This step can't be deleted while another step is being configured.",
    "Delete_step_blocked": "This step can't be deleted because the next step needs a previous step to pull its assignees from.",
    "Delete_step_body": "Please confirm that you would like to delete this step. This action cannot be undone.",
    "Delete_step_title": "Delete this step?",
    "Delete_workflow": "Delete workflow",
    "Delete_workflow_body": "Please confirm that you would like to delete this workflow. This action cannot be undone.",
    "Delete_workflow_body_with_customers": "{{count}} in-progress tasks are running this workflow. They will continue unchanged — only new tasks will no longer get it. This action cannot be undone.",
    "Delete_workflow_body_with_customers_one": "{{count}} in-progress task is running this workflow. It will continue unchanged — only new tasks will no longer get it. This action cannot be undone.",
    "Delete_workflow_title": "Delete workflow",
    "Discard_step_body": "You haven't created this step yet. If you leave now, its configuration will be lost.",
    "Discard_step_confirm": "Discard step",
    "Discard_step_edit_body": "Your changes to this step have not been saved. If you leave now, they will be lost.",
    "Discard_step_edit_title": "Discard changes?",
    "Discard_step_title": "Discard this step?",
    "Discard_workflow_body": "You haven't updated this workflow yet. If you leave now, its configuration will be lost.",
    "Discard_workflow_confirm": "Discard workflow",
    "Discard_workflow_title": "Discard this workflow?",
    "Draft_category_unavailable": "The task category from your unsaved changes is no longer available and was not restored.",
    "Draft_outdated": "Your unsaved changes were based on an older version of this workflow and could not be restored.",
    "Drag_disabled_single_signing_step": "Approval steps cannot come after signing steps, so this step can’t move higher.",
    "Drag_disabled_single_step": "Add another step to enable reordering.",
    "Drag_disabled_step_being_configured": "Steps can't be reordered while another step is being configured.",
    "Edit_workflow_title": "Edit review workflow",
    "Empty_description": "Approval workflow define who reviews a task and in what order. Set one up to standardize tasks get approved, so required review steps are never missed.",
    "Empty_title": "No approval workflows",
    "Error_category_already_has_workflow": "A review workflow already exists for this task category. Reload the page to see the latest list.",
    "Error_category_overlap": "This category already has a workflow of the other kind (all languages or a single language). Reload the page to see the latest list.",
    "Error_delete_failed": "Could not delete the workflow. Please try again.",
    "Error_description_too_long": "Description must be {{max}} characters or fewer.",
    "Error_signing_step_must_be_last": "The signing step must be the last step of the workflow. Move it below all other steps before saving.",
    "Error_invalid_configuration": "This workflow configuration is not valid. Please review the steps and try again.",
    "Error_document_collects_signatures": "This questionnaire includes a signing step, so it can't be used in a review workflow yet. The questionnaire needs to be updated to remove it first.",
    "Error_load_failed": "Could not load review workflows. Please try again.",
    "Error_name_too_long": "Name must be {{max}} characters or fewer.",
    "Error_save_failed": "Could not save the workflow. Please try again.",
    "Error_step_name_too_long": "Step name must be {{max}} characters or fewer.",
    "Error_step_removed_while_editing": "This step was removed while you were editing it, so your changes could not be saved.",
    "Error_workflow_not_found": "This workflow no longer exists. It may have been deleted by another user.",
    "Field_auto_apply_all_languages": "Automatically apply this workflow to every new {{category}} task, in all languages",
    "Field_auto_apply_no_category": "Automatically apply this workflow to every new task of this category",
    "Field_auto_apply_prefix": "Automatically apply this workflow to every new",
    "Field_auto_apply_suffix": "task",
    "Field_description": "Workflow description",
    "Field_description_optional": "(optional)",
    "Field_description_placeholder": "Add a description for this workflow",
    "Field_name": "Name",
    "Field_name_placeholder": "Name this workflow",
    "Field_notify_on_complete": "Notify user(s) when the task is completed",
    "Field_task_category": "Task category",
    "Field_task_category_placeholder": "Choose a task type",
    "Keep_editing": "Keep editing",
    "Language_dutch": "Dutch",
    "Language_english": "English",
    "Language_french": "French",
    "Language_german": "German",
    "Language_portuguese": "Portuguese",
    "Loading": "Loading...",
    "New_workflow": "New workflow",
    "New_workflow_title": "New review workflow",
    "No_conditions": "No conditions added",
    "Notifications": "Notifications",
    "Pill_conditional": "Conditional",
    "Pill_signature_required": "Signature required",
    "Rejection_reassign_to": "If any step is rejected, re-assign to",
    "Step_default_name": "Step {{number}}",
    "Step_field_assignees": "Assignees",
    "Step_field_completion": "Step completed when",
    "Step_field_name": "Name",
    "Step_field_notify_by_email": "Notify assignee(s) by email",
    "Step_field_start_conditions": "Start step if",
    "Step_field_start_conditions_hint_first": "By default, this step starts as soon as the workflow is assigned. Add a condition to control when it starts instead.",
    "Step_field_start_conditions_hint_subsequent": "By default, this step starts as soon as the previous step is completed. Add a condition to control when it starts instead.",
    "Step_field_who_approves": "Who should approve?",
    "Step_summary_all_previous": "Assignee(s) from all previous steps",
    "Step_summary_all_users": "All assignees",
    "Step_summary_assignee_count": "{{count}} assignees",
    "Step_summary_assignee_count_one": "{{count}} assignee",
    "Step_summary_choose_at_creation_all_users": "Assignee(s) chosen at task creation from all users",
    "Step_summary_choose_at_creation_from": "Assignee(s) chosen at task creation from {{parts}}",
    "Step_summary_choose_at_creation_join": "{{first}} and {{second}}",
    "Step_summary_choose_at_creation_label": "{{count}} labels",
    "Step_summary_choose_at_creation_label_one": "{{count}} label",
    "Step_summary_choose_at_creation_user": "{{count}} users",
    "Step_summary_choose_at_creation_user_one": "{{count}} user",
    "Steps": "Steps",
    "Tab_title": "Task review workflows",
    "Task_category_none_available": "There are no risk assessment categories available in your firm.",
    "Task_type_all_languages": "{{category}}: All languages",
    "Update_step": "Update step",
    "Update_step_disabled_unchanged": "Disabled until you make an update to the step configuration.",
    "Update_workflow": "Update workflow",
    "Update_workflow_impact_body": "This workflow is currently assigned to {{count}} tasks. Changes to this workflow will not affect existing assigned tasks and will only apply to new assignments.",
    "Update_workflow_impact_body_one": "This workflow is currently assigned to {{count}} task. Changes to this workflow will not affect existing assigned tasks and will only apply to new assignments.",
    "Update_workflow_impact_title": "Update workflow",
    "Workflow_created": "Workflow created successfully",
    "Workflow_deleted": "Workflow deleted successfully",
    "Workflow_updated": "Workflow updated successfully"
  },
  "tasks": {
    "actions_archive_group": "Archive CAP group",
    "actions_copy_url": "Copy link",
    "actions_delete": "Delete task",
    "actions_details": "Task details",
    "actions_download": "Download",
    "actions_download_uploads": "Download uploaded files",
    "actions_group_collapse": "Collapse",
    "actions_group_expand": "Expand",
    "actions_mark_complete": "Mark as complete",
    "actions_preview": "Preview",
    "actions_send_invite": "Send invite",
    "actions_send_reminder": "Send reminder",
    "actions_start": "Start",
    "actions_view": "View",
    "actions_view_questionnaire": "View questionnaire",
    "add_all_previous_assignees": "Everyone who acted on this task",
    "add_assign_workflow_checkbox": "Assign the <b>{{workflow}}</b> workflow to this task",
    "add_assigned_workflow": "Assigned workflow",
    "add_select_a_user": "Select a user",
    "add_select_a_workflow_or_user": "Select a workflow or user",
    "add_step_condition_generic": "This step will only be assigned if {{field}} is {{value}}.",
    "add_step_condition_risk_assessment": "This step will only be assigned if the risk assessment is {{value}}.",
    "add_step_label": "Step {{order}}:",
    "add_step_two_hint": "The {{workflow}} workflow requires assignees at task creation.",
    "add_task": "Add task",
    "column_category": "Task category",
    "column_date": "Date",
    "column_progress": "Progress",
    "column_status": "Status",
    "column_type": "Type",
    "completed_on": "Completed on",
    "confirm_archive_action": "Archive task",
    "confirm_archive_body": "This task will be moved to the archive. You can restore it later.",
    "confirm_archive_title": "Archive this task?",
    "confirm_assignment_body": "Confirm that you would like to change this task’s assignment from <b>{{from}}</b> to <b>{{to}}</b>.",
    "confirm_step_assignment_body": "Confirm that you would like to change this step’s assignment from <b>{{from}}</b> to <b>{{to}}</b>.",
    "confirm_delete_action": "Delete task",
    "confirm_delete_body": "This task and its answers will be permanently deleted.",
    "confirm_delete_title": "Delete this task?",
    "confirm_download_action": "Download anyway",
    "confirm_download_body": "This questionnaire is not fully completed. The download will contain only the answers given so far.",
    "confirm_download_title": "Download an incomplete task?",
    "confirm_preview_action": "Preview anyway",
    "confirm_preview_body": "This questionnaire is not fully completed. The preview will show only the answers given so far.",
    "confirm_preview_title": "Preview an incomplete task?",
    "confirm_takes_effect_immediately": "This change takes effect immediately.",
    "confirm_update_step_assignment": "Update step assignment?",
    "confirm_update_step_assignment_action": "Update step assignment",
    "confirm_update_task_assignment": "Update task assignment?",
    "confirm_update_task_assignment_action": "Update task assignment",
    "assignment_picker_title": "Choose step assignees",
    "assignment_picker_description": "The {{workflowName}} workflow requires assignees for some steps before it can be assigned. Choose one or more users from each step's configured group — remaining steps are assigned automatically.",
    "assignment_picker_confirm": "Assign workflow",
    "details_answer": "Answer",
    "details_assign": "Assign",
    "details_assign_user": "Assign a user",
    "details_assign_workflow_or_user": "Assign a workflow or user",
    "details_assigned_user": "Assigned user",
    "details_assigned_workflow": "Assigned workflow",
    "details_close": "Close",
    "details_completed_on": "Completed on",
    "details_no_workflow": "No workflow",
    "details_not_submitted": "Not submitted",
    "details_notify_not_sent": "Not sent",
    "details_notify_on_complete": "When this task is complete, notify",
    "details_notify_sent": "Sent",
    "details_progress": "Progress:",
    "details_question": "Question",
    "details_reassign": "Re-assign",
    "details_rejection_declined_in_portal": "Declined in the e-sign portal.",
    "details_rejection_portal_explainer": "The request has been withdrawn for everyone. To continue, either change who needs to sign, or reopen the questionnaire and correct it — a new request goes out once you resolve this step.",
    "details_risk": "Risk",
    "details_risk_weight": "Risk weight",
    "details_select_a_user": "Select a user",
    "details_select_workflow_or_user": "Select a workflow or user",
    "details_status": "Status",
    "details_submitted": "Submitted",
    "details_tab_questionnaire": "Questionnaire answers",
    "details_tab_steps": "Steps and assignees",
    "details_title": "Task details",
    "details_total_risk_weight": "Total risk weight:",
    "notifications_assignment_failed": "Could not update the assignment",
    "notifications_assignment_updated": "Assignment updated",
    "notifications_download_failed": "Download failed. Please try again.",
    "notifications_invite_failed": "Could not send the invite",
    "notifications_invite_sent": "Invite sent",
    "notifications_load_failed": "Could not load tasks. Please try again.",
    "notifications_assignee_options_failed": "Could not load the list of assignees. Please try again.",
    "notifications_reminder_failed": "Reminder could not be sent. Please try again.",
    "notifications_reminder_sent": "Reminder sent",
    "notifications_step_unavailable": "That step is no longer available. Please reopen the task and try again.",
    "notifications_task_archive_failed": "Could not archive this task. Please try again.",
    "notifications_task_archived": "Task archived",
    "notifications_task_delete_failed": "Could not delete the task",
    "notifications_task_deleted": "Task deleted successfully",
    "risk_high": "High",
    "risk_standard": "Standard",
    "risk_unknown": "Unknown",
    "special_assignee_allUsers": "All users",
    "special_assignee_amlcoOfficer": "AMLCO officer",
    "special_assignee_responsible": "Responsible user",
    "special_assignee_taskCreator": "Task creator",
    "special_assignee_unknown": "Unknown assignee",
    "status_completed": "Completed",
    "status_in_progress": "In progress",
    "status_not_sent": "Not sent",
    "status_not_started": "Not started",
    "status_rejected": "Rejected",
    "status_sent": "Sent",
    "status_skipped": "Skipped",
    "status_workflow_step": "In review",
    "steps_active_suffix": "(Active)",
    "steps_signature_request_not_sent": "The signature request has not been sent yet.",
    "steps_signature_request_reissued": "Signature request re-issued on {{date}} — everyone has been asked to sign again.",
    "steps_all_previous_assignees": "All previous assignees",
    "steps_all_selected_assignees": "All selected assignees",
    "steps_comment_tooltip": "{{count}} comments added by assignees",
    "steps_comment_tooltip_one": "1 comment added by assignee",
    "steps_comment": "Comment",
    "steps_completed_at_tooltip": "Completed on {{date}}",
    "steps_no_assignees": "No assignees",
    "steps_no_comment": "No comments added",
    "steps_search_assignees": "Search users and labels",
    "steps_select_assignees": "Select assignees",
    "type_External": "External",
    "type_Internal": "Internal",
    "add_step_conditional_hint": "This step will only be assigned if its configured condition is met.",
    "add_step_conditional_hint_conditions": "This step will only be assigned if {{value}}.",
    "add_step_conditional_hint_join_or": "or",
    "actions_view_esign_request": "View e-sign request",
    "actions_view_rejected_signing": "View e-sign request",
    "step_status_notStarted": "Not started",
    "step_status_inProgress": "In progress",
    "step_status_completed": "Completed",
    "step_status_skipped": "Skipped",
    "step_status_rejected": "Rejected",
    "errors_workflow_not_found": "That workflow could not be found.",
    "errors_workflow_not_applicable": "This task category cannot run a review workflow.",
    "errors_instance_not_found": "This task's workflow could not be found. Refreshing…",
    "errors_workflow_already_assigned": "This task already runs a workflow — remove it before assigning a new one.",
    "errors_workflow_auto_applied_cannot_be_detached": "This workflow was applied automatically and cannot be removed.",
    "errors_category_mismatch": "That workflow doesn't apply to this task's category.",
    "errors_task_already_submitted": "This task is already submitted — there is nothing left to approve.",
    "errors_task_archived": "This task is archived and can no longer be changed.",
    "errors_unknown_step": "That step no longer exists on this workflow.",
    "errors_step_not_editable": "This step's assignees are fixed and cannot be changed.",
    "errors_step_not_editable_anymore": "This step has already settled — its assignees can no longer be changed.",
    "errors_assignee_not_in_pool": "That person is not eligible for this step.",
    "errors_assignee_unavailable": "That person is no longer available.",
    "errors_workflow_has_no_steps": "This workflow has no steps configured.",
    "errors_not_a_customer_task": "This task type cannot run a review workflow.",
    "errors_not_an_internal_task": "Only internal questionnaires can run a review workflow.",
    "errors_step_assignees_required": "A step must have at least one assignee.",
    "errors_last_approver_required": "The last approval step must keep at least one assignee who hasn't approved yet. Assign a replacement before removing this one.",
    "errors_step_already_settled": "Someone else already acted on this step. Refreshing…",
    "errors_instance_already_completed": "This workflow has already completed, so its notification list can no longer be changed.",
    "errors_step_comment_required": "A comment is required to reject this step.",
    "errors_signing_step_not_supported": "Signing steps aren't supported yet — this will open in a new tab once it is.",
    "errors_submit_failed": "The task could not be submitted. Please try again.",
    "errors_questionnaire_incomplete": "The questionnaire must be fully filled in before it can be approved.",
    "errors_questionnaire_session_not_identified": "This link doesn't identify who is acting — open the questionnaire from your assigned link instead.",
    "errors_no_active_step": "There is nothing to act on for this workflow right now.",
    "errors_questionnaire_assignees_only": "Only this step's assignees can open this questionnaire while the workflow is running.",
    "errors_task_action_blocked_while_running": "This task can't be changed while its workflow is running.",
    "errors_signing_already_issued": "An e-sign request has already been sent for this step.",
    "errors_signing_not_retryable": "This step is no longer active, so its e-sign request can't be sent again.",
    "errors_signing_still_sending": "The e-sign request is still being sent. Please try again in a couple of minutes.",
    "errors_signing_no_signers": "This step has no assignee, so the e-sign request can't be sent. Add an assignee to the step and try again.",
    "errors_signing_no_document": "This task has no generated report, so the e-sign request can't be sent.",
    "errors_signing_retry_failed": "The e-sign request could not be sent. Please try again.",
    "signing_request_sent": "E-sign request sent successfully.",
    "signing_request_retry": "Retry e-sign request",
    "errors_requires_task_owner": "Only the task's owner can do this.",
    "errors_requires_step_assignee": "Only this step's assignees can do this.",
    "errors_requires_rejection_assignee": "Only the person this rejection was handed to can resolve it.",
    "errors_step_not_actionable": "Someone else already acted on this step. Refreshing…",
    "errors_step_already_acted": "You've already acted on this step — nothing left to decide.",
    "errors_step_not_found": "That step could not be found. Refreshing…",
    "errors_no_customer_access": "You don't have access to this customer.",
    "errors_questionnaire_collects_signatures": "This task's questionnaire includes a signing step, so a review workflow can't be assigned to it.",
    "errors_notify_recipients_required": "At least one recipient is required when \"notify on complete\" is enabled."
  },
  "add-task-workflow-step": {
    "No_customer_access_suffix": "{{name}} (no customer access)",
    "No_customer_access_members": "{{name}} (no customer access: {{members}})",
    "No_customer_access_warning": "One or more selected assignees do not have access to this customer. Choose a different assignee or contact an admin.",
    "No_customer_access_create_warning": "One or more selected assignees do not have access to this customer. Choose a different assignee or contact an admin.",
    "No_customer_access_fixed_warning": "One or more of this step's assignees do not have access to this customer, so they cannot complete this step. Contact an admin.",
    "No_customer_access_modal_title": "Some assignees have no customer access",
    "No_customer_access_modal_text": "One or more assignees of these steps do not have access to this customer and will not be able to act on them:",
    "No_customer_access_modal_confirm": "Create task anyway",
    "No_customer_access_modal_cancel": "Go back"
  },
  "assigned-tasks-trigger": {
    "Assigned_tasks": "Assigned tasks",
    "Date_assigned": "Date assigned",
    "No_assigned_tasks": "No assigned tasks",
    "No_assigned_tasks_hint": "We'll display a badge when a task is assigned to you.",
    "No_search_results": "No assigned tasks match your search",
    "No_customer_access": "You don't have access to this customer. Contact an admin for help.",
    "Search_for_a_customer": "Search for a customer",
    "Step_reference": "{{taskName}} > Step {{stepOrder}}: {{stepName}}",
    "Assigned_suffix": "was assigned to you.",
    "Rejected_suffix": "was rejected and handed to you.",
    "Rejected_by_system_suffix": "The questionnaire of {{taskName}} is incomplete, so it could not be sent for signing. It was reassigned to you.",
    "Step_start_failed": "Could not open this step. Please try again."
  },
  "step-decision-modal": {
    "Add_a_comment": "Add a comment",
    "Add_a_required_comment": "Add a required comment",
    "Approve_and_complete_description": "Approving will complete the {{stepName}} step and finish this task.",
    "Approve_and_complete_task": "Approve and complete task",
    "Approve_and_complete_title": "Approve and complete task",
    "Approve_and_send_description": "Approving this task will assign this task to the following step assignee. You won’t be able to make any more edits to the questionnaire.",
    "Approve_and_send_title": "Approve and send to next assignee?",
    "Approve_and_send_to_next_assignee": "Approve and send to next assignee",
    "Comment": "Comment",
    "Comment_required": "A comment is required to reject this task",
    "Comment_required_generic": "A comment is required",
    "Comment_too_long": "Comment must be 2000 characters or fewer",
    "Optional_suffix": "(optional)",
    "Reject_task": "Reject task",
    "Reject_task_description": "Please provide information for why you are rejecting this task:",
    "Reject_task_title": "Reject task?",
    "Resolution_comment": "Comment",
    "Resolve_and_reassign_confirm": "Resolve & Reassign",
    "Resolve_and_reassign_description": "Resolving will send the {{stepName}} step back to its original assignees for review.",
    "Resolve_and_reassign_title": "Resolve & Reassign"
  },
  "task-status-badge": {
    "Assignee_tooltip": "Assignee: {{assigneeName}}"
  },
  "task-step-row": {
    "Comment": "Comment",
    "Reassigned_to": "Re-assigned to",
    "Reassigned_by_system_tooltip": "{{taskName}}'s questionnaire is incomplete, so couldn't be sent for signing and was reassigned.",
    "Update": "Update"
  },
  "task-steps-list": {
    "Assignee": "Assignee",
    "Status": "Status",
    "Tab_questionnaire_disabled_tooltip": "No answers filled out yet."
  },
  "monitoring": {
    "column_date": "Date",
    "column_customer": "Customer",
    "column_section": "Section",
    "column_change": "Change",
    "column_status": "Status",
    "column_assignee": "Assignee",
    "status_toReview": "To review",
    "status_confirmed": "Confirmed",
    "status_correct": "Correct",
    "status_notCorrect": "Not correct",
    "status_differentEntity": "Name matches a different person or company",
    "status_noLongerApplies": "No longer applies",
    "status_otherReason": "Other reason",
    "status_notReviewed": "Not reviewed",
    "action_review": "Review",
    "action_re_review": "Re-review",
    "action_comments": "Comments",
    "date_range_placeholder": "Select date range",
    "status_reviewed_by_tooltip": "Reviewed by {{userName}}",
    "status_re_review_hint_tooltip": "If this status is not correct, assign a user to re-review it.",
    "status_reviewed_by_re_review_tooltip": "Reviewed by {{userName}}. If this status is not correct, assign a user to re-review it.",
    "action_review_assigned_tooltip": "Review this Monitoring change; assigned to {{assignedUserName}}",
    "action_re_review_tooltip": "If the reviewed status is incorrect, this Monitoring log can be re-reviewed.",
    "assignee_complete": "Complete",
    "assignee_search": "Search",
    "empty_title": "No changes detected yet",
    "empty_description": "We’re monitoring customers for new Sanctions, PEP status, Adverse media, KYC activity and mandate changes. Anything we find will show up here for review.",
    "empty_customer_description": "We’re monitoring this customer for new Sanctions, PEP status, Adverse media, KYC activity and mandate changes. Anything we find will show up here for review.",
    "empty_filtered_title": "No matching monitoring events",
    "empty_filtered_description": "No monitoring events match the selected filters. Change or clear the filters to see more events.",
    "empty_date_range_description": "No monitoring events fall within the selected date range. Choose a wider date range to see more events.",
    "panel_loading": "Loading…",
    "panel_load_error": "This monitoring event could not be loaded.",
    "panel_close": "Close review panel",
    "panel_status": "Status",
    "panel_comment": "Comment",
    "panel_comment_placeholder": "Add a comment",
    "panel_back": "Back to Monitoring",
    "discard_title": "Discard this review?",
    "discard_body": "This review hasn't been submitted yet. Any changes you've made won't be saved.",
    "discard_keep_reviewing": "Keep reviewing",
    "discard_confirm": "Discard review",
    "cta_verify": "Verify",
    "cta_confirm_results": "Confirm results",
    "cta_submit_review": "Submit review",
    "cta_update_results": "Update results",
    "cta_add_comment": "Add comment",
    "status_notCorrectDifferentEntity": "Name matches a different person or company",
    "status_notCorrectNoLongerApplies": "No longer applies",
    "status_notCorrectOtherReason": "Other reason",
    "status_previousResultsStillApply": "Previous results still apply",
    "status_group_correct": "Result is correct",
    "status_group_not_correct": "Result is not correct",
    "group_desc_correct": "This status will be applied to this customer.",
    "group_desc_not_correct": "This status will be applied to this customer.",
    "group_desc_correct_warningResult": "The red results status will stay on this customer.",
    "group_desc_not_correct_warningResult": "Red results status will be removed and updated to “Verified: Results do not apply.”",
    "group_desc_correct_simple": "The result stays on this customer.",
    "group_desc_not_correct_simple": "The result will be removed from this customer.",
    "group_desc_correct_warningRemoved": "Blue no results flag stays on this customer.",
    "group_desc_not_correct_warningRemoved": "The previous red flag result was correct.",
    "menu_group_desc_correct": "This status will be applied to this customer.",
    "menu_group_desc_not_correct": "This status will be applied to this customer.",
    "menu_group_desc_correct_warningResult": "Red results flag stays on this customer.",
    "menu_group_desc_not_correct_warningResult": "Red results flag is removed and will show “Verified: Results do not apply.”",
    "previous_results_heading": "No results found",
    "previous_results_body": "These are the previous results, please verify if the new status is correct",
    "sources_question": "Are all of the sources correct?",
    "sources_mark_all": "Mark all as accurate",
    "sources_previously_reviewed_one": "1 source previously reviewed",
    "sources_previously_reviewed": "{{count}} sources previously reviewed",
    "sources_previously_reviewed_by": "These sources were reviewed by {{name}} on {{date}} and were found again.",
    "sources_accurate": "Mark this source as accurate",
    "sources_inaccurate": "Mark this source as inaccurate",
    "sources_all_rejected_hint": "Every source is marked inaccurate. If the result itself is wrong, pick a “Result is not correct” status instead.",
    "submit_in_progress": "Submitting…",
    "sources_excluded_tooltip": "This source is not shown in the result summary because it was previously marked as not correct.",
    "undo_title": "Reopen this monitoring event?",
    "undo_body": "The completed review will be undone, the red result comes back and the event returns to the review list. Your comment explains why.",
    "undo_cancel": "Cancel",
    "undo_confirm": "Reopen event",
    "review_tooltip": "Review this Monitoring change",
    "status_not_reviewed_tooltip": "This monitoring event was not reviewed before a new status was found.",
    "comments_title": "Comments",
    "comments_empty_title": "No comments yet",
    "status_placeholder": "Select a status",
    "status_hint_toReview": "The completed review is undone and the event returns to the review list.",
    "status_verified_prefix": "Verified:",
    "status_results_do_not_apply": "Results do not apply.",
    "status_marking_all_accurate": "All {{accurateCount}} source(s) marked accurate — not verified yet",
    "status_marking_accurate": "{{accurateCount}} source(s) marked accurate — not verified yet",
    "status_marking_mixed": "{{accurateCount}} source(s) accurate, {{inaccurateCount}} not accurate — not verified yet",
    "status_verified_relevant": "Relevant — based on {{sourceCount}} source(s)",
    "status_verified_relevant_with_inaccurate": "Relevant — based on {{sourceCount}} source(s), {{inaccurateCount}} marked inaccurate",
    "status_reviewed_notice": "Marked as not applicable by {{userName}} on {{date}}. The original scan results are shown below.",
    "status_reviewed_notice_notCorrectDifferentEntity": "The original scan results are shown below. {{userName}} reviewed them on {{date}} and found they refer to a different person or company with the same name.",
    "status_ai_summary_notice": "AI summary generated on {{date}}, before your review. It may still refer to {{inaccurateCount}} source(s) you marked inaccurate.",
    "status_ai_summary_notice_undated": "AI summary generated before your review. It may still refer to {{inaccurateCount}} source(s) you marked inaccurate.",
    "list_match_link": "Open {{name}} on the list",
    "summary_rewrite_pending": "Updating the summary without the sources you marked inaccurate",
    "status_reviewed_by_unknown": "A reviewer",
    "status_list_reviewed_notice": "Marked as not applicable by {{userName}} on {{date}}.",
    "status_list_reviewed_notice_notCorrectDifferentEntity": "{{userName}} reviewed this on {{date}} and found the listed names refer to a different person or company.",
    "status_possible_match": "Possible match found.",
    "status_possible_match_and_relations": "Possible match found, and {{count}} linked relations also have a match.",
    "status_verified_matched_prefix": "Verified:",
    "status_matched_to": "matched to {{name}}",
    "candidates_which_customer": "Which of these is your customer?",
    "candidates_hint": "Select the version used in their official documents.",
    "candidate_exact_match": "exact match",
    "assignee_placeholder": "Select an assignee",
    "assignee_responsible_no_access_tooltip": "Not assigned: the customer’s responsible doesn’t have access to this customer. Update their access or the responsible, or assign this log manually.",
    "assignee_not_possible": "No assignee possible",
    "assignee_update_error": "The assignee could not be changed. Please try again.",
    "additional_filters": "Additional filters",
    "filter_customer_min_length": "Type at least {{min}} characters to search for a customer.",
    "filter_customer_search_error": "The customers could not be searched. Please try again.",
    "superseded_notice": "Replaced by a newer event on {{date}}.",
    "superseded_notice_re_review": "This event was assigned to {{assigneeName}} for a re-review, but was replaced by a newer event on {{date}}.",
    "superseded_notice_reviewed": "Reviewed by {{reviewerName}} on {{reviewedDate}}. Replaced by a newer event on {{date}}.",
    "review_stale_title": "Your review wasn’t saved",
    "review_stale_detail": "A newer event came in for this category while you were reviewing. ",
    "review_stale_link": "Review the latest event instead"
  }
}
